import {ILanguage} from './language';
import {Utils} from "../model/Utils";
import {HiringType, TimesheetType} from "../model/common.model";
import {ApplyPortalParams} from "../model/IApplyToEmployee";
import {MyRound} from "../directives/my.round";

export class LanguageEn implements ILanguage {
    LanguageCode = 'en-ca';
    LanguageDescription = 'English/Canada';
    'day.short.1' = 'Mon';
    'day.short.2' = 'Tue';
    'day.short.3' = 'Wed';
    'day.short.4' = 'Thu';
    'day.short.5' = 'Fri';
    'day.short.6' = 'Sat';
    'day.short.7' = 'Sun';
    'month.short.1' = 'Jan';
    'month.short.2' = 'Feb';
    'month.short.3' = 'Mar';
    'month.short.4' = 'Apr';
    'month.short.5' = 'May';
    'month.short.6' = 'Jun';
    'month.short.7' = 'Jul';
    'month.short.8' = 'Aug';
    'month.short.9' = 'Sep';
    'month.short.10' = 'Oct';
    'month.short.11' = 'Nov';
    'month.short.12' = 'Dec';
    'month.1' = 'January';
    'month.2' = 'February';
    'month.3' = 'March';
    'month.4' = 'April';
    'month.5' = 'May';
    'month.6' = 'June';
    'month.7' = 'July';
    'month.8' = 'August';
    'month.9' = 'September';
    'month.10' = 'October';
    'month.11' = 'November';
    'month.12' = 'December';
    All = 'All';
    Filter = 'Filter';
    NoItems = 'No Items';
    Expand = 'Expand';
    Collapse = 'Collapse';
    PleaseSelect = 'Please Select';
    NbrSelectedOptions = '{{nbOptions}} options selected.';
  PleaseSelectUnit= 'Select Unit';
  NbrSelectedUnit = '{{nbOptions}} units selected.';
  NoUnits = 'No Unit.';
  FormatDDMMM = 'MMM DD';
  Currency = '{{v}} $';
  CurrencySymbol = '$';
  EmployeeGroups = 'Employee Groups';
  GroupManager = 'Grouping Manager';
  GroupManagerShortName= 'Manage Groups';

  FromDate = 'From';
  ToDate = 'To';


  Searching = 'Employee Search';
  YouNeedToSelectAServiceOrDepartment = 'You need to select a service or department.';
  AddNewWorkshift = 'Add a new position';
  Job = 'Choose Position';
  StartTime = 'Shift starting time';
  EndTime = 'Shift ending time';
  Validate = 'Validate';
  Cancel = 'Cancel';
  NoEmployeeSelected = 'No Employee has been selected.';
  Add = 'Add';
  SelectingEmployees = 'Selection of the Employee';
  FullName = 'Full name';
  CurrentWage = 'Current Wage';
  Availability = 'Availability';
  NoEmployeeFound = 'No employee found.';
  WorkShiftDescription = 'Workshift';
  WorkShiftOf= 'Workshift on {{refDate}}';
  WorkShift = 'Workshift';

  // Meal1Label = 'Lunch';
  // Meal2Label = 'Dinner';
  Meal1Label = 'Meal 1';
  Meal2Label = 'Meal 2';
  MealPaid = 'paid';
  Break1Label = 'Break 1';
  Break2Label = 'Break 2';

  MissingPlanning = 'You need to schedule {{qty}} employee(s) on {{dayOfWeek}}';
  TooManyPlanning = 'You should remove {{qty}} employee(s) from the schedule on {{dayOfWeek}}';

  MONDAY = 'Monday';
  TUESDAY = 'Tuesday';
  WEDNESDAY = 'Wednesday';
  THURSDAY = 'Thursday';
  FRIDAY = 'Friday';
  SATURDAY = 'Saturday';
  SUNDAY = 'Sunday';

  // Lunch = 'Lunch';
  // Supper = 'Dinner';
  Lunch = 'Meal 1';
  Supper = 'Meal 2';
  LunchIsPaid = 'paid';
  SupperIsPaid = 'paid';
  Break1 = 'Break 1';
  Break2 = 'Break 2';
  Note = 'Note';
  ThisEmployeeIsNotAvailable = '{{fn}} is not available.';
  ThisEmployeeIsNotAvailablePrecise = '{{fn}} is not available. ({{when}})';
  ThisEmployeeAlreadyScheduled= '{{fn}} is already scheduled {{fullJobDescription}}. {{when}}';
  ThisEmployeeIsNotAvailableStartEndHour = '{{fn}} is not available from {{startHour}} to {{endHour}}.';
  ThisEmployeeIsAvailableStartEndHour = '{{fn}} is available from {{startHour}} to {{endHour}}.';

  ThisEmployeeAlreadyScheduledWithDay = '{{day}}: {{fn}} is already scheduled {{fullJobDescription}}.';
  ThisEmployeeIsNotActive = '{{fn}} is not active, {{reason}} {{note}}';

  TooMuchTimeScheduled= '{{fn}} works more than what has been scheduled.';
  NotEnoughEmployeeScheduled= 'There is not enough work-time for what has been scheduled.';
  WeekOf = 'Week of ';
  TimesheetsByWeekAndEmployee = 'Timesheets by Employee';
  TimesheetsToApprove = 'Timesheets to Approve';

  'meal.punched.but.no.meal.scheduled' = 'A meal has been punched but none was scheduled.';
  'diff.between.meal.punched.and.scheduled' = 'Punched duration {{punched}} is different than the scheduled duration {{scheduled}}.';
  'pause.is.mandatory'= 'A break is mandatory.';
  'pause.duration.is.different' = 'The normal break duration is {{duration}}.';
  'pause.duration.is.greater' = 'Break duration is longer that the normal break duration {{duration}}.';
  'no.punched.start.time' = 'No punch at shift start.';
  'no.punched.end.time'= 'No punch at shift end.';
  'start.time.equals.end.time' = 'Start time and end time are equal.';
  'no.sick.days.found' = 'No sick day is allowed.';
  'no.enough.minutes.left' = 'Not enough balance left ( {{left}} HH:MM) for paid sick leave.';
  'no.family.days.found' = 'Not family days bank.';
  'no.enough.unpaid.family.days.left' = 'Not enough unpaid family days left.';
  'no.enough.paid.family.days.left' = 'Not enough paid family days left.';
  'no.punch.found'= 'No punch found.';
  'no.start.shift.punch.found'= 'No punch for shift start.';
  'real.start.different.punch.start' = 'The real start time is different than the punched ( {{punched}} ) start time. ';
  'no.end.shift.punch.found' = 'No punch for shift end.';
  'real.end.different.punch.end' =  'The real end time is different than the punched ( {{punched}} ) end time. ';
  'no.meal.scheduled' = 'No meal has been scheduled.';
  'diff.between.meal.saved.and.scheduled' = 'The duration of the meal {{saved}} is different than the scheduled duration {{scheduled}}'


  TimeBankGlobal = 'Time Bank (Hours:Minutes)';
  Begin = 'Start of Week';
  Current = 'Current Week';
  SickDays = 'Allowed Sick Days (Hours:Minutes)';
  Vacation = 'Vacation';
  DatePeriod = 'From {{from}} to {{to}}';
  EmployeeSummary = 'Summary';
  HoursApproved = 'Approved';
  HoursBanked = 'Banked';

  TimeBankUsage = 'Add to Bank';
  Hours = 'Hours';
  Amount = 'Amount';
  Regular = 'Regular';
  WorkedHours=  'Hrs. Worked';
  TraineeshipHours= 'Shadowing';
  TrainingHours= 'Training';
  PaidHrs = 'Paid';

  PaidLeavesHours = 'Paid Absence';
  SubTotal= 'Sub-total';
  Holidays = 'Stat. Holidays';
  Vacations = 'Vacation';
  NoVacations = 'No Vacation';

  DoYouReallyWantToDeleteTheseVacations='Do you want to delete those Vacations?';
  DoYouReallyWantToRemoveAllAccessToThisUnit  = 'Do you want to delete all access to this unit?';
  RemoveAllEmployeeAccessToUnit='Delete all access to this division and its sub-units.';
  VacationsBalanceOrTimeBankBalanceAreNegativeDoYouWantToSaveAnyway='The Balance of the Time Bank <b>OR</b> the Balance of Vacation is negative.<br> You might have some issues when importing in your Payroll System.<br><br> Do you want to continue and save?';

  TimeBank = 'Time Bank';

  Solde_Balance='Balance';

  TRAVAIL= 'Work';
  ENTRAINEMENT= 'Shadowing';
  FERIE= 'Stat. Holiday';
  CONGE_AVEC_SOLDE= 'Time Off (Paid)';
  CONGE_SANS_SOLDE = 'Time Off (Unpaid)';
  SICK_LEAVE_PAID = 'Sick Day (Paid)';
  SICK_LEAVE_UNPAID = 'Sick Day (Unpaid)';

  BEREAVEMENT_LEAVE_PAID = 'Bereavement Leave (Paid)';
  BEREAVEMENT_LEAVE_UNPAID = 'Bereavement Leave (Unpaid)';
  FAMILY_LEAVE_PAID = 'Family Leave (Paid)';
  FAMILY_LEAVE_UNPAID = 'Family Leave (Unpaid)';

  JOUR1CSST= '1st day CSST';
  ABSAUTH= 'Leave of Absence (Unpaid)';
  ABSAUTHPAYE= 'Leave of Absence (Paid)';
  ABSNONAUTH= 'Non-Authorized Absence (Unpaid)';
  ABSMALPAYE= 'Sick Leave (Paid)';
  ABSMALNONPAYE= 'Sick Leave (Unpaid)';
  ABSDECPAYE= 'Bereavement Leave (Paid)';
  ABSDECNONPAYE= 'Bereavement Leave (Unpaid)';
  ABSFAM= 'Family Leave (Unpaid)';
  ABSFAM_PAID = 'Family Leave (Paid)';
  VACANCE= 'Vacation';
  FORMATION= 'Training';
  ABSAUTHNONPAYE= 'Authorized Absence (Unpaid)';
  OTHER='Other';
  UNION_RELATED='Union';

  Employee= 'Employee';
  'Division/Job'= 'Division / Position';
  Meals= 'Meals';
  Breaks= 'Breaks';

  TimesheetType = 'Type';
  ShiftStart= 'Shift Start';
  ShiftEnd= 'Shift End';
  Meal1= 'Meal 1';
  Meal2= 'Meal 2';
  Dashboard = 'Dashboard';
  Schedules = 'Schedules';
  SchedulesPerEmployees = 'Schedules by Employee';
  Timesheets = 'Timesheets';
  TimesheetsAndExpenses = 'Approvals';
  Save = 'Save';
  Employees = 'Employees';
  Search = 'Search';
  EnterLastNameFirstName = 'Last Name or ,First Name or Blank to list all employees';
  IncludeHiddenEmployee= 'Include Hidden Employees';


  USER_ROLE_PUNCH = 'Punch';
  USER_ROLE_USER = 'Manager';
  USER_ROLE_READ_ONLY = 'Manager (Limited)';
  USER_ROLE_DEMO = 'Employee';
  USER_ROLE_EXECUTIVE = 'Admin. (Limited)';
  USER_ROLE_ADMIN = 'Administrator';
  USER_ROLE_SYS_ADMIN = 'System Administrator';
  USER_ROLE_REP = 'Representative';
  USER_ROLE_NO_ROLE = 'No Role';


  LastName = 'Last Name';
  FirstName = 'First Name';
  Matricule = 'Employee Number';
  Username = 'Username';
  UserRole = 'User Type';

  age = '{{age}} years old';

  EmployeeDetail = 'Employee Information';
  lastName = 'Last Name';
  firstName = 'First Name';
  bdate = 'D.O.B';
  address = 'Address';
  city = 'City';
  nas = 'Social Security Number';
  country = 'Country';
  provState = 'Province';
  postalCode = 'Postal Code';
  tel1 = 'Primary Phone';
  tel2 = 'Secondary Phone';
  telCell = 'Cell. Phone';
  email = 'Email';
  professionalEmail='Professional Email';
  telPage = 'Pager/SMS';
  pref1 = '1st Call Pref.';
  pref2 = '2nd Call Pref.';
  pref3 = '3rd Call Pref.';
  QUEBEC = 'Québec';
  TELEPHONE_PRINCIPAL = 'Primary Phone';
  TELEPHONE_SECONDAIRE = 'Secondary Phone';
  CELLULAIRE = 'Cell Phone';
  EMAIL = 'Email';
  PROFESSIONAL_EMAIL = 'Professional Email';
  PAGE = 'Pager';
  SMS = 'SMS';
  RemunerationDetail = 'Wage Modification';
  hiringSalary = 'Hiring Wage';
  originalSalary = 'Current Wage';
  currentSalary = 'Current Wage';
  calculatedSalary = 'Recalculated Wage Incorporating Modification';
  adjustDt = 'Adjustment Date';
  SalaryIncrease= 'Wage Increase';
  SalaryIncreasePercent = 'Wage Increase in %';
  SalaryDecrease = 'Wage Decrease';
  SalaryDecreasePercent = 'Wage Decrease in %';
  nextAdjustDt = 'Next Adjustment Date';
  note = 'Note';

  RemunerationAndBonus = 'Remuneration and Premiums';
  RemunerationAndCumulativeBonus = 'Remuneration and Cumulative Premiums';
  Bonus = 'Premiums';
  bonus1 = 'Premium 1';
  bonus2 = 'Premium 2';
  bonus3 = 'Premium 3';
  bonus4 = 'Premium 4';
  bonus5 = 'Premium 5';
  bonus6 = 'Premium 6';
  bonus7 = 'Premium 7';
  bonus8 = 'Premium 8';
  bonus9 = 'Premium 9';
  bonus10 = 'Premium 10';
  bonus11 = 'Premium 11';
  bonus12 = 'Premium 12';
  bonus13 = 'Premium 13';
  bonus14 = 'Premium 14';
  bonus15 = 'Premium 15';
  bonus16 = 'Premium 16';
  bonus17 = 'Premium 17';
  bonus18 = 'Premium 18';
  bonus19 = 'Premium 19';
  bonus20 = 'Premium 20';
  Adjustment = 'Adjustment';
  Percentage = 'Adjustment %';
  Responsable = 'Responsible';
  RemunerationDetails = 'Remuneration Adjustments';
  NoRemunerationDetails='No Adjustments';


  EMBAUCHE = 'Hiring';
  DEPART = 'Termination';
  ARRET_TRAVAIL = 'Work Stoppage';
  RETOUR_TRAVAIL = 'Return to Work';
  'A_MANQUE_TRAVAIL' = 'A - Work Shortage' ;
  'B_GREVE_LOCKOUT' = 'B - Strike or Lock-out';
  'C_RETOUR_ETUDES' = 'C - Return to School';
  'D_MALADIE_BLESS' = 'D - Illness or Injury';
  'E_DEPART_VOLONTAIRE'= 'E - Voluntary Departure';
  'F_GROSSESSE_PAR'= 'F - Maternity';
  'G_RETRAITE'= 'G - Pension';
  'H_TRAVAIL_PARTAGE'= 'H - Shared Work';
  'J_FORMATION' = 'J - Training';
  'K_AUTRE' = 'K - Other';
  'M_CONGEDIEMENT' = 'M - Dismissal';
  'N_CONGE_SANS_SOLDE' = 'N - Leave Without Pay';
  'P_PARENTAL' = 'P - Parental';
  'Z_COMPASSION' = 'Z - Compassionate Care Leave';


  Inactive = 'Inactive';
  Active = 'Active';
  Terminated = 'Terminated';
  matricule = 'Employee Number';
  currentHiringStatus = 'Status';
  hiringStatus = 'Position Type';
  scheduleStatus = 'Schedule Type';
  HiringInformation = 'Hiring Information';
  HiringDetails = 'Details';
  type = 'Type';
  CONTRACTUEL = 'Contractor';
  PERMANENT = 'Permanent';
  PROBATION = 'Probation';
  STAGIAIRE = 'Intern';
  SUBVENTIONNE = 'Subsidized';
  TEMPORAIRE = 'Temporary';
  OCCASIONNEL = 'Occasional';
  TEMPORAIRE80 = 'Temporary (80 days and more)';
  SUR_APPEL = 'On Call';
  TEMPS_COMPLET = 'Full time';
  TEMPS_PARTIEL = 'Part time';
  HiringDetail = 'Hiring Detail';
  eventDt = 'Date';
  reason = 'Cause';
  endOfContract = 'End of Contract';
  backToWorkDate = 'Planned Return Date';
  NoHiringInformation = 'You must hire this person.';

  StartDate = 'Start Date';
  EndDate = 'End Date';
  AllowedInMinutes = 'Available (min.)';
  UsedInMinutes = 'Used (min.)';
  BalanceInMinutes = 'Balance (HH:MM)';
  SickDaysAllowed = 'Allowed Duration (HH:MM)';
  EmployeeSickDays = 'Sick Leave';
  AbsencesInformation = 'Sick Leave and Vacation';
  AbsencesInformationAndBankType = 'Sick Leave, Vacation and Custom Time Banks';

  SickDaysTitle = 'Sick Leave';
  NoSickDays ='No Sick Leave';
  DoYouReallyWantToDeleteThisSickDays='Do you really want to delete those \'Sick Leave\'?';
  PeriodStart = 'Period Start';
  PeriodEnd = 'Period End';
  AllowedVacation = 'Indemnity %';
  DaysAvailable = 'Nb Days Available';

  'ca.QC' = 'Québec';
  'ca.ON' = 'Ontario';
  'ca.AB' = 'Alberta';
  'ca.BC' = 'British Columbia';
  'ca.MB' = 'Manitoba';
  'ca.NB' = 'New Brunswick';

  AllowanceGrantedShouldBe = 'Indemnity should be {{p}}%.';
  GrantedVacationDaysShouldBe = 'The number of available days is {{should}} :  (accumulated during last period \'{{won}}\') MINUS' +
    ' (anticipated during last period \'{{prevAhead}}\') PLUS (deferred from the previous period \'{{prevDeferred}}\')' +
    ' MINUS (anticipated during this period \'{{currentAhead}}\') PLUS (deferred from this period to the next \'{{currentDeferred}}\')';

  Seniority = 'Seniority';
  WorkCodeFrom = 'Labor Law Jurisdiction (Payroll)';
  AllowanceGranted = 'Indemnity';
  PeriodStartGranted = 'Allowed No. of Days';
  PeriodStartAhead = 'Anticipated Days';
  PeriodStartDeferred = 'Deferred Days';
  BadgeWillBeGenerated = 'The badge number will be generated after you have saved.';

  PunchAndPortalParameters = 'Punch, Web and Mobile Parameters';
  UserParameter = 'User Parameters';
  UserName = 'Username';
  Password = 'Password';
  PunchParameter = 'Punch Parameters';
  BDateIsVisibleOnPunch = 'Display Birthday on Punch';
  ContactsVisibleOnPunch = 'Display Contacts on Punch';
  ScheduleVisibleOnPunch = 'Display Schedule on Punch';
  TakePhotoOnPunch = 'Take photo';
  PortalParameter = 'Web and Mobile Applications';
  ShowPersonalInfosOnPortal = 'Display Personal Information';
  ShowBanksOnPortal = 'Display Employee\'s Banks';
  ShowClassicTimeBankOnPortal='Display Time Bank';
  ShowSickDaysBankOnPortal='Display Sick Days Bank';
  ShowPersonalScheduleOnPortal = 'Display Personal Schedule';
  ShowGeneralScheduleOnPortal = 'Display General Schedule';
  ShowGeneralScheduleOnPortalWithSamePosition='Only Schedules with the Same Positions';
  ShowTimesheetsOnPortal = 'Display Timesheets';
  ShowMessagesOnPortal = 'Display Messages';
  ShowAttendance='Display Attendance';
  ShowAbsence='Display Absence';

  EmployeeContactsList = 'Emergency Contacts';
  EmployeeContactTitle = 'Employee\'s Contact in case of Emergency';
  AddContact='Add Contact';
  Firstname = 'Firstname';
  Lastname = 'Lastname';
  ContactType = 'Type';
  HomePhone = 'Home';
  OfficePhone = 'Office';
  CellPhone = 'Cell';
  BonusPerJob = 'Premium for the position ($/h)';
  BonusPerJobInPercent = 'Premium for the position (% of $/h)';
  Level = 'Level';
  LevelShort = 'Level';
  EmployeeJobIsActive = 'The position is active for this employee.';
  Department = 'Department';
  SubDepartment = 'Sub-department';
  Service = 'Service';
  JobInformation = 'Position';
  EmployeeJobInformation = 'Information about the position';
  JobLevel = 'Level';
  JobBonus = 'Premium ($/h)';
  DB_STATUS_ACTIVE = 'Active';
  DB_STATUS_INACTIVE = 'Inactive';
  ThisIsTheDefaultJobForTheEmployee = 'Default Position for this employee.';
  Default = 'Default';
  Status= 'Status';
  EmployeeJobList = 'List of Employee\'s Position';
  PlanningManager = 'Plan Manager';
  PlanningManagerShort = 'Manage Plans';

  Planning = 'Plans';
  NoJobsPlannedUseAdd = 'No Shift added for {{d}}.';
  AddPlanningDetail = 'Add Positions';
  Monday = 'Monday';
  Tuesday = 'Tuesday';
  Wednesday = 'Wednesday';
  Thursday = 'Thursday';
  Friday = 'Friday';
  Saturday = 'Saturday';
  Sunday = 'Sunday';

  HowManyJob = 'Number of Positions';
  JobLabel = 'Position';
  NbJobs = 'Quantity';
  Schedule = 'Schedule';
  EditPlanningAggregation = 'Plan Details';
  PlanningName = 'Plan name';
  UsersWithAccess = 'Users allowed to use this plan';
  Users = 'Users';
  EditPlanningDetail = 'Plan Details Modification';
  EditPlanningUser = 'Select a User';
  AddAPlan = 'Add a new Plan';
  PlanningNotes = 'Notes';
  PlanningCreatedBy = 'Plan Creator';
  Validable = 'Validation Active';
  CreateAPlanningToUseTheScheduling= 'Creating a plan allows you to first determine what work shifts you need and when. Using this plan allows you then to select employees who are available to fulfill your needs.';

  HasMoreJobs = 'Employee has more positions.';
  EmployeeWontBeExportedInThePaySystem = 'Employee will not be included in export to the payroll service.';
  ToStartProcessingYourBatchWeNeedAnEmailAddress = 'To start the batch (ref. {{batchId}}), you must add an email to receive notifications.';
  NbLineToBeRead = ' {{nbObjects}} lines will be read from the uploaded file. You will be notified by email about errors and successes. ';
  SaveBatchEmail = 'Start the batch';
  EmailToUpdateWhenBatchIsDone='Notification\'s email';
  BatchErrorOnWholeLine = 'We were expecting {{expectedNbOfFields}} elements, we read {{actualNbOfFields}} elements.';
  BatchErrorOnField= 'The element \'{{fieldName}}\' at index {{fieldIndex}} contains \'{{valueRead}}\' and the following was expected \'{{expectedFormat}}\'';
  String = 'String';
  FormatErrorWithFormat= 'An element \'{{fieldName}}\' of type \'{{fieldType}}\' according to the format or with the following values \'{{expectedFormat}}\'.';
  FormatError= 'An element \'{{fieldName}}\' of type \'{{fieldType}}\'.';

  EmployeeParameters='Work Parameters';

  EmployeeWillBeExportedInThePaySystem='Employee will be included in export to payroll service.';
  Enterprise = 'Enterprise';

  EmployeeSchedule='Schedule';
  EmployeeTimesheet='Timesheet';
  EmployeeExport='Export';

  SubjectToApprovalByAManager='The following requests will have to be approved by a manager.';
  EmployeeCanModifyItsAvailability='Employee can submit availability modifications (subject to approval).';
  EmployeeCanRequestForVacation= 'Employee can submit vacation requests (subject to approval).';
  EmployeeCanExchangeShift = 'Employee can submit shift replacement requests to other employees (subject to approval).';


  SortingOrder='Sort Order';

  GraceStartBefore='Grace (Before Shift Start)';
  RoundingStartBefore='Rounding';
  RoundingStartBeforeMode='Rounding Type';

  GraceStartAfter='Grace (After Shift Start)';
  RoundingStartAfter='Rounding';
  RoundingStartAfterMode='Rounding Type';

  GraceEndBefore='Grace (Before Shift End)';
  RoundingEndBefore='Rounding';
  RoundingEndBeforeMode='Rounding Type';

  GraceEndAfter='Grace (After Shift End)';
  RoundingEndAfter='Rounding';
  RoundingEndAfterMode='Rounding Type';

  GraceMealShorter='Grace (Shorter Meal)';
  GraceMealLonger='Grace (Longer Meal)';
  RoundingMeal='Rounding';
  RoundingMealMode='Rounding Type';

  GraceBreak='Grace (Breaks)';
  RoundingBreak='Rounding';
  RoundingBreakMode='Rounding Type';


  RoundingStartNoSchedule='Rounding Arrival (No Schedule)';
  RoundingStartNoScheduleMode='Rounding Type';
  RoundingEndNoSchedule='Rounding Leaving (No Schedule)';
  RoundingEndNoScheduleMode='Rounding Type';

  BreakDuration = 'Break Default Duration';
  MealDuration = 'Meal Default Duration';
  HolidayCalculationType = 'Stat. Holiday Calculation Method';
  HolidayMinutes='Quantity (HH:MM)';
  HolidayMinutesDuration = 'Minutes';
  HolidayAlternateExportCode='Alternate Payroll Code';
  UseHolidayAlternateExportCode='Use Alternate Payroll Code';
  HolidayMaxMinutes = 'Maximum Nb of Minutes';


  FamilyDaysCalculationType = 'Family Days Calculation Method';
  FamilyDaysMinutesDuration='Quantity (HH:MM)';
  FamilyDaysAlternateExportCode='Alternate Payroll Code';
  UseFamilyDaysAlternateExportCode='Use Alternate Payroll Code';
  FamilyDaysMaxMinutes='Maximum Nb of Minutes';


  HOLIDAY_CALCULATION_TYPE_1 = '1/10 (Last Pay)';

  HOLIDAY_CALCULATION_TYPE_3 = '1/16 (4 weeks)';
  HOLIDAY_CALCULATION_TYPE_2 = '1/20 (4 weeks)';
  HOLIDAY_CALCULATION_TYPE_6 = '1/60 (12 weeks)';
  HOLIDAY_CALCULATION_TYPE_S = 'Fixed';
  HOLIDAY_CALCULATION_TYPE_ONTARIO_2018 = 'Ontario (2018)';
  HOLIDAY_CALCULATION_TYPE_NOVA_SCOTIA='Nova Scotia';
  HOLIDAY_CALCULATION_TYPE_ONE_20_4_PAY_W_BANKS = '1/20 (4 weeks) + Banks';
  HOLIDAY_CALCULATION_TYPE_BRITISH_COLUMBIA = 'British-Columbia';
  HOLIDAY_CALCULATION_TYPE_ALBERTA = 'Alberta';
  HOLIDAY_CALCULATION_TYPE_PEI = 'P.E.I.';
  HOLIDAY_CALCULATION_TYPE_NEW_BRUNSWICK = 'New-Brunswick';
  HOLIDAY_CALCULATION_TYPE_NEWFOUNDLAND = 'NewFoundland';
  HOLIDAY_CALCULATION_TYPE_NUNAVUT = 'Nunavut';
  HOLIDAY_CALCULATION_TYPE_YUKON = 'Yukon';
  HOLIDAY_CALCULATION_TYPE_ONTARIO = 'Ontario';
  HOLIDAY_CALCULATION_TYPE_CALC_FROM_LAST_PAY='Based only on last Pay';
  HOLIDAY_CALCULATION_TYPE_CALC_4_WEEKS_PAY='1/20 (4 weeks) - Pay'
  HOLIDAY_CALCULATION_TYPE_ONE_12_4_WEEK_3DAY='1/12 (4 weeks)';
  HOLIDAY_CALCULATION_TYPE_MANITOBA = 'Manitoba';

  MealDurationType= 'Meal Duration (Source)';
  MEAL_DURATION_TYPE_PUNCH_DURATION = 'Punch';
  MEAL_DURATION_TYPE_DEFAULT_DURATION = 'Default Duration';

  HORAIRE_ROUNDING_MODE_UP = 'Greater';
  HORAIRE_ROUNDING_MODE_DOWN = 'Smaller';
  HORAIRE_ROUNDING_MODE_HALF_UP = 'Closest';
  BreaksArePaidEvenWhenNotScheduled = 'Breaks will be paid even if not scheduled. Time punched in excess of the default break duration will be deducted from hours worked.';


  EmployeeWillBeExported='Employee\'s file will be included in export';
  JobStatus = 'Position\'s Status';
  JOB_STATUS_1 ='Regular Rate';
  JOB_STATUS_2 ='Reduced Rate';
  UsableWage = 'Usable Rate';
  USABLE_WAGE_1 = 'Manual';
  USABLE_WAGE_2 = 'Remuneration';
  USABLE_WAGE_3 = 'Period\'s Salary';
  PaymentMethod = 'Payment Mode';
  PayProvince = 'Pay Province';
  BankId = 'Bank ID';
  BankTransit = 'Transit';
  BankAccount= 'Account Number';
  FederalExemptionType = 'Base Exemption (Federal)';

  BASE_FEDERAL_EXEMPTION_1= 'Base Amount';
  BASE_FEDERAL_EXEMPTION_2 = 'No Tax';
  BASE_FEDERAL_EXEMPTION_3 = 'No Exemption';
  BASE_PROVINCE_EXEMPTION_1 = 'Base Amount (QC)';
  BASE_PROVINCE_EXEMPTION_2 = 'No Tax (QC)';
  BASE_PROVINCE_EXEMPTION_3 = 'No Exemption (QC)';
  BASE_PROVINCE_EXEMPTION_4 = 'Base Amount';
  BASE_PROVINCE_EXEMPTION_5 = 'No Tax';
  BASE_PROVINCE_EXEMPTION_6 = 'No Exemption';


  ProvincialExemptionType = 'Base Exemption (Provincial)';
  Function='Function';
  Classe='Class';
  Workgroup = 'Workgroup';
  HourPerPay = 'Hours per Pay';
  DisplayPayCode = 'Salary Display (Code)';
  EmployeeHasAFixedPay='Employee has a fixed Pay';

  NoDocumentsAttached = 'No attached file.';
  DocumentsAttached = '{{nb}} attached file(s)';

  DAY_TYPE_MONDAY = 'Monday';
  DAY_TYPE_MONDAY_SHORT = 'Mo';
  DAY_TYPE_TUESDAY = 'Tuesday';
  DAY_TYPE_TUESDAY_SHORT = 'Tu';
  DAY_TYPE_WEDNESDAY = 'Wednesday';
  DAY_TYPE_WEDNESDAY_SHORT = 'We';
  DAY_TYPE_THURSDAY = 'Thursday';
  DAY_TYPE_THURSDAY_SHORT = 'Th';
  DAY_TYPE_FRIDAY = 'Friday';
  DAY_TYPE_FRIDAY_SHORT = 'Fr';
  DAY_TYPE_SATURDAY = 'Saturday';
  DAY_TYPE_SATURDAY_SHORT = 'Sa';
  DAY_TYPE_SUNDAY = 'Sunday';
  DAY_TYPE_SUNDAY_SHORT = 'Su';
  EMPLOYEE_AVAILABLE = 'Available';
  EMPLOYEE_NOT_AVAILABLE = 'Not Available';
  EmployeeAvailabilitiesList = 'Employee\'s Availability';
  AvailabilitiesOfTheEmployee = 'Employee\'s Availability';
  SpecialDatesWhenTheEmployeeIsNotAvailable = 'Employee\'s Unavailability for Specific Dates';
  ActiveStartingDate = 'Date Effective';
  RefDateNotAvailable = 'Date';
  StartTimeEndTimeAvailability = 'Available from (HH:MM) - to (HH:MM)';
  EditEmployeeAvailabilityAndDetails = 'Modification of Employee Availability';
  activeStartingDate='Date Effective';
  Remove='Delete';
  AllDay = 'All Day';
  StartTimeEndTimeUnAvailability= 'Unavailable from (HH:MM) - to (HH:MM)';
  EditEmployeeAvailabilitySpecial= 'Temporary Unavailability for an Employee';
  refDateUnavailability = 'Unavailable Date';
  FileName = 'Document';
  FileUploadedBy = 'By';
  AddDocumentToSign='Add Document to Sign';
  EditEmployeeDocument = 'Employee\'s Associated Document';
  ChooseFile = 'Select the file to associate.';
  ChosenFile = 'Selected File:';
  EmployeeCanSeeTheFile = 'Employee can see the document';
  NoDefaultJob = 'No Default Position';
  HasNoActiveJobs = 'No Active Position';
  Close = 'Close';
  JobString = 'Position';
  PAYMENT_MODE_1 = 'Check';
  PAYMENT_MODE_2 = 'Deposit';
  PAYMENT_MODE_3 = 'Memo';
  ALBERTA = 'Alberta';
  BRITISH_COLUMBIA = 'British Columbia';
  MANITOBA = 'Manitoba';
  NEW_BRUNSWICK = 'New Brunswick';
  NEWFOUNDLAND = 'Newfoundland';
  NOVA_SCOTIA = 'Nova Scotia';
  PEI = 'Prince Edward Island';
  SASKATCHEWAN = 'Saskatchewan';
  ONTARIO = 'Ontario';
  NUNAVUT='Nunavut';
  NORTHERN_TERRITORY = 'Northwest Territories';
  YUKON='Yukon';
  EmployeeDocumentList = 'Employee\'s Documents List';
  refDate = 'Reference Date';
  EmployeeInactive = 'Employee Not Active';
  sex = 'Gender';
  MALE = 'Male';
  FEMALE = 'Female';
  FRANCAIS = 'French';
  ENGLISH = 'English';
  OnlineTraining = 'Online training';
  EnterPunchName = 'Enter the punch name to search';
  NoPunchFound = 'No Punch Found';
  PunchName = 'Punch Name';
  DeviceId = 'Device Id';
  Remuneration = 'Remuneration';
  EmployeeVacation = 'Employee Vacation';
  NewEmployee = 'New Employee';
  EmployeeFound = '{{nb}} employees found';
  EmployeePunchIsNotActive = 'The employee can\'t punch.';
  CopyTo = 'Copy to';
  PlanningIsActive = 'The plan is active.';
  days = 'day(s)';
  NoEmergenciesContacts = 'No Emergency Contacts';
  AddAvailabilitiesForTheEmployee = 'The employee has no availabilities';
  QuestionTitle= 'Question';
  DoYouReallyWantToDelete = 'Do you really want to delete your selection?';
  ServiceDepartement = 'Service, Department';
  TooManyScheduleForThisDay = 'Too many employees selected. Only {nbPlanned} were planned.';
  NotAvailable = 'Not Available';
  Available = 'Available';
  PlannedPostes = 'Planned Shifts';
  EmployeeHasAlreadyAShift = 'Employee {{fullName}} already has a shift on {{refDate}}.';
  EmployeeHasAlreadyAShiftHours = 'Employee {{fullName}} already has a shift from {{startDate}} to {{endDate}}.';

  SeniorityInDays = 'Seniority (days)';
  SeniorityInDaysShort= 'Senior. (days)';

  DoYouWantToNotifyYourEmployeesAboutTheChangeInTheirSchedule = 'Do you want to notify employees about schedule changes?';
  DoYouWantToNotifyYourEmployeesAboutTheChangeInTheirScheduleAndSomeShiftToBeFilled = 'Do you want to notify employees about schedule changes and about available shifts?';
  DoYouWantToNotifyYourEmployeesAboutSomeShiftToBeFilled = 'Do you want to notify employees about the available shifts?';

  ScheduleIsPublished = 'The shift is published. (Visible to employee)';
  EmployeeIsVisible = 'The employee is visible.';
  EmployeeIsHidden = 'The employee is not visible.';
  NoSchedulePlannedForThisDay = 'No shift was planned.';
  HasUnpublishedSchedules = 'Some shifts are not published.';
  ScheduleType = 'Type';
  HORARIUS_LOCALE_fr_CA = 'French (Canada)';
  HORARIUS_LOCALE_en_CA = 'English (Canada)';
  HORARIUS_LOCALE_es = 'Spanish';

  HORARIUS_TZ_CA_EASTERN = 'Canada/Est';
  HORARIUS_TZ_CA_ATLANTIC = 'Canada/Atlantique';
  HORARIUS_TZ_CA_CENTRAL = 'Canada/Central';
  HORARIUS_TZ_CA_MOUNTAIN = 'Canada/Montagne';
  HORARIUS_TZ_CA_PACIFIC = 'Canada/Pacifique'
  HORARIUS_TZ_CENTRAL_EUROPEAN = 'Europe/Central';
  HORARIUS_TZ_EUROPE_MOSCOW='Europe/Moscow';
  HORARIUS_TZ_CA_YUKON = 'Canada/Yukon';
  HORARIUS_TZ_CA_EAST_SASKATCHEWAN = 'Canada/East-Saskatchewan';
  HORARIUS_TZ_CA_SASKATCHEWAN = 'Canada/Saskatchewan';
  HORARIUS_TZ_CA_NEWFOUNDLAND = 'Canada/Newfoundland';
  HORARIUS_TZ_WEST_AFRICA='West Africa';

  CA_EASTERN = 'Canada/Est';
  CA_ATLANTIC = 'Canada/Atlantique';
  CA_CENTRAL = 'Canada/Central';
  CA_MOUNTAIN = 'Canada/Montagne';
  CA_PACIFIC = 'Canada/Pacifique'
  CENTRAL_EUROPEAN = 'Europe/Central';
  EUROPE_MOSCOW='Europe/Moscow';
  CA_YUKON = 'Canada/Yukon';
  CA_EAST_SASKATCHEWAN = 'Canada/East-Saskatchewan';
  CA_SASKATCHEWAN = 'Canada/Saskatchewan';
  CA_NEWFOUNDLAND = 'Canada/Newfoundland';
  WEST_AFRICA = 'West Africa';

  MealWasScheduled = 'scheduled from {{start}} to {{end}}';
  MealWasNotScheduled = 'not scheduled';
  AccountedMealDuration = 'Duration (HR:MIN)';
  BreakWasScheduled = 'scheduled for {{start}}.';
  BreakNotScheduled = 'not scheduled.';
  AccountedBreakDuration = 'Duration (HR:MIN)';
  AccountedBreakDurationToBeRemoved  = 'Time subtracted from hours worked (HR:MIN)';
  AccountedMealDurationToBeRemoved = 'Time subtracted from hours worked (HR:MIN)';
  ShiftWasScheduled = 'scheduled for {{start}}.';
  ShiftNotScheduled = 'not scheduled.';
  ShiftEndWasScheduled = 'scheduled for {{start}}.';
  ShiftEndNotScheduled = 'not scheduled.';



  PunchedShiftStart = 'Punched';
  AccountedShiftStart= 'Used by Pay';
  AdjustedPunchedShiftStart = 'Rounded';
  PunchedShiftEnd = 'Punched';
  AccountedShiftEnd = 'Used by Pay';
  AdjustedPunchedShiftEnd = 'Rounded';

  EmployeeDescription = 'Employee';
  UnFoldAll = 'Unfold All';
  FoldAll = 'Fold All';
  AddEditWorkshift = 'Work Shifts';
  EditWorkshift = 'Modify';
  AddWorkshift = 'Add';
  ModifyWorkshift = 'Modify';


  NoDataFound = 'No data found.'
  DisplaySchedulePerDay = 'Alternate display of the daily schedule.';
  PlanningCanBeValidated = 'Automatic Validation';
  WarnWhenMoreTimeIsScheduled = 'Warn when too many schedules';
  WeeklyMinimum = 'Weekly Minimum Hours Worked (0 => none)';
  WeeklyMaximum = 'Weekly Maximum Hours Worked (0 => none)';
  PlanningValidation = 'Plan(s) Validation';
  EmployeeScheduleValidation = 'Employee Schedule Validations';
  PLANNING_ERROR_TYPE_MORE_THAN_PLANNED = 'Too Many';
  PLANNING_ERROR_TYPE_LESS_THAN_PLANNED = 'Not Enough';
  PLANNING_ERROR_TYPE_NONE = 'N/A';
  EMPLOYEE_ERROR_TYPE_SCHEDULE = 'Schedule';
  EMPLOYEE_ERROR_TYPE_AVAILABILITY = 'Avail.';
  EMPLOYEE_ERROR_TYPE_OVERTIME_BY_LAW = 'Overtime';
  EMPLOYEE_ERROR_TYPE_MORE_THAN_EXPECTED = 'Too many hours';
  EMPLOYEE_ERROR_TYPE_LESS_THAN_EXPECTED = 'Too few hours';
  EMPLOYEE_ERROR_TYPE_NONE = 'N/A';

  WowAllVerificationsWorked = 'Wow! Everything is perfect.';
  ErrorMessage = 'Description';
  'employees.with.job.and.unit' = 'Employees working as \'{{job}}\' in unit \'{{unit}}\' ';
  ShowAllSchedulesByJobUnit='All the schedules for this position';
  ShowAllSchedulesForEmployee = 'All the schedules for this employee';
  ShowAllSchedulesForEmployeeNamed = 'All the schedules for {{employee}}';

  SchedulesPlanning = 'Schedules & Plans';


  PunchInformation = 'Time Punching';
  EmployeeCanPunchWithBadge = 'Employee uses the code \'{{badge}}\'.';
  EmployeeCanPunchOnTheMobileAndWeb = 'Employee can punch with the mobile application and the web portal.';
  EmployeeCanPunchOnTheMobile  = 'Employee can punch with the mobile application.';
  EmployeeCanPunchOnTheWeb = 'Employee can punch with the web portal';
  PunchingMultipleTaskAtOnceIsPermitted='Employee can punch multiple tasks at once.';
  EmployeeIsPunching = 'Employee punches';
  EmployeeIsPunchingOntheWeb = 'Employee can punch with the web portal.';
  EmployeeIsPunchingOntheMobile = 'Employee can punch with the mobile application';


  APictureIsTakenWhenEmployeeIsPunching = 'A photo will be taken.';
  Documents = 'Documents';
  AllHiringInformation = 'Hiring information';
  HiringStatus = 'Status';
  EmployeeJob = 'Position(s)';
  TimeInBank = 'Banked Time';
  SickDaysUsed_SickDaysLeft = 'Other Banks (balance)';
  VacationLeft = 'Vacation\'s Days left';
  Availabilities = 'Work Availability';
  ParametersInformation = 'Parameters';
  WebAndMobileAccess = 'Mobile and Web Access';
  ExportInThePaySystem = 'Export to the Payroll Service';

  CopyWorkshift='Copy Schedules';
  NoticeCopyWorkshift='Warning: The selected schedules will be added to the information already available in the following weeks (if any).';
  NoticeCopyWorkshiftScheduleTypes = 'Warning: Only schedules of with the types selected below will be copied.';

  WeekFrom= 'Week from ';
  WeekTo = 'to';
  PeriodFrom= 'Period from ';
  PeriodTo = 'to';
  DoYouReallyWantToDeleteTheWorkshift = 'Do you really want to delete the current schedules? ';
  inboxMessage = 'Messages'

  ExplanationOfMemos = 'Internal messages improve communications between managers and employees by centralizing and keeping track of communications. You can create messages to one or more employees and they can be displayed on the APP and/or on the Punch when they login. You can put an expiration date, and know if they have been read or deleted. However, the communications are not emails. They are managed internally.';
  Inbox = 'Inbox';
  SentMessages = 'Sent Messages';
  NewWorkShift = 'Work Shift needs filling';
  NewPlainMessage = 'New';
  PlainMessage = 'Message';
  Recipients = 'Recipient(s)';
  ExpiryDate = 'Expiry Date';
  title = 'Title';
  content = 'Body'
  NoMessageReceived = 'No message has been received.';
  NoMessageSent = 'No message has been sent.';
  Error = 'Error';
  'Schedule.is.overlapping' = 'The Work Shift is already used.'
  YouCantSeeThePasswordWithYourUserLevel = 'Sorry, you can\'t see it with your user level.';
  OtherEmployeesParameters = 'Work Parameters';
  EmployeeHasNotThisJob = '{{employee}} doesn\'t have the position {{job}} in the unit {{unit}}.';
  MEMO_INFO_TYPE_WORK_SHIFT = 'Work Shift';
  MEMO_INFO_TYPE_REQUEST_VACATION = 'Vacation Request';
  MEMO_INFO_TYPE_PLAIN='Text';
  MEMO_INFO_TYPE_WORK_SHIFT_EXCHANGE='Shift Replacement';
  MEMO_INFO_TYPE_AVAILABILITIES_SE='Special Availability';
  MEMO_INFO_TYPE_AVAILABILITIES_PERIODIC='Periodic Availabilities';

  MEMO_EMP_STATUS_READ='Memo Read';
  MEMO_EMP_STATUS_SEEN='Memo Seen';
  MEMO_EMP_STATUS_SEEN_PUNCH='Memo Seen on Punch';
  MEMO_EMP_STATUS_DELETED='Memo Deleted';


  WorkShiftMessage = 'Missing Work Shift';
  EmployeeAppliedOnWorkshiftRequest='<span style="font-size:larger; font-weight: 600;">{{employee}}</span> is applying for the Work Shift as <span style="font-size:larger; font-weight: 600;">{{job}}</span> <span class=muted>({{unit}})</span> on {{eventDt}} between {{schedule}}.<div class="muted">{{note}}</div>';
  EmployeeAppliedForExchangeWorkshiftRequest='<span style="font-size:larger; font-weight: 600;">{{employee}}</span> is ready to replace <span style="font-size:larger; font-weight: 600;">{{requester}}</span> for the Work Shift by a request of the latter: <span style="font-size:larger; font-weight: 600;">{{job}}</span> <span class=muted>({{unit}})</span> on {{eventDt}} between {{schedule}}.<div class="muted">Requester\'s note: {{note}}</div>';
  EmployeeWorkshiftExchangeRequest='Your co-worker <span style="font-size:larger; font-weight: 600;">{{requester}}</span> is looking for a replacement for the Work Shift: <span style="font-size:larger; font-weight: 600;">{{job}}</span> <span class=muted>({{unit}})</span> on {{eventDt}} between {{schedule}}.';
  Accept = 'Accept';
  Reject = 'Decline';
  Apply = 'Apply';
  EmployeeRequestsSomeVacation ='<span style="font-size:larger; font-weight: 600;">{{employee}}</span> would like to take vacation from <span style="font-size:larger; font-weight: 600;">{{startDt}}</span> to <span style="font-size:larger; font-weight: 600;">{{endDt}}</span> inclusively.<div class="muted">{{note}}</div>'
  EmployeeDeletedMemo='{{employee}} deleted the message on {{date}}.';
  EmployeeSeenMemo='{{employee}} saw the message on {{date}}.';
  EmployeeSeenPunchMemo='{{employee}} saw the message on the punch on {{date}}.';
  EmployeeReadMemo='{{employee}} read the message on {{date}}.';
  EmployeeAcknowledgedMemo='{{employee}} acknowledged the message on {{date}}.';

  CantFindAttachment='Can\'t find the attachment [{{memoId}}].';
  ManagementOfThisTypeIsNotSupported='We are not supporting messages of type \'{{memoType}}\'.';
  MemoAggregation='Conversation';
  WorkshiftRequestDate='Date';
  SaveAndSend='Save and Send';
  PublishAll = 'Publish All';
  UnPublishAll = 'Unpublish All';
  MissingWorkShift = 'Missing Shift';
  Importing='Importing';
  VacationsLeft='Vacation Remaining';
  SchedulePerPlanPurpose = 'In <b>Schedules and Plans</b>. You \'load\' an existing Plan and fill your pre-determined needs with available employees. To create a new plan, select <b>Plan Manager</b>.';
  SchedulePerPlanHowToFill = '<span style="font-style: italic; font-size: smaller" class="muted">Depending on the Plan you have chosen, you must assign Work Shifts with a <i class="fa fa-certificate"></i></span>';
  'schedule.start.different.punch.start'='The shift was scheduled to start at {{scheduled}} instead of {{punched}}';
  'schedule.end.different.punch.end' ='The shift was scheduled to end at {{scheduled}} instead of {{punched}}';
  ApproveToday = 'Today';
  ApproveYesterday = 'Yesterday';
  NoTimesheetsFound = 'No Timesheets found.';
  VisibleOnPunch = 'Visible on the punch';
  DoYouReallyWantToDeleteThePlan= 'Do you really want to remove the plan \'{{plan}}\'? ';
  PayingEnterprise = 'Employee to be paid by';
  seniorityDate = 'Seniority Date';
  hiringDate = 'Hiring Date';
  CANADA = 'Canada';
  FRANCE = 'France';
  USA = 'USA';
  Reporting = 'Reports';
  parametersForReport = 'Report Parameters - {{name}}';
  CreateReport = 'Create Report';
  ReportPDF = 'Report (Pdf)';
  ReportXLS = 'Report (Excel)';
  ExportExcel = 'Export to Excel';
  NoStatusYet = 'No Status yet';


  AvailabilityForDay='<li>{{dayType}}: {{schedule}}</li>';
  AvailabilityChange='Modification will be valid starting on <span style="font-size:larger; font-weight: 600;">{{startingDt}}</span><br><ul>{{details}}</ul>';
  EmployeeRequestChangeAvailabilities='<span style="font-size:larger; font-weight: 600;">{{employee}}</span> would like to modify his/her availabilities:<br>{{data}}<br>{{noteFromApprover}}';
  EmployeeRequestChangeAvailabilitiesHeader = '{{employee}} requests changes to his/her availability beginning on {{dateDebut}}';

  EmployeeRequestSpecialAvailability='<span style="font-size:larger; font-weight: 600;">{{employee}}</span> would like you to approve a request of non-availability on <span style="font-size:larger; font-weight: 600;">{{eventDt}}</span> for {{schedule}}.<br>{{note}}<br>{{noteFromApprover}}';
  EmployeeRequestSpecialAvailabilityHeader = '{{employee}} requests a non-availability on {{eventDt}} for {{schedule}}';
  RequestCreatedOn='<span style="font-size:smaller; font-weight: 200;" class="muted">Sent on {{createdDt}}.</span>';


  Language = 'Language';
  ANGLAIS = 'English';
  ESPAGNOL='Spanish';
  EmployeeAppliedOnWorkshiftProvide='<span style="font-size:larger; font-weight: 600;">{{provider}}</span> is looking for someone for a Work Shift as <span style="font-size:larger; font-weight: 600;">{{job}}</span> <span class=muted>({{unit}})</span> on {{eventDt}} between {{schedule}}.<div class="muted">{{note}}</div>';

  Punches = 'Information From Punch';
  StartShift = 'Start of Shift';
  NoPunch = 'No Punch Information';
  EndShift = 'End of Shift';
  StartMeal1 = 'Start of Meal';
  EndMeal1 = 'End of Meal';
  StartMeal2 = 'Start of Meal';
  EndMeal2 = 'End of Meal';
  StartBreak1 = 'Start of Break';
  EndBreak1 = 'End of Break';
  StartBreak2 = 'Start of Break';
  EndBreak2 = 'End of Break';

  EmployeesPanel = 'Employees';
  PunchesPanel = 'Punches';
  UnitsPanel = 'Structures';
  EnterUnitName = 'Search units by description/name'
  JobInTheUnit = 'Positions associated with the unit';
  EmployeeWithDirectAccess = 'Employees with access to this unit';
  AddAccessToEmployees = 'Add access to employees';
  AddJobToUnit = 'Add Position';
  Templates='Templates';
  JobDescription = 'Position';
  Week = 'Week';
  AllTemplates = 'Templates for an Employee';
  firstWeekOfCycle = 'The first week starts on (Optional)';
  CurrentWeekAccordingToCycle = 'Current Week according to the cycle';
  ChooseATemplateForEmployee = 'Employee\'s Templates';
  ChooseATemplateForEmployeeNamed = '{{employee}} - Templates';
  Info='Information';
  NoTemplatesForEmployee = 'This employee has no template.';
  NoTemplatesAvailableForThisJob = 'No template available for this position.';
  PeriodStartAmountGranted = 'Indemnity Amount';
  PeriodStartAheadAmount  = 'Anticipated Amount';
  PeriodStartDeferredAmount = 'Deferred Amount';
  BackgroundColor = 'Background Color';
  ClickToChangeTheColor = 'Click to choose a different color';
  EmployeeVacationAmountIsNullOrNegative = 'Allowed amount for vacations is less than 0.';
  UserDeactivatedNoConnectionToApplications = 'Account is deactivated - no access to application.';
  UserIsActive = 'Account is Active.';
  NoWorkDataFoundSoNoDaysVerification = 'Verification is temporarily unavailable.'
  PreviousVacationHasDeferredAmount='An amount of {{amount}} from the previous vacation will be added.';
  NoPreviousVacationFoundNoDaysOfVacationAreRequired = 'No vacation History. No vacation is required.'
  NbVacationsRequiredByLaw = 'Labor Law requires {{nb}} day(s) of vacation.';
  UsedDaysInThePeriod = 'Days used (Scheduled + Taken)';
  UsedAmountInThePeriod = 'Amount Used (Taken)';
  PeriodBalance = 'Days Remaining';
  PeriodBalanceAmount = 'Amount Remaining';
  CalculatedAmountGrantedForPeriod = 'Indemnity Amount (Calculated)';
  ChooseColorTitle = 'Click on color to select';
  SelectThisWeek = 'Select This Week';

  HowManyWeeks= 'Weeks Visible';
  HowManyWeeksShort= 'Weeks Visible';
  OneWeek = '1 Week';
  TwoWeeks = '2 Weeks';
  ThreeWeeks = '3 Weeks';
  FourWeeks = '4 Weeks';
  FoldAllSchedules = 'Fold All Schedules';
  UnFoldAllSchedules = 'UnFold All Schedules';
  FoldAllTimesheets = 'Fold All Timesheets';
  UnFoldAllTimesheets = 'UnFold All Timesheets';

  VacationCantBeZero = 'No vacation available.';
  NotEnoughSickDaysLeft = 'Not enough paid sick leave left.';
  HolidayCantBeZero = 'Verify Stat. Holiday Calculation';
  EmployeeIsLate = '{{fn}} is late by {{nbMin}} min.';
  NoEmployeesAreLate = 'Everybody is on time.';
  LateEmployeesValidation = 'Attendance';
  LateMessage = 'Messages';
  Periode = 'Period';
  WageUsedInCalculation = 'Hourly wage used: ';
  Rappels='Notes';
  WageOfDefaultJobUsedInSomeCalculation= 'Hourly wage of default position: ';
  LastNote = 'Most Recent Note';
  EmployeeNoteList = 'Employee Notes';
  Manager = 'Manager';
  ModifDate = 'Last Modification';
  EmployeeNote = 'Note Regarding Employee';
  NoteVisibility = 'Note Visibility';
  DocumentVisibility= 'Document Visibility';
  NOTE_VISIBILITY_ALL = 'All';
  NOTE_VISIBILITY_ADMIN = 'Administrators';
  NOTE_VISIBILITY_PRIVATE = 'Private';

  DOCUMENT_VISIBILITY_ALL = 'All';
  DOCUMENT_VISIBILITY_ADMIN = 'Administrators';
  DOCUMENT_VISIBILITY_PRIVATE = 'Private';


  AddManualTimesheet = 'Add a Timesheet';
  AccountedBreak1Duration = 'Break1 Duration (HR:MIN)';
  AccountedBreak2Duration = 'Break2 Duration (HR:MIN)';
  AccountedMeal1Duration = 'Meal1 Duration (HR:MIN)';
  Meal1IsPaid = 'Meal1 is Paid';
  AccountedMeal2Duration = 'Meal2 Duration (HR:MIN)';
  Meal2IsPaid = 'Meal2 is Paid';
  TotalTime = 'Total (HR:MIN)';
  NoMeal1Information = 'No Meal1';
  NoMeal2Information = 'No Meal2';
  NoBreak1Information = 'No Break1';
  NoBreak2Information = 'No Break2';
  VacationDaysLeft = 'Vacations Days Remaining';
  ValueOfDayOfVacationInMinutes = '1 day is equals to ';
  AllowedTime = 'Allowed Time (HR:MIN)';
  UsedTime = 'Used Time (HR:MIN)';
  UserPreferences = 'Preferences';
  PREFS_WORKSHIFT_DEFAULT_START_TIME = 'Default Start of Shift';
  PREFS_WORKSHIFT_DEFAULT_END_TIME = 'Default End of Shift';

  PREFS_LATE_MIN_TIME = 'Display \'Late\' notifications after \'x\' minutes (minimum 15)';
  PREFS_LATE_MAX_TIME = 'Stop \'Late\' notifications after \'x\' minutes.';
  PREFS_RUN_VALIDATION_PLAN_NB_WEEK = 'Plans will be validated for \'x\' weeks in advance.';
  PREFS_RUN_VALIDATION_EMPLOYEE_NB_WEEK = 'Employees schedules will be validated for \'x\' weeks in advance.';
  PREFS_NB_WEEK_FOR_SCHEDULE = 'Default number of weeks to show in Schedules / Employees';
  PREFS_NB_DAY_FOR_TIMESHEET = 'Default number of days to display Timesheets to approve';
  PREFS_NB_DAY_FOR_EXPENSE = 'Default number of days to display Expenses to approve';

  PREFS_USE_SCHEDULE_ALIAS='Use Schedule Alias';
  PREFS_ESTABLISHMENT_DONE = 'Establishment Done';
  PREFS_USE_TIMED_TASKS = 'Project Management';
  PREFS_USE_ALTERNATE_UI = 'New Interface';
  PREFS_UI_VERSION = 'User Interface (you will need to logoff and login)';
  PREFS_SHOW_CCQ_OPTION = 'Display CCQ Options.';
  PREFS_DEFAULT_SORT_ORDER = 'Default Sort';
  PREFS_USE_UDATA_SERVICE = 'UData Service (RPA360)';
  PREFS_USE_ALLIERH_SERVICE='Folks Service';
  PREFS_USE_RETAIL_NEXT_SERVICE = 'RetailNext Service';
  PREFS_VALIDATE_OVERTIME= 'Verify Overtime';
  PREFS_INCLUDE_VACATION_IN_AMOUNT_WHEN_AVAILABLE='Include Vacation When Calculating Amounts';
  PREFS_DISPLAY_SCHEDULE_TO_FILL='Display Shifts to Fill';
  PREFS_DISPLAY_AMOUNT='Display Amounts';
  PREFS_SHOW_PARAMS_PROFILE='Show Parameters Profile';
  PREFS_DISPLAY_DAY_SALES_COST_OBJECTIVE='Show Cost Objectives';
  PREFS_DISPLAY_EMPLOYEE_PROFILE_IMAGE='Show Profile Pictures';
  PREFS_USE_SHIFT_BONUS='Use WorkShifts Premiums';
  PREFS_DISPLAY_PLAN_IN_SCHEDULE_PER_POSITION='Show Plannings on Schedules / Position';
  PREFS_USE_BANK_TYPE='Custom Time Banks';
  PREFS_USE_GEO_FENCE='GPS Fences';
  PREFS_USE_SURVEYS='Surveys';
  PREFS_USE_SURVEYS_EXTRA='Surveys Extra (COVID)';
  PREFS_USE_API_ACCESS='API Access';
  PREFS_USE_CUSTOM_PREMIUM='Custom Cumulative Premiums Access';
  PREFS_DEMO_ACCOUNT='DEMO Account';
  PREFS_USE_REPORT_TO_EMAIL='Reports by email';
  PREFS_CAN_MODIFY_COST_DISTRIBUTION='Modify Costs Distributions';
  PREFS_USE_SYNC_API='Sync API';
  PREFS_HIDE_INFORMATION_FOR_DEMOS='Hide some infos in demo mode';
  PREFS_MANUAL_VALIDATION_SCHEDULE='Schedules have to be manually validated';
  PREFS_DISPLAY_MEMOS_BY_TYPE='Display Memos by Type';

  PREFS_CAN_MODIFY_ALL_PAST_TS='Can modify all past TS';
  PREFS_CAN_MODIFY_ALL_PAST_SCHEDULES='Can modify all past Schedules';
  PREFS_ACCOUNT_CAN_ADD_TEST_PUNCH='Can add Schedules and Punches (Jerome Only!)';
  PREFS_ACCOUNT_CAN_DELETE_UNAPPROVED_TS_IN_BATCH='Can delete Timesheets in Batch (Jerome Only!)';
  PREFS_AUTO_SAVE_SCHEDULES='Auto-Save Schedules';
  PREFS_MAX_MENU_600='Menus Max Height 600';
  PREFS_MAX_MENU_800='Menus Max Height 800';
  PREFS_MAX_MENU_900='Menus Max Height 900';
  PREFS_DISPLAY_REQUEST_LIST='Display Requests Received';
  PREFS_USE_INTUIT_API='Intuit API';
  PREFS_FAVORITE_MENU='Favorite Menu';
  PREFS_DEFAULT_MEAL_DURATION='Default Meal Duration';
  PREFS_DEFAULT_BREAK_DURATION='Default Break Duration';
  PREFS_CAN_READ_CONFIGURATION_API_V2='Can Read API V2 Configuration';
  PREFS_SMART_SEARCH='Employees Smart Search';
  PREFS_EDIT_IN_PLACE='Smart Edit (Schedules & TS)';
  PREFS_COPY_ONLY_SCHEDULE_WITH_DND="Drag N Drop Only do Copy";
  PREFS_EMPLOYEE_FILE_PANEL_OPEN_V2='Opened Panels - V2'
  PREFS_CUSTOM_GROUP_CARBUR ='Group Carbur - Menu';
  PREFS_IMPORT_SCHEDULES_FROM_ON_TRACK='Import Schedules OnTrack - Menu';

  EmployeeWillPunch = 'The employee will punch.';
  EmployeeWillPunchOnTheWeb__ = 'Employee can punch via Employee Portal and Mobile Application.';
  EmployeeWillPunchOnTheWeb = 'Employee can punch via the Employee Portal.';
  EmployeeWillPunchOnTheMobile= 'Employee can punch via the Mobile Application.';

  TasksAndFunction = 'Tasks & Functions';
  Task1 = 'Task 1';
  Task2 = 'Task 2';
  Task3 = 'Task 3';
  Task4 = 'Task 4';
  Task5 = 'Task 5';
  Task6 = 'Task 6';
  Task7 = 'Task 7';
  Task8 = 'Task 8';
  Task9 = 'Task 9';
  Task10 = 'Task 10';
  PayManagement = 'Pay Management';
  EXPORT_PAY_TYPE_1 = 'Nethris';
  EXPORT_PAY_TYPE_2 = 'Acomba';
  EXPORT_PAY_TYPE_3 = 'Avantage';
  EXPORT_PAY_TYPE_4 = 'Desjardins';
  EXPORT_PAY_TYPE_5 = 'Paie PC';
  EXPORT_PAY_TYPE_6 = 'Pay Web';
  EXPORT_PAY_TYPE_7 = 'Simple Comptable';
  EXPORT_PAY_TYPE_8 = 'ADP';
  EXPORT_PAY_TYPE_9 = 'Sage (PJC)';
  EXPORT_PAY_TYPE_10 = 'Rocheleau';
  EXPORT_PAY_TYPE_11 = 'Cytronics';
  EXPORT_PAY_TYPE_12 = 'SCQC';
  EXPORT_PAY_TYPE_13 = 'Hopem';
  EXPORT_PAY_TYPE_14 = 'MagicPay'
  EXPORT_PAY_TYPE_15 = 'SCQC GC';
  EXPORT_PAY_TYPE_16 = 'Acceo';
  EXPORT_PAY_TYPE_17 = 'PowerPay (Ceridian)';
  EXPORT_PAY_TYPE_18 = 'EasyPay';
  EXPORT_PAY_TYPE_19 = 'Ogasys';
  EXPORT_PAY_TYPE_20 = 'Azur';
  EXPORT_PAY_TYPE_21 = 'Hopem+';
  EXPORT_PAY_TYPE_22 = 'Ultimate';
  EXPORT_PAY_TYPE_23 = 'Nethris (Attendance)';
  EXPORT_PAY_TYPE_24 = 'Desjardins (Attendance)';
  EXPORT_PAY_TYPE_25 = 'Hopem (Valeo-Sedna)';
  EXPORT_PAY_TYPE_26 = 'PayWorks';
  EXPORT_PAY_TYPE_27 = 'Titan';
  EXPORT_PAY_TYPE_28 = 'Sage50';
  EXPORT_PAY_TYPE_29 = 'QuickBooks Time';
  EXPORT_PAY_TYPE_30 = 'Emprez';
  EXPORT_PAY_TYPE_31 = 'Dynacom';
  EXPORT_PAY_TYPE_32 = 'On Track';
  EXPORT_PAY_TYPE_33 = 'ADP - CSV';
  EXPORT_PAY_TYPE_34 = 'Harvest';

  PAY_PERIOD_TYPE1 = 'Weekly';
  PAY_PERIOD_TYPE2 = 'Every 2 weeks';
  PAY_COMPILATION_TYPE_WEEKLY = 'Weekly';
  PAY_COMPILATION_TYPE_TWO_WEEK = 'Every 2 weeks';
  PAY_COMPILATION_TYPE_WEEK_1_ONLY = '1st Week Only';
  PAY_COMPILATION_TYPE_WEEK_2_ONLY = '2nd Week Only';
  SaveConfiguration = 'Save Configuration';
  PAY_SUMMARY_SORT_ALPHABETICAL = 'Alphabetical Order';
  PAY_SUMMARY_SORT_BADGE_ID = 'Employee ID';
  PAY_SUMMARY_SORT_SENIORITY = 'Seniority';
  PAY_SUMMARY_SORT_DEFAULT_JOB = 'Default Position';
  PAY_SUMMARY_SORT_SERVICE = 'Service';
  ExportingPay='Export Pay';
  PaySystem = 'Payroll Service';
  EnterpriseCode = 'Enterprise Code';
  PayCompilation = 'Compilation';
  PayWorkedHours = 'Hours Worked';
  HolidayHours = 'Stat. Holidays';
  VacationHours = 'Vacations';
  SickLeaveHours = 'Paid Sick Leave';
  PaidAbsenceHours = 'Paid Leave';
  PaidLeaveHours = 'Paid Absences';
  _PaidAbsenceHours = 'Paid Absences';
  _PaidLeaveHours = 'Paid Leave';
  PaidFamilyAbsence = 'Paid Family Leave';
  TimeBankUtil = 'Banked Time Used';
  TimeBankCumul = 'Banked Time Accumulated';
  ExportPayFile = 'Generate';
  ExportPayFileAndTransmit = 'Generate & Transmit';
  ExportingPaySummary = 'Pay Summary';
  ExportPaySummaryFile = 'Generate';
  IncludeTerminatedEmployees = 'Include Terminated Employees';
  ExportingEmployees= 'Export Employee Files';
  ExportEmployeeFile = 'Generate';
  ExportEmployeeFileAndTransmit = 'Generate & Transmit';
  SortOrder = 'Sort By';
  ImportingPayStubs = 'Import Pay Slips';
  ImportPayStubs = 'Import';
  ExportType = 'Export Type';
  EXPORT_EMPLOYEE_FORMAT_ADP = 'ADP';
  EXPORT_EMPLOYEE_FORMAT_NETHRIS = 'Desjardins-Nethris';
  EXPORT_EMPLOYEE_FORMAT_AZUR = 'Azur';
  EXPORT_EMPLOYEE_FORMAT_HOPEM = 'Hopem';
  EXPORT_EMPLOYEE_FORMAT_HOPEM_VALEO_SEDNA = 'Hopem (Valeo-Sedna)';
  EXPORT_EMPLOYEE_FORMAT_ON_TRACK = 'On Track';


  PayStubFormatType='Format for Import of Pay Slips';
  DropPayStubsHere = 'Drag and Drop the file here.';
  PAY_STUB_FORMAT_TYPE_NETHRIS_ = 'Nethris-Desjardins';
  PAY_STUB_FORMAT_TYPE_NETHRIS = 'Standard';
  ImportFile = 'Import';
  WeekCompilation = 'Week';
  APIUserName = 'Service Web Username';
  APIPassword = 'Service Web Password';
  ApiEnterpriseCode = 'Service Web Enterprise Code';
  ApprobationDoneAndWhen = 'Approved by {{approvedBy}} on {{approvedOn}}.';
  LockedByAndWhen = 'Locked by {{lockedBy}} on {{lockedOn}}';
  ReadyToBeApproved = 'Ready to be approved';
  ErrorsCantBeApproved= 'Can\'t Approve with Errors';
  AlreadyApprovedCantBeDisapprovedLocked='Approved & Locked';
  AlreadyApprovedCanBeDisapproved='Disapprove';

  ForThePayPeriode = 'For the Pay Period';
  ForTheWeekPeriode = 'For the period';
  OrForThisDayOnly = 'Or only for: ';
  EmployeeRights = 'User\'s Rights';
  RightsPerUnit = 'Access is granted to the selected units.';
  RightsPerEnterprise = 'Access is granted to the selected enterprises.'
  ApproveAll = 'Approve All';
  UnApproveAll = 'Un-Approve All';


  'Cant.approve.not.between.dates' = 'You can approve Time Sheets only between {{from}} and {{to}}.';
  'Cant.approve.no.job'= 'The Time Sheet has no associated position.';
  'NotTheRightRole.to.approve' = 'You role can\'t approve Time Sheets.';
  PeriodeWeek = 'Period';

  RawInformationForEmployee='Raw Information for the pay';
  RawPayPeriod = 'Pay Period';
  RawDisclaimer = 'Note that hours are in decimal format not minute format (1.5 = 1h 30min, 1.25 = 1h 15min, ...)';

  PayEntryCode = 'Code';
  PayEntryName = 'Desc.'
  DivisionCode = 'Div.';
  ServiceCode = 'Serv.';
  DepartmentCode = 'Dept.';
  SubDepartmentCode = 'S-Dept.';
  HoursDecimal = 'Hours (10)';
  Wage  = 'Wage';
  PayAmount = 'Amount';
  BonusManagement = 'Manage Premiums';
  JobBonusPerDayAndHour='Hourly Premium';
  DefaultBonus = '(Default)';
  BonusPerHour = '{{value}}/h';
  BonusPercentHour = '{{value}} %/h';
  BonusFixed='{{value}}';
  BonusFixedInPercent='{{value}}';

  EveryDayFrom='Every day';
  ExplainJobBonus = '{{when}} from {{start}} to {{end}}, {{bonus}}. (Hour Code: {{hourCode}}, Premium Code: {{bonusCode}}).';
  ExplainShiftBonus= 'Premium: {{bonus}}. (Hour Code: {{hourCode}}, Premium Code: {{bonusCode}}).{{bonusPoste}}<br> <span style="font-style: italic">{{divisions}}</span>';
  WillAddJobBonusIfThereIsOne=' (Position Premium will be added.)';
  BonusIsDeactivated=' <span class="emprez-orange-fiesta">Premium has been deactivated.</span>';

  ExpensesTypes='Expenses Types';
  ExplainExpenseType='{{name}} is an expense in {{unitName}} whose multiplier is {{valuePerUnit}}, exported in the PayRoll with the code {{payExportCode}} <br> <span style="font-style: italic">{{divisions}}</span>';
  ExplainExpenseTypeDeactivated='<span class="emprez-orange-fiesta">{{name}} is a DEACTIVATED expense in {{unitName}} whose multiplier is {{valuePerUnit}}, exported in the PayRoll with the code {{payExportCode}} <br> <span style="font-style: italic">{{divisions}}</span></span>';



  CumulativeBonus = 'Cumulative Premium';
  CUMULATIVE_BONUS_TYPE_OVERTIME = 'Overtime';
  CUMULATIVE_BONUS_TYPE_FIX = 'Fix';
  CUMULATIVE_BONUS_TYPE_HOLIDAY = 'Stat. Holiday';

  CUMULATIVE_BONUS_PERIOD_DAILY = 'Daily';
  CUMULATIVE_BONUS_PERIOD_HEBDO = 'Weekly';
  CUMULATIVE_BONUS_PERIOD_FORTNIGHT = '2 weeks';

  CUMULATIVE_BONUS_CONDITION_LESSER = 'less than';
  CUMULATIVE_BONUS_CONDITION_GREATER = 'more than';
  CUMULATIVE_BONUS_CONDITION_EQUALS = 'equal to';
  CUMULATIVE_BONUS_CONDITION_DIFFERENT = 'different than';
  CUMULATIVE_BONUS_CONDITION_TO_A_MAX_OF = 'max. of';
  CUMULATIVE_BONUS_CONDITION_GREATER_OR_EQUALS='greater or equals to';

  CumulativeBonusWorkedHour = 'Hours Worked';
  CumulativeBonusTraining = 'Training';
  CumulativeBonusTraineeship = 'Traineeship';
  CumulativeBonusHoliday = 'Stat. Holiday';
  CumulativeBonusVacation = 'Vacation';
  CumulativeBonusPaidDayOff = 'Paid Day-Off';
  CumulativeBonusPaidFamily = 'Paid Family Leave';


  CumulativeBonusBonus='Add Position Premium';


  CumulativeBonusForHoliday = 'Stat. Holiday Premium of {{bonus}}, for schedules of type {{schedules}}. (Pay Code: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>';
  CumulativeBonusForHolidayWithCondition = 'Stat. Holiday Premium of {{bonus}}, for schedules of type {{schedules}}, when the sum of the hours <span style="font-style: italic">({{accumulation}})</span> is {{condition}}. (Pay Code: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>';
  CumulativeBonusFix='Premium of {{bonus}}, for schedules of type <span style="font-style: italic">({{schedules}})</span>, when the sum of the hours <span style="font-style: italic">({{accumulation}})</span> is {{condition}}. (Pay Code: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>';
  CumulativeBonusOvertime='Premium of {{bonus}}, for schedules of type {{schedules}}, when the sum of the hours ({{accumulation}}) is {{condition}}. (Pay Code: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>'
  CumulativeBonusToAMaxOf= 'Premium of {{bonus}}, for schedules of type <span style="font-style: italic">({{schedules}})</span>, to a maximum of {{condition}} <span style="font-style: italic">({{accumulation}})</span>. (Pay Code: {{codeForPay}}). <br><span style="font-style: italic">{{divisions}}</span>';

  BonusWontApplyOnHolidays='<span class="emprez-orange">(Won\'t apply on a Stat. Holiday)</span>';
  CumulativeBonusApplyEvenOnHoliday='Will be applied on a Stat. Holiday';
  CumulativeBonusDaysOfTheWeekExplanation='Premium will use only Timesheets on the selected days of the week.';
  TSWillApplyOnlyOn='Premium will use only Timesheets on  <span style="font-style: italic">{{daysOfTheWeek}}</span>.';
  WillBeUsedInSomeHolidayCalculation='Premium will be used in some Stat. Holidays methods.';

  EditCumulativeBonus = 'Cumulative Premium';
  bonusName='Name';
  payExportCode = 'Pay Code';
  CumulativeBonusPercent = 'Premium';
  CumulativeBonusAmount='Premium';
  CumulativeBonusDefault= 'Default Premium';
  CumulativeBonusUseInSomeHolidayCalculation='Use in supported Stat. Holiday Calculation Methods';
  bonusType='Type';
  bonusPeriod='Period';
  condition='When the sum of the hours';
  conditionAmount = 'HH:MM';


  PunchTakesPhoto = 'Taking photos';
  PhotoRetention = 'Photos Retention (days)';
  PunchID = 'Punch Id';
  PunchAdminCode = 'Punch Admin Code';
  StartOfWeek = 'Start of Week';
  startOfWeekForSchedule= 'Start of Week (Schedules)';
  TimeZone = 'Time Zone';
  LoadingDataDelayInMinute = 'Loading Delay (min)';
  SendingDataDelayInMinute = 'Sending Delay (min)';
  BreakMaxDelayInMin = 'Displaying Delay for Break (min)';
  MealMaxDelayNoScheduleInMin = 'Displaying Delay for Meal, No Sch. (min)';
  MealMaxDelayInMin = 'Displaying Delay for Meal (min)';
  PunchCheckSequence = 'Check Sequence';
  PunchCheckBreak = 'Valid. Breaks';
  PunchCheckMeal = 'Valid. Meals';
  DisplayBirthday = 'Disp. Birthdays';
  DisplayClock = 'Disp. Clock';
  DisplaySchedule = 'Disp. Schedule';
  DisplayEmergency = 'Disp. Emergency';
  DisplayEmployeeSchedule = 'Disp. Employee Sch.';
  DisplayEmployeeMessages = 'Disp. Employee Msg';
  DisplayEmployeeTasks = 'Disp. Employee Tasks';
  DisplayClose = 'Disp. Close Button';
  IsItASmallScreenTAG = 'Small Screen (TAG)';
  DisplayMealButton = 'Disp. Meals Button';
  DisplayBreakButton = 'Disp. Breaks Button';
  DisplayJobChangeButton = 'Disp. Position Change Button';
  DisplayTimesheetButton = 'Disp. Timesheet Button';
  PunchIsVisible = 'Punch is visible';
  SearchByPunchName = 'Search by Punch Name';
  DisconnectedPunches = 'Disconnected Punches List';
  createPunch = 'Create a New Punch';
  punchName = 'Punch Name';
  EnterprisesPanel = 'Enterprises';
  EnterpriseGroupsPanel = 'Entreprises Groups';
  NoEnterpriseFound = 'No Enterprise found.';
  EnterpriseName = 'Enterprise\'s Name';
  SearchEnterprise = 'Enterprise search';
  EnterEnterpriseNameOrCode = 'Enter part of the name or code of the enterprise you are searching';

  UnitNotFound = 'Unit not found.';
  UNIT_TYPE_DIVISION = 'Division';
  UNIT_TYPE_SERVICE = 'Service';
  UNIT_TYPE_DEPARTEMENT= 'Department';
  UNIT_TYPE_SOUS_DEPARTEMENT = 'Sub-Department';
  AddSubUnit = 'Add a sub-unit';
  EditDivision = 'Division';
  CreateUnit = 'Create a Unit';
  description = 'Description';
  SearchUnit = 'Search for a Unit';
  ShowDivisions = 'All Divisions';
  CreateNewDivision = 'Create a new division';
  unitCode = 'Unit Id';
  startOfWeek = 'Start of Week';
  zohoId = 'CRM Id (Zoho Id)';
  ZohoName='CRM Name (Zoho Name)';
  NoteSysAdmin='Note (Half-God)';


  EditHourBonus = 'Hourly Premium';
  startTime='Start Time';
  endTime = 'End Time';
  JobBonusPercent = 'Premium Percent';
  JobBonusAmount = 'Premium Amount';
  PayExportHour = 'Payroll Code for Hours';
  PayExportBonus = 'Payroll Code for Premium';

  CreateNewEnterprise = 'New Enterprise';
  ThisPunchHasNoConfigVeryWrong = 'Something is very wrong with this punch. No configuration has been found.';
  ImportEmployeeNethrisFormat = 'Import Employees (Format 1)';
  UploadCSVFile = 'Select the CSV file to upload';
  EmployeeInserted = '{nbSuccess}/{nbObjects} employees have been added.';

  ShowFormat = 'Show Format';
  HideFormat = 'Hide';
  MandatoryField = 'Mandatory Field';
  CreateEmployee = 'Create a new Employee';
  ImportEmployeeFromFile = 'Import Employees from a File';
  ImportEmployeeFromAPI = 'Import Employees via Web Services Link';
  ImportEmployeeWithNethrisAPI = 'Import with the entreprise: {{name}}';
  SearchLNameNethris = 'Exact (Web Service Limitation) Search by Family Name';

  ApiUserName = 'Service Web Username';
  ApiPassword = 'Service Web Password';
  APIUseTheTestMode = 'Service Web is in Test Mode';
  ExportationCodes = 'Default Code for the PayRoll';
  UploadStructureAsCSV = 'Upload Structure';
  ExcelTemplate = "Excel Template";
  AutomaticTimesheetValue = 'Meals Parameters (Auto TS)';
  EntityCode = 'Entity Code';
  CreateAdmin = 'Create an Administrator';


  SchedulePrintConfig = 'Print Options';
  ShowDivision = 'Show Division';
  ShowHeader = 'Show Header';
  ShowColor = 'Show Colors';
  ShowTraining = 'Show Training';
  ShowTimeOff = 'Show Vacations';
  ShowTel = 'Show Phone';
  ShowTotal = 'Show Total';
  ShowJob = 'Show Position';
  ShowFunction = 'Show Functions';
  ShowNoSchedule = 'Show No Schedules';
  ShowMeal = 'Show Meals';
  ShowBreak = 'Show Breaks';
  ShowDailyPercentage = 'Show Percentage Per Day';
  ShowTasks = 'Show Tasks';
  ShowEmployeeWithoutSchedule='Show Employees w/o Schedules';
  ShowWorkShiftBonus='Show Workshift Premiums';

  // RetrieveFromPayRoll = 'Retrieve from Pay Roll System';
  // SendToPayRoll = 'Send to Pay Roll System';

  RetrieveFromPayRoll = 'Retrieve from {{payRoll}}';
  RetrieveFromPayRollThenUpdateEmprez = 'Retrieve from {{payRoll}} and update the employee\'s file';
  MatchingFromPayRoll = 'Found in {{payRoll}}';
  MatchEmployeeWithAllieRH='Folks: Linking Employees found in Folks';
  MatchEmployeeWithFolks = 'Match with {{name}}';
  ImportEmployeeFromAllieRH='Folks: Import Employees into Emprez';
  ImportEmployeeWithFolks='Import with {{name}}';

  SendToPayRoll = 'Send to {{payRoll}}';
  DifferentSalary = 'Salary on {{payRoll}} is {{salary}}';
  DownloadMyStructure = 'Download My Structure';
  EditEmployeeNow = 'Modify Employee';
  Year = 'Year';
  AbsCode = 'Code';
  AbsType = 'Type';
  Description = 'Description';
  BalanceHours = 'Balance (Hrs)';
  BalanceAmount = 'Balance';
  PaidHours = 'Paid (Hrs)';
  PaidAmount = 'Paid';
  BanksInformation = 'Absences Information';
  UsingTheTimeBank = 'Using the Time Bank';
  PunchMessages = 'Messages Visible on the Punch';
  NoMessageForPunches = 'No Message has been created.';
  PunchMessageDisclaimer = 'There is a 1 hour delay before a message will be transferred to the punch.';
  Author = 'Author'
  Batching = 'Batches';
  RetrieveInformation = 'Search';
  Import = 'Import';
  ImportSelectedBalance = 'Import Selected Balance';
  CreateVacationRecord = 'Add Vacations';
  CreateOrDeleteVacationRecord = 'Add or Delete Vacation';
  CreateOrRemoveEvaluationsInBatch='Add or Delete Evaluations';
  AddEvaluationToEmployee='Add an Evaluation (if it doesn\'t exist for the same due date)';
  RemoveEvaluationFromEmployee='Delete an Evaluation (if no answer has been recorded)';

  SearchForEmployeePlaceHolder= '<Lastname> <Firstname> or #<Employee Number>';
  UpdateVisibleEmployee = 'Update Employee Visibility';
  CreateSickDays = 'Add Sick Days';
  CreateOrDeleteSickDays = 'Add or Delete Sick Days';
  SelectAll = 'Select All';
  UnSelectAll = 'Un-Select All';
  SickDaysInMin = 'Sick Day in HH:MM';

  UpdateSalaryInBatch = 'Wage Adjustments';
  WithSalaryGreaterThan = 'Employees with a wage greater than';
  WithSalaryLessThan = 'Employees with a wage less than';
  AdjustmentDate = 'Adjustment Date';
  SalaryAdjustment = 'Wage Adjustment';
  SalaryAdjustmentPercent = 'Wage Adjustment in Percent';
  EmployeeTerminated = 'Terminated';
  ExternalCalendariCal = 'Link for (Google Calendar,...)';
  CopyCalendarLinkToClipboard='Copy link for Google Calendar';
  SendCalendarLinkToEmployee='Send Link for Google Calendar by email';
  CopyToClipboard='Copy';
  SendToEmployee='Send by email';

  DoYouWantUsToSendYouANewPassword = 'Do you want us to send you a new password?';
  NewPasswordSentTo = 'A new password has been sent to {{recipient}}.';
  Report1010 = 'Hours Worked Summary';
  Report1014 = 'Collective leaves';
  Report1015 = 'Individual leaves of absence';
  Report1016='Exceptions by employee';
  Report1017='Exceptions by Subdivision';
  Report1018='Time Punch Codes';
  Report1019='Access codes';
  Report1020='Years of Service';
  Report1021='Hourly Attendance';
  Report1022='Daily Attendance';
  Report1023='Daily Summary';
  Report1024='Individual Summary';
  Report1025='Vacation Calendar';
  Report1026='Expired Competences';
  Report1027='Batch timesheets';
  Report1028='Timesheets';
  Report1029='Inter-Division';
  Report1030 = 'Trainings';
  Report1031 = 'Batch Individual Summary';
  Report1032 = 'Overtime';
  Report1033 = 'Salary';
  Report1035 = 'Phone List';
  Report1036 = 'Punches per Employee';
  Report1037 = 'Modified Punches';
  Report1038 = 'Modified Punches per Employee';
  Report1039 = 'Birthdays';
  Report1041 = 'Time Bank';
  Report1042 = 'Seniority per Position';
  Report1043 = 'Bonuses';
  Report1045 = 'Banks summary';
  Report1046 = 'Emergency Contacts';
  Report1047 = 'Active Competences';
  Report1048 = 'Absences Export';
  Report1049 = 'Delays & Absences by Employee';
  Report1050 = 'Delays & Absences';
  Report1051 = 'Real Hours Summary';
  Report1052 = 'Stat. Holidays Calculation';
  Report1053 = 'Stat. Holidays List';
  Report1056 = 'Availabilities';
  Report1057 = 'Weekly Schedule';
  Report1058 = 'Cost per Day';
  Report1059 = 'Custom Time Banks Balances';
  Report1060 = 'Custom Time Banks Details';
  Report1061 = 'Turnovers';
  Report1062 = 'Employees List with at least 1 schedule';
  Report1063 = 'Employees List with at least 1 approved TS';
  Report1064 = 'Distinct number of employees with at least 1 approved TS or 1 active schedule';
  Report1065 = 'Premiums List per Employee';
  Report1066 = 'Work, Late Arrivals, Absences and Amounts paid per Employee';
  Report1067 = 'Amounts Paid';
  Report1068 = 'Work, Late Arrivals, Absences and Amounts paid per Employee - Selection by structures and groups';
  Report1069 = 'Absenteeism and Late Arrivals per Structure';
  Report1070 = 'Late Arrivals per Structure';
  Report1071 = 'Amounts paid per Payroll for a selected PayPeriod';
  Report1073 = 'Timesheets Complete List per Payroll';
  Report1074 = 'Timesheets Complete List per Structure';
  Report1076 = 'All Managers Emails';
  Report1077 = 'Tasks per Project and Date';
  Report1078 = 'Schedules Displayed by Unit';
  Report1079 = 'Hiring Status Updates';
  Report1080 = 'Expenses';
  Report1081 = 'Timesheets for Inactive or Hidden Employees';
  Report1082 = 'Evaluations per Employee';
  Report1083 = 'Due Evaluations per Employee';
  Report1085 ='Terminated Employees';
  Report1086='Employees Requests';
  Report1087='Rights on Structure and Enterprises per Employee';
  Report1088='Rights on Structure and Enterprises per Employee';
  Report1089='Employees Requests not Answered yet per Unit';
  Report1090='Daily Summary (Structure)';
  Report1091='Employees Positions (Structure)';
  Report1092='Training Costs';
  Report1094='Deleted Schedules or Timesheets';
  Report1095='Employees with at least one approved timesheet';
  Report1096='Custom Time Bank Calendar '

  ReportW9001='Timesheets (Armoires Cuisines Action)';
  ReportW9002 = 'Approved Timesheets (La Cordée)';
  ReportW9003 = 'Feuille de temps (PicNik)';
  ReportW9004 = 'Calcul Maladie GBDA';
  ReportW9007 = 'Rapport Mortagne';
  ReportW9010 = 'Rapport HART';
  ReportW9011 = 'Rapport Esterel - Coûts';
  ReportW9012 = 'Worked Hours with Totals per Position and Department (9012)';
  ReportW9013 = 'Batch Individual Summary - (9013)';
  ReportW9014 = 'Rapport Primeau Vélo';
  ReportW9015 = 'Cumul des Heures';
  ReportW9016 = 'R. des batisseurs - Heures travaillees (9016)';
  ReportW9017 = 'WongWing - Sommaire individuel par groupe (9017)';
  ReportW9018 = 'Empty schedules (9018)';
  ReportW9019 = 'Salary (9019)';
  ReportW9020 = 'Unlocked TS (9020)';
  ReportW9021 = 'Absences personnel de soutien (9021)';
  ReportW9022 = 'Feuilles de temps et Primes (9022)';
  ReportW9023 = 'Sommaire de paie - Limité (9023)';
  ReportW9024 = 'Horaires par Fonction (9024)';
  ReportW9025 = 'Scheduled - Real (9025)';
  ReportW9026 = 'Timesheets (9026)';
  ReportW9027 = 'Worked Hours Summary (9027)';
  ReportW9028 = 'Azoulay - Hours Summary (9028)';
  ReportW9029 = 'Hours Worked Summary per Position (9029)';
  ReportW9030 = 'Hours per Employee and Segment (9030)';
  ReportW9031 = 'Worked Hours (9031)';
  ReportW9032 = 'Maison Riviera Worked Hours (9032)';
  ReportW9033 = 'La Cordée - Formation (9033)';
  ReportW9034 = 'MSB Design - Yearly Individual Summary (9034)';
  ReportW9035 = 'Pay Summary - Columns (9035)';
  ReportW9036 = 'Weekly Schedule (9036)';
  ReportW9037 = 'Cost per Day and per Subdivision (9037)';
  ReportW9038 = 'Memos Status - Current User (9038)';
  ReportW9039 = 'Absences & Late Arrivals (9039)';
  ReportW9040 = 'Timesheets Complete List per Dates (9040)';

  AllEmployeeReports = 'Reports - Employees';
  AllCostReports = 'Reports - Costs';
  AllTimesheetReports = 'Reports - Timesheets';
  AllScheduleReports = 'Reports - Schedules';
  TimedTasksReports = 'Reports - Projects';

  NewWage = 'New Wage';
  ChooseTheEmployeeToExport = 'Choose the employee to export';
  GroupCreatedBy = 'Owner';
  GroupName = 'Name';
  GroupNotes = 'Notes';
  AddGroup = 'New';
  EditGroupEmployeAggregation = 'Employee Group';
  GroupIsVisible = 'Groups are Visible';
  ChooseEmployee = 'Select an Employee';
  SelectElement = 'Selection';

  mealMissingEnd='End of meal missing';
  mealMissingStart='Start of meal missing';
  mealNotSameLength='Duration of meal is different';
  mealUnscheduledEnd='End of meal not scheduled';
  mealUnscheduledStart='Start of meal not scheduled';
  mealPunchedNotSameLength = 'Different duration of punched meal';
  pauseMissingEnd='End of break missing';
  pauseMissingStart='Start of break missing';
  pauseNotSameLength='Different duration of break';
  pauseUnscheduledEnd='End of break not scheduled';
  pauseUnscheduledStart='Start of break not scheduled';
  unscheduledEnd='End of shift not scheduled';
  unscheduledStart='Start of shift not scheduled';
  missingEnd='End of shift is missing';
  missingStart='Start of shift is missing';
  startDiff='Different shift start date';
  endDiff='End of different shift';
  ALL_ARE_SELECTED = 'Select All';
  UpdateFromWebService = 'Retrieve information from {{payRoll}} and update employees'
  ChooseTheEmployeeToUpdate = 'Choose the employees to update.';
  NoEmployeesCanBeUpdated = 'No employee can be updated.';
  'Remember me' = 'Remember me';
  'Forgot Password?' = 'Forgot Password ?';
  Login = 'Connect';

  DayStartLocation = 'Shift Start';
  DayEndLocation = 'Shift End';
  Meal1StartLocation = 'Meal 1 Start';
  Meal1EndLocation = 'Meal 1 End';
  Meal2StartLocation = 'Meal 2 Start';
  Meal2EndLocation = 'Meal 2 End';
  Break1StartLocation = 'Break 1 Start';
  Break1EndLocation = 'Break 1 End';
  Break2StartLocation = 'Break 2 Start';
  Break2EndLocation = 'Break 2 End';
  UserNameAndPasswordIsRightNoRightsOnAnyUnit = 'Your username and password are valid. However, you do not have any access rights associated with this account. Please communicate with your Administrator.';
  UserNameAndPasswordIsRightNoRightsOnAnyEnterprise = 'Your username and password are valid. However, you do not have any access rights on the Enterprise associated with this account. Please communicate with your Administrator.';

  CanModifyOtherAdmins = 'Can Modify Other Admins';
  NbDistinctEmployeesWithSchedule = 'Number of Employees with at least one schedule or TS.';
  ReturnToWorkOn = 'Return to work on ';
  MatriculeUsedToMatch = 'Employee Number';
  FoundInEmprez = 'Found in Emprez';
  FoundInFolks = 'Found in Folks';
  ImportEmployeeWithMatriculeFromAPI = 'Web Service Link: Verify if certain employees are not matched between Emprez and the payroll service';
  UserHasTimesheetAccess = 'Can Add Their Own Timesheets';
  StructureErrorJobInTooManyUnit = 'Error in the structure, the position {{job}} MUST be associated with only one unit ({{units}})';
  NoUnitFound = 'No Unit found';
  MatchSelection = 'Match';
  SORT_ORDER_SENIORITY= 'Years of Service';
  SORT_ORDER_PREDEFINED_SORT_ORDER= 'File Sort Order';
  SORT_ORDER_EMPLOYE_ID= 'Employee Number';
  SORT_ORDER_ALPHABETICAL= 'Alphabetical Order';
  SORT_ORDER_DEFAULT_JOB='Default Position';
  SORT_ORDER_SCREEN_ORDER= 'Screen Order';
  SORT_ORDER_ECHELON_LEVEL='Job - Level';
  WatchVideos = 'Watch the videos';
  RetrieveAndUpdateInfoFromPayroll = 'Retrieve from Payroll Service';
  StatusForTheMessage = 'Message Status';
  PayConfigurationFrom = 'PayRoll configuration is read from enterprise <span>{{configFrom}}</span>. The following enterprises are included in the group: <b>{{inGroup}}</b>.';

  VacationFromForXdays = '<span class="emprez-vert-agrume">Vacations starting on {{from}} for {{nbDays}} day(s).</span>';
  VacationFromFor1day = '<span class="emprez-vert-agrume">1 day off on {{from}}.</span>';
  VacationFromFromForMinutes = '<span class="emprez-vert-agrume">{{duration}} (hours:minutes) taken as vacations on {{from}}.</span>';

  LastModificationOnAndBy = 'Last modification by {{modifBy}} on {{modifOn}}';
  LastTimeSeenByEmployee = 'Seen by employee on {{lastTimeSeen}}';

  ApprovedOnAndBy = 'Approved by {{modifBy}} on {{modifOn}}';

  PeriodeVacance = 'Vacation Period';
  LastModification = 'Last modification';
  LastModificationAndApprobation = 'Last modification & Approval';
  AddVacation = 'Add Vacations';
  NoCurrentVacation = 'No Vacation Period';
  FromVacationDate = 'First day on';
  ToVacationDate = 'Last day on';
  VacationType = 'Type';

  EmployeeHasNoVacationPeriod = '<span class="emprez-orange-fiesta">You didn\'t add a Vacation Period yet.</span>';
  WarningEmployeeDaysLeft = '<span class="emprez-orange-fiesta">Attention, when the following vacation days have been approved on the timesheet, the balance will be {{nbDaysLeft}} vacation day(s).</span>';
  EmployeeDaysLeft = '<span class="emprez-vert-agrume">When all the following vacation days have been approved on the timesheets, there will be {{nbDaysLeft}} day(s) of vacation remaining.</span>';


  LastConnectionOK ='<span class="emprez-vert-agrume">Last connection {{dt}}, last known ip: {{ip}}.</span>';
  LastConnectionWarning ='<span class="emprez-orange-fiesta">Last connection {{dt}}, last known ip: {{ip}}.</span>';
  LastConnectionError ='<span class="emprez-rouge-matador">Last connection {{dt}}, last known ip: {{ip}}.</span>';

  SelectEnterprise = 'Select an Enterprise';
  SelectPayPeriod = 'Select a pay period';
  RemoveColor = 'Remove Color';
  BreakPaid = 'Break paid';
  DangerCreatingDuplicates = 'Warning: Possibility of creating duplicates. Make sure to match ALL existing files before importing new ones';


  BreakIsPaid = 'Break paid of {{breakDuration}}';
  BreakIsPaidAsNormal = 'Break paid as a normal break of {{normalBreakDuration}}';
  BreakIsPaidFor='Break paid of {{normalBreakDuration}} and not paid for the remaining {{notPaid}}';
  BreakIsPaidButNotTaken = 'A Paid Break of {{normalBreakDuration}} was not taken. Nevertheless {{notPaid}} will be not paid.';
  BreakIsPaidAsNormalButSomeWontBePaid = 'Break paid as a normal break of {{normalBreakDuration}}. Nevertheless {{notPaid}} will be not paid.';

  BreakIsNotPaid='Break not paid of {{breakDuration}} was taken, {{notPaid}} will not be paid.';
  EmployeeStatus='Status';
  RetrieveAllTerminatedAndVisible='Terminated & Visible';
  MyEmployeeProfile = 'My Employee Profile';

  PREFS_HIDE_LATE_ARRIVAL_PANEL='Hide Late Arrivals in the Dashboard';
  PREFS_HIDE_PLAN_VALIDATION_PANEL='Hide Plan(s) Validation in the Dashboard';
  PREFS_HIDE_SCHEDULE_VALIDATION_PANEL='Hide Employee Schedule Validations in the Dashboard';
  PREFS_SHOW_HELP_WHEN_AVAILABLE='Show Help Button when Available';
  PREFS_HIDE_TIMESHEET_PANEL='Hide Timesheets to Approve in the Dashboard';
  PREFS_HIDE_EXPENSE_PANEL='Hide Expenses to Approve in the Dashboard';
  PREFS_HIDE_BIRTHDAYS_VALIDATION_PANEL='Hide Birthdays in the Dashboard';
  PREFS_HIDE_SKILLS_VALIDATION_PANEL='Hide Skills in the Dashboard';


  PREFS_SAVED_TZ = 'Default TimeZone';
  ChooseTimeZone='Change TimeZone';

  EmployeeSkills = 'Competencies';
  nbSkills = '{{nb}} competencies';
  nbSkill = '{{nb}} competencie';
  nbActiveSkills = '<span class="emprez-vert-agrume">{{nb}} active competencies</span>';
  nbExpiredSkills = '<span class="emprez-orange-fiesta">{{nb}} expired competencies</span>';

  nbActiveSkill = '<span class="emprez-vert-agrume">{{nb}} active competencie</span>';
  nbExpiredSkill = '<span class="emprez-orange-fiesta">{{nb}} expired competencie</span>';


  skillName = 'Competence';
  expiryDate = 'Expiration';
  EmployeeSkillList = 'Employee\'s Competencies';
  skillLastUpdate = 'Updated on {{on}} by {{by}}.';
  LearnHowToLinkYourEnterpriseWithAPI = 'Watch the video to know how to electronically connect your enterprise <b>{{name}}</b> with <b>{{payRoll}}</b>.'
  StartMeal1Time='Meal 1';
  Meal1Duration='Dur. (min)';
  StartMeal2Time='Meal 2';
  Meal2Duration='Dur. (min)';
  StartBreak1Time='Break 1';
  Break1Duration='Dur. (min)';
  StartBreak2Time='Break 2';
  Break2Duration='Dur. (min)';
  OnlyOneJobMustBeDefault = '<div class="emprez-orange-fiesta">You can only have one default position.</div>';
  AtLeastOneJobMustBeActiveAndDefault = '<div class="emprez-orange-fiesta">The default position must be active.</div>';

  CustomReports = 'Custom Reports';
  WebReportCode = 'Emprez Report Code';
  ReportClass = 'Report Type';
  ReportName = 'Name';
  CustomReport = 'Custom Report';
  CustomReportsTab='Custom';
  ReportType='Report Type';
  ReportIsActive = 'Report is active.';
  AllActiveCustomReports = "Reports - Custom";
  CanModifyStructure='The user can modify the structure.';
  CanModifyEnterprise='The user can modify the enterprises.';
  CanModifyCustomReport='The user can modify the custom reports.';
  CanModifyJob = 'The user can modify the positions.';


  jobLinkedToSeveralUnit ='Warning, position \'{{job}}\' is linked in several services/departments. In order to avoid some confusion, please limit your selection of services/departments.[{{jobKey}}]';
  WarningVacationsExistWithSameStartingDate = 'Warning, you already have a vacations bank starting on: <span style="font-size: larger; font-weight: bolder">{{dt}}</span>.';
  WarningSeveralVacationsExistWithSameStartingDate= 'Warning, you already have several vacations banks starting on: <span style="font-size: larger; font-weight: bolder">{{dt}}</span>.';

  Overnight='Overnight';

  MealIsPaid = 'Meal is paid.';
  MealIsPaidBut = 'The meal would normally be paid for {{normalDuration}}, but its duration was {{currentDuration}}, {{shouldNotBePaid}} should not be paid, {{willNotBePaid}} won\'t be paid.';
  MealIsNotPaidDefaultDuration = 'The meal uses the default duration, {{shouldNotBePaid}} should not be paid, {{willNotBePaid}} won\'t be paid.';
  MealIsNotPaidPunchDuration = 'The meal uses the punched duration, {{shouldNotBePaid}} should not be paid, {{willNotBePaid}} won\'t be paid.';

  MealIsPaidWithMax = 'The meal is paid for {{max}}.';
  MealIsPaidButNotSome = 'The meal is paid but {{willNotBePaid}} wont be paid.';

  ExportPayToPDF = 'Export in PDF';
  ExportPayToExcel = 'Export in Excel';
  ExportPayToXML= 'Export in XML';
  ExportPayToCSV= 'Export in CSV';
  ExportPayToJSON = 'Export in JSon';


  ExportPayStandard = 'Export in the standard format.';
  ExportPayStandardThenSend = 'Export in the standard format then send electronically';
  TemplateWeek = 'Template Week';

  CreatedDt='Created';
  JobActive ='Active?';
  Defaultjob='Default';
  EmployeeWithThisJobList = 'Employees with the selected position and unit';
  EmployeesPaidBy='Employees paid by {{name}}';
  EmployeePaidByThisEnterprise = 'Employee paid';
  RemoveExternalID = 'Remove \'External ID\'';
  EmployeesAvailableToPunchToday = 'Employees that can punch today.';
  WillTakePicture = 'Take picture?';
  CreateNewUser='Create a new user';
  AddAnyHiringType='Do Shift+Click to choose any hiring type';
  'Not.Enough.VacationsLeft' = 'Not enough Vacation Time left in the bank.';
  UseNbOfDaysInBankToCalculateAllowance = 'Calculated from the Time Bank';
  AddJobInBatch='Add Positions to Employees';
  AddHourlyBonusInBatch='Add or Modify Hourly Premiums';
  AddModifyJobAndHourlyBonusInBatch='Add Position or Modify Hourly Premiums to Employees';


  JobDefault='The position will be the job by default';
  DoYouReallyWantToDeleteTheGroup='Do you really want to delete this group?';
  DoYouReallyWantToDeleteThisEmployeeJob='Do you really want to remove the position from this employee?';
  DeleteEmployeeJob='Delete';
  FormatTaskToDisplayInDailyReport='Use this button to specify an entry mask to add a schedule to your tasks. Very useful in the daily report.';

  CompanyNumber='Enterprise #';
  EmployeeId='Id Externe'
  HireDate='Hire Dt';
  DepartureDate = 'Leave Dt';
  SomeModificationsHaveBeenDoneDoYouWantToContinueWithoutSavingFirst='Some unsaved modifications will be lost, do you want to continue anyway?';
  UnionRelated = 'Union';
  OtherType='Other';
  elements = '{{nb}} row(s)';
  SchedulesAndTimeSheets= '{{nbSch}} schedules and {{nbTs}} timesheets.';
  EmployeeHasNoOtherActiveJob = 'No other active job';
  ApplyToAllEmployee='Apply to All Employees';
  BeCarefulThePayingEnterpriseWontExportTimeBank = 'Attention the paying enterprise <span style="font-size: x-large">{{name}}</span> is not configured to export time banks in the payroll.<br>All hours in the time banks will be exported as regular hours.';

  PunchConfiguration = 'Punch Configuration';
  LoadAllEmployeeWorkingInUnit = 'Load Employees Working in the Unit';
  LoadAllEmployeeWithTheJobs = 'Load Employees With the Positions';
  ChooseJobsIfNecessary='Choose Position';
  SchedulesPerEmployeeTitle='Schedules per employee';
  SchedulesPerEmployeeTitleSideBySide='Schedules per employee';
  SchedulesPerPlan='Schedules per planning';


  SchedulesPerJobs='Schedules by Structure';
  SchedulesPerJobsTitle='Schedules by Structure';
  SchedulesPerJobTitle='Schedules by Position';
  SchedulesForOneJob='Schedules For One Position';

  SchedulesPerPlanTitle='Schedules by Plan';
  CurrentEtagSession = 'My Session!';
  DisplaySchedulesInfo = 'Display Info';
  SpifTypeTitle = 'Bonus Type';
  AddSpifTitle = 'Add Bonus';
  SpifType = 'Bonus Type';
  SpifDate = 'Bonus Date';
  AddOtherTypes = 'Add more Bonus Type';
  AddSpif = 'Add Bonus';
  SpifLabel= 'Bonus Label';
  PayRollCode = 'PayRoll Code';
  By = 'By {{modifBy}} on {{modifOn}}';
  NoSpifForThisPeriod = 'No Bonus for the Period';
  NoSpifTypeYet = 'No Bonus Type yet.';
  EmployeeSpifs = 'Bonuses';
  ApplyTimesheetParams ='Apply these \'Timesheet\' Parameters to all employees.';
  DoYouReallyWantToApplyTSParamsToEmployeePaidBy = 'Do you really want to apply the parameters to employees paid by {{name}}?';
  CarefulDefaultBonusHaveBeenAddedYouShoudlSaveIfYouDontWantToLoseYourChanges = 'Some default premiums have been added, you should save to keep the displayed information.';
  AddCumulativeBonusInBatch = 'Add Cumulative Premiums';
  SelectTheCumulativeBonusToApplyToTheSelectedListBelow = 'Select the Cumulative Premiums to add';
  SearchAgain = 'New Search';

  CanReceiveMemo = 'Can receive Messages';
  CanReceiveVacationRequest = 'Can receive Vacations Requests';
  CanReceiveAvailabilitiesRequest = 'Can receive Avail. Requests';
  CanReceiveWorkshiftExchangeRequest = 'Can receive Workshift Exchg.';
  CanReceiveInitialWorkshiftExchange= 'Can receive Initial Workshift Exchg.';
  CanReceiveFamilyDaysRequest='Can receive Family Days Requests';

  SendNotification='Send a notification';
  NotificationExplain = 'A Notification will be sent by email or directly on the mobile App, depending on the preferences of the employee. A notification on the mobile App won\'t use the body of the message.<br><b>Emprez can\'t warranty that the message will be delivered.</b>';
  NotificationTitle='Topic (Used by emails AND mobile App)';
  NotificationBody='Message Body (ignored by the mobile App)';

  NotificationCenterFor = 'Notifications Parameters for {{name}}';
  DeviceAssociatedWithTheEmployee='Mobile Devices associated with the Employee';
  AllowsNotification='Can be notified';
  DeviceType='Type';
  DeviceInfo = 'Device Information';
  DEVICE_TYPE_IOS='iOS';
  DEVICE_TYPE_ANDROID='Android';
  DEVICE_TYPE_GENERIC='P. of S.';

  NotificationDataSentToTheEmployee='Notifications sent to the employee during the following period:';
  fromDt = 'From';
  toDt = 'To';
  CommunicationType='Type';
  SentDt = 'Sent';
  Email ='Email';
  Phone = 'Tel.';
  ExternalSystemId = 'Ext. Id.';
  ExternalSystemResp = 'Resp. Ext.';

  NOTIFICATION_STATUS_AWAITING_DISTRIBUTION = 'Waiting Dist.';
  NOTIFICATION_STATUS_DISTRIBUTED = 'Distributed';
  NOTIFICATION_STATUS_ACCEPTED = 'Accepted';
  NOTIFICATION_STATUS_QUEUED = 'Queued';
  NOTIFICATION_STATUS_SENDING = 'Sending';
  NOTIFICATION_STATUS_SENT = 'Sent';
  NOTIFICATION_STATUS_RECEIVING = 'Receiving';
  NOTIFICATION_STATUS_RECEIVED = 'Received';
  NOTIFICATION_STATUS_DELIVERED = 'Delivered';
  NOTIFICATION_STATUS_UNDELIVERED = 'Not Delivered';
  NOTIFICATION_STATUS_FAILED = 'Failed';

  COMMUNICATION_TYPE_EMAIL='Email';
  COMMUNICATION_TYPE_PHONE='Tel.';
  COMMUNICATION_TYPE_DEVICE_NOTIFICATION='App. Notif.';
  COMMUNICATION_DEVICE_NOTIFICATION='App. Notif.';

  AddPunch = 'Add a Punch (for testing purposes)';
  ShowBoss = 'Display Managers';
  ManageCustomReports = 'Custom Reports Management';
  AddTimeInBank = 'Adjust Time Bank';
  ConnectToEmprez = 'Connect to Emprez';
  ManageEmployeeRights = 'Rights Management';
  ConnectInEmployeePortal = 'Connect to the Employee Portal';
  EmployeeNotificationCenter = 'Notifications Management';
  ExplainHolidayCalculation = 'Explain how Stat. Holidays are calculated';
  HolidayCalculation = 'Stat. Holiday Calculation';
  NbMinutesForHolidayOn = 'Stat. Holiday Calculation for {{dt}} returned {{min}} minutes or <b>{{nb}}</b>.'
  DisplayEmployeeThatCanPunch = 'Employees who can use this punch';
  ManageRights='Rights Management';
  ApplyScheduleParams = 'Apply these \'Schedule\' Parameters (except Sort Order) to all employees.';
  DoYouReallyWantToApplyScheduleParamsToEmployeePaidBy =  'Do you really want to apply the parameters to employees paid by {{name}}?';
  ApplyToAllEmployees = 'Apply to all Employees';
  DoYouReallyWantToApplyPortalParamsToEmployeePaidBy = 'Do you really want to apply the parameters to employees paid by {{name}}?';
  DoYouReallyWantToApplyPunchParamsToEmployeePaidBy  = 'Do you really want to apply the parameters to employees paid by {{name}}?';
  EnterpriseWithPayAnticipation = 'Enterprises with Pay Anticipation';
  MoveJobFrom='Moving positions \'{{job}}\' from unit \'{{unit}}\'';
  UnitToMoveTo = 'Target Unit';


  ExportStructure='Export Structure';
  DisplayNbDistinctSchedules='Display number of distinct employees with at least one schedule.';
  AddRightsToMultipleUnits='Add Rights to sub-units';
  ShowEmployeeWithJob = 'Display Employees with the Position';
  MoveJobToAnotherUnit = 'Move Position to another Unit';
  MoveJob ='Move Position';
  Move = 'Move';

  EditNamedWorkShift = 'Modify Predetermined Shift';
  NamedWorkShiftName= 'Predetermined Shift Name';
  NamedWorkshiftIsActive = 'Predetermined Shift is active';
  NamedWorkShiftType = 'Type';
  NamedWorkShiftNotes = 'Notes';
  NamedWorkShiftCreatedBy = 'Author';
  NamedWorkShiftHours='Hours';

  NoUserFoundOtherThanYourself='No other User';
  ScheduleNote='Schedule Note';
  AliasManager='Predetermined Shifts Manager';
  ScheduleAlias = 'Predetermined Shifts';
  UsersWithAccessToAlias='Users who can use this Predetermined Shift';
  DisplayUserPreferences='User Preferences';
  UnitCode = 'Unit Id';
  UnitType = 'Unit Type';
  RemoveRightOnUnit = 'Remove Rights';
  PrefName = 'Name';
  PrefType = 'Type';
  PrefValue = 'Value';


  EstablishmentStructureCreation='Step 1: Structure Creation';
  YourStructureHasBeenCreatedNowProceedWithOtherSteps = 'Your Structure has been created, you may now continue to the next Step.';
  EstablishmentEmployeeCreation='Step 2: Add Employees';
  AddEmployeeToYourStructure = 'You can now add Employees to your Structure. <a class="naked" target="_blank" href="https://emprez.zohodesk.com/portal/en/kb/articles/employee-file-creation">How to add Employees?</a>';
  YouHaveAddedEmployeesNowProceedWithOtherSteps = 'You have added Employees, you may now continue to the next Step.'
  GoToCreateEmployeePage='Add Employee';
  EstablishmentScheduleCreation='Step 3: Add Schedules';
  AddSchedulesToYourEmployees = 'You can now schedule your employees for workshifts. <a class="naked" target="_blank" href="https://emprez.zohodesk.com/portal/en/kb/articles/work-shift-add-modification-and-delete">How to create a WorkShift ?</a>'
  GoToCreateScheduleByEmployee='Schedule per Employee';
  GoToCreateScheduleByJob='Schedule per Position';
  YouHaveCreatedSchedulesNowProceedWithOtherSteps = 'You have scheduled your employees you can now continue to the next Step and approve timesheets.';
  EstablishmentTimesheetCreation='Step 4: Approve Timesheets';
  ApproveTimesheetForYourEmployees='After creating schedules for your employees, you can now approve their timesheets. <a class="naked" target="_blank" href="https://emprez.zohodesk.com/portal/en/kb/articles/timesheets-approval">How to approuve timesheets ?</a>'
  YouHaveApprovedSomeTimesheetsNowProceedWithOtherSteps='You have approved some timesheets, you may now go to the next Step.';
  GoToTimesheetCreation='Approve Timesheets';
  EstablishmentPayRoll='Step 5: Export to PayRoll';
  GoToPayRoll='Export to PayRoll';
  YouAreNowReadyToExportToPayRoll='All steps have been successfully completed, you can now export to the PayRoll.';
  HideTheGuide = 'Congratulations, you can now use Emprez.';
  AlwaysPayMeals = 'Always Pay Meals';
  NeverPayMeals = 'Never Pay Meals';
  MealsAreNeverPaid= 'Meals are never paid';
  MealsAreAlwaysPaid = 'Meals are always paid';
  ExplainEmployeeTimesheetParams = '<span style="font-weight: bold;">Timesheet Parameters</span><br><br>a) Use this section to define the parameters which you want to apply to the timesheets for managing arrivals, departures, meals and breaks for <u>this employee</u>.<br>b) If you wish to have these same parameters applied to <u>all employees</u>(overriding previously defined parameters saved to those employee files), you can click on “Apply the parameters ‘Timesheets’ to all employees“ at the bottom of this page. ';

  EnterpriseId = 'Id';
  DumpRawInfo='Web Service Information';
  AddAccessToUser = 'Add Access to this Enterprise to users';
  ZohoId ='CRM Id';
  AllowPayStubs = 'Can Import Pay Slips';
  TypePeriod='PayRoll Type';
  Period='PayRoll Period';
  DisplayImplementationCursus='Display Implementation Cursus.';
  AddSpifTypeTitle='Add Bonus Type';

  TimedTasksManager = 'Projects Manager';
  TimedTaskGroupDescription = 'Name';
  TimedTaskGroupCreatedBy='Author';
  TimedTaskGroupNbTasks='Number of Tasks';
  TimedTaskGroupTitle='Modify a Project';
  TimedTaskGroupIsActive='Project is active';
  UsersWithAccessToTaskGroup='Users with access to the project';
  TasksInTaskGroup='Tasks of the Project';
  NoTimedTaskFound='No Task Found.';
  TimedTaskTitle='Modify a Task';
  TimedTaskDescription = 'Name';
  TimedTaskExternalCode = 'External Code';
  ExternalCode = 'External Code';
  TimedTaskScheduledDuration = 'Default Estimated Duration (Min)';
  AssociatedWithScheduleOf = 'Task is linked with the schedule from {{start}} to {{end}}.';
  NoScheduleAssociated = 'Task is not linked to a schedule';
  EmployeeTimedTasks = 'Tasks';
  NoTimedTaskForThisEmployee='No Task Found.';
  AddProject='Add Project';
  DoYouReallyWantToDeleteTheEmployeeTimedTaskParams='Do you really want to delete this task?';
  NoDateAssociated_Always='Always';
  AddTaskToEmployee='Employee\'s Task';
  TimedTasks = 'Links to Projects';
  TimedTaskGroup='Projects';
  AddTimedTaskGroup='Add a Project';
  DoYouReallyWantToDeleteTheTimedTaskGroup = 'Do you really want to delete the project \'{{name}}\'? ';
  SomeTasksHaveBeenDone = '( {{nb}} tasks have already been started and/or finished. )';
  BackToProjectList = 'Back to Projects List';
  TaskDescription='Task';
  RefDate = 'Dates';
  StartStopDates = 'Start - End';
  chartsForTaskFromProject='Tasks Allocation for project {{projectDescription}}'
  BackToProject='Back to Project';
  DoYouReallyWantToDeleteTheEmployee = 'Do you want to totally remove employee {{fullName}} including his profile, his schedules and his timesheets ?';
  DoYouReallyWantToDeleteThePunch='Do you really want to totally remove the punch {{fullName}} with deviceId {{deviceId}} ?';
  DoYouReallyWantToDeleteTheEnterprise='Do you really want to totally remove the enterprise {{fullName}}?';


  EmployeeWithNoJob = 'Employees without a position.';
  EmployeeWithNoActiveJob = 'Employees without an active position.';
  TotalDestruction = 'Completely removing the employee.';
  AddJob ='Add a position';
  HourlyBonus1='Hourly Premium 1';
  HourlyBonus2='Hourly Premium 2';
  HourlyBonus3='Hourly Premium 3';
  HourlyBonus4='Hourly Premium 4';
  HourlyBonus5='Hourly Premium 5';
  HourlyBonus6='Hourly Premium 6';
  HourlyBonus7='Hourly Premium 7';
  HourlyBonus8='Hourly Premium 8';
  HourlyBonus9='Hourly Premium 9';
  HourlyBonus10='Hourly Premium 10';
  HourlyBonus11='Hourly Premium 11';
  HourlyBonus12='Hourly Premium 12';
  HourlyBonus13='Hourly Premium 13';
  HourlyBonus14='Hourly Premium 14';
  HourlyBonus15='Hourly Premium 15';
  HourlyBonus16='Hourly Premium 16';
  HourlyBonus17='Hourly Premium 17';
  HourlyBonus18='Hourly Premium 18';
  HourlyBonus19='Hourly Premium 19';
  HourlyBonus20='Hourly Premium 20';


  CumulativeBonus1='Cumulative Premium 1';
  CumulativeBonus2='Cumulative Premium 2';
  CumulativeBonus3='Cumulative Premium 3';
  CumulativeBonus4='Cumulative Premium 4';
  CumulativeBonus5='Cumulative Premium 5';
  CumulativeBonus6='Cumulative Premium 6';
  CumulativeBonus7='Cumulative Premium 7';
  CumulativeBonus8='Cumulative Premium 8';
  CumulativeBonus9='Cumulative Premium 9';
  CumulativeBonus10='Cumulative Premium 10';
  CumulativeBonus11='Cumulative Premium 11';
  CumulativeBonus12='Cumulative Premium 12';
  CumulativeBonus13='Cumulative Premium 13';
  CumulativeBonus14='Cumulative Premium 14';
  CumulativeBonus15='Cumulative Premium 15';
  CumulativeBonus16='Cumulative Premium 16';
  CumulativeBonus17='Cumulative Premium 17';
  CumulativeBonus18='Cumulative Premium 18';
  CumulativeBonus19='Cumulative Premium 19';
  CumulativeBonus20='Cumulative Premium 20';

  HourlyBonuses = "Hourly Premiums";
  HourlyBonusesMore = "Hourly Premiums+";
  CumulativeBonuses="Cumulative Premiums";
  CumulativeBonusesMore="Cumulative Premiums+";

  AllBanksInformation='Information on available banks.';
  RetrieveBanks='Retrieve Information';
  DisplayAllBanks = 'Information on the available banks of the PayRoll';
  NoInformationAboutBanks = 'No information found.';
  StartTask = 'Beginning of Task';
  EndTask = 'End of Task';
  BackToEmployee = 'Close';
  MinuteApproved = '<div class="muted" style="display:inline">{{approved}} approved.</div>';
  WhatTimeSheetsWillBeConsidered='<span>Timesheets Type to use</span>';
  PasswordChangeTitle='Password Change';
  PasswordShouldBeChanged='Password is expired and needs to be changed.';
  CurrentPassword='Current Password';
  NewPassword='New Password';
  RepeatNewPassword='Repeat New Password';
  PasswordStrength='Password Strength:';
  passwordExpiredOn='expires on {{dt}}.';

  NoSecretNeedsToGenerateOne = 'Click here to generate a Two-Factor authentication';
  LinkToQRCodeForGoogleAuthenticator = 'Click here to visualize the QrCode to add to Google Authenticator';
  ActivateTwoFactorAuthentication = 'Activate Two-Factor Authentication.';
  GenerateNewSecret='Re-Generate';
  TwoFactorAuthentication='Double authentication';
  Authentication = 'Enter the number provider by your Authenticator';
  AuthenticateYourSelf = 'Second Authentication';
  ChooseUnitContainingNewJob = 'Choose a Unit';
  CreateNewJob='Create a new Position';
  EditTwoFactor = 'Manage Double Authentication';
  EditModules = 'Manage Modules';
  ModuleUserList = 'Modules List';
  ModuleExpiryDate = 'Expires on';
  ModuleType='Module Type';
  ModuleUserEdit = 'Module';
  ModuleIsActive = 'Module is active';
  MODULE_TYPE_SCHEDULE_MODULE = 'Schedules';
  MODULE_TYPE_TIMESHEET_MODULE = 'Timesheets';
  MODULE_TYPE_PAY_MODULE = 'PayRoll';
  MODULE_TYPE_PERFORMANCE_MODULE = 'Emprez BI';
  MODULE_TYPE_EXPENSE_MODULE = 'Expenses';
  MODULE_TYPE_HR_MODULE='Human Resources';
  NoExpiration = 'No Exp.';
  CarefulNotAProVersion = 'Not Emprez-Pro!';
  AccessToSchedule = 'Access to Schedule Module';
  AccessToTimesheet = 'Access to Timesheet Module';
  AccessToPay = 'Access to PayRoll Module';
  AllEmployees = 'All Employees';

  TemplatesAll = 'Current Version';
  TemplatesAllClassic = 'New Version';
  LastSearchResult = 'Last Search Results';
  SearchForEmployees = 'Search...';
  CreateOrImportAnEmployee = 'Create or Import an Employee';

  PunchParameters = 'Punchs Parameters';
  WarningWillOverrideParametersOfAllEmployees = 'Applied information will replace information of each employee.';
  MobileAndPortalAccesForEmployees = 'Mobile & Portal Access for Employees';

  SchedulesParametersAndMore='Schedules: Employees Options Configuration';
  TimesheetsParametersAndMore='Timesheets: Rounding, Graces, Stat. Holiday Calculation';
  DownloadCurrentStructureInXLS = 'Export Structure in Excel';
  StructureAndJobs = 'Structure & Positions';
  JobManagement = 'Manage Positions in the Structure';
  ManageUserAccessToUnits = 'Manage Users Access';
  Units ='Units';
  ChooseAUnit = 'Choose a Unit';
  CurrentPayPresentation = 'General';
  UpdateFromPayRoll = 'Retrieve information from PayRoll to update Employees File';
  Parameters = 'Parameters';
  CopyTemplate= 'Template Copy';
  NoticeCopyTemplates = 'Warning: this action will copy (and add) the information from one template to another.';
  FromTemplate = 'Copy from Template';
  ToTemplate = 'To Template';
  DoYouReallyWantToDeleteTheTemplate = 'Do you really want to remove all Schedules that are visible on the screen ?';
  ApprovingTimesheets='Timesheets Approval';
  ApprovingExpenses = 'Expenses Approval';

  EmployeesFile='Employees File';
  TemplatesManager = 'Templates Manager';
  AddSpifInBatch = 'Add Bonuses';
  SpifValue='Bonus';
  ShowSideBar = 'Display SideBar';
  HideSideBar = 'Show SideBar';

  ConfigureCCQConfigurationForEmployee='Modify CCQ Informations';
  CreateOrActivateCCQConfigurationForEmployee = 'Add or Activate CCQ Informations';
  ConfigurationCCQActive ='CCQ Informations will be used to export the PayRoll.';
  CCQWorkedHourCodeForPayRoll='Worked Hours Export Code';
  EnterpriseGroup = 'Enterprises Group';
  TooManyEnterpriseSelected = 'Too many Enterprises have been selected.';
  MaximumSelectionOfEnterpriseIs = 'You can\'t select more than {{max}} enterprises';

  ExportPaySummaryInSingleFile='Generate only one file with the selection';
  ExportPaySummaryFilePerEnterprise = 'Generate one file per Enterprise';
  SaveAndApplyToAllEmployeeShort='Save & Apply';
  SaveAndApplyToAllEmployee='Save & Apply to all Employees';
  FailedAuthentications='Authentications';
  FailedAuthenticationOlderThan = 'Authentication Errors since';
  NoFailedAuthentication='No Authentication Error';
  FAILED_AUTHENTICATION_TYPE_WRONG_USER='Wrong Username';
  FAILED_AUTHENTICATION_TYPE_WRONG_PWD='Wrong Password';
  FAILED_AUTHENTICATION_TYPE_WRONG_DOUBLE_AUTHENTICATION='Wrong Double Authentication';
  FAILED_AUTHENTICATION_TYPE_INACTIVE_USER = 'Inactive User';
  FAILED_AUTHENTICATION_TYPE_USER_HAS_NO_ENTITY='No Entity'
  FAILED_AUTHENTICATION_TYPE_PASSWORD_EXPIRED  = 'Password Expired';
  FAILED_AUTHENTICATION_TYPE_WRONG_ROLE  = 'Wrong Role';
  FAILED_AUTHENTICATION_TYPE_USER_TERMINATED  = 'Terminated';
  FAILED_AUTHENTICATION_TYPE_USER_ENTERPRISE_INACTIVE  = 'Enterprise is inactive';
  FAILED_AUTHENTICATION_TYPE_USER_HAS_NO_PAY_PARAMETERS  = 'No Pay parameters';
  FAILED_AUTHENTICATION_TYPE_USER_HAS_NO_ENTERPRISES  = 'No enterprises';
  FAILED_AUTHENTICATION_TYPE_USER_HAS_NO_UNIT  = 'No units';

  EventDate = 'Event Date';
  RemoteInfo = 'Provenance';
  UserAgent = 'Browser'
  DeleteExpired = 'Remove';
  DeleteExpiredTooltip = 'Remove Expired Sessions';

  SecurityPerEnterpriseTitle='Default Security Parameters for new Employees';
  PasswordWillExpire='Password will expire';
  PasswordExpirationInDays ='Password Expiration in days';
  FailedLoginDeactivateAccount='Too many authentication failures will block the account.';
  NbMaxOfFailedLogin='Maximum number of failed authentications';
  MinSizePwd='Password minimum length';
  MinNbUpperCase='Min. number of uppercase letters';
  MinNbLowerCase='Min. number of lowercase letters';
  MinSpecialChar='Min. number of special characters';
  MinNumberDigit='Min. number of digits';
  SecurityPerUser='Security Parameters';

  PasswordWillExpireAfter='Password will expire after {{passwordExpirationInDays}} days.<br>';
  PasswordWillNotExpire='Password will not expire.<br>';
  AccountWillBeDeactivated='The account will be deactivated after {{nbMaxOfFailedLogin}} failed attempts.<br>';
  NoLimitForFailedLogin='No limit on failed attempts.<br>';
  PasswordRules='Minimum password length is {{minSizePwd}} characters.<br>It must contain at least {{minNbUpperCase}} uppercase letters , {{minNbLowerCase}} lowercase letters, {{minSpecialChar}} special characters and {{minNumberDigit}} digits.';
  PasswordRulesLen='The minimum password length is {{minSizePwd}} characters.';
  NoPasswordRules = 'No special rule for the password length.';
  EditSecurityForUser='Modify Security Rules';
  PasswordValidationNoPassword='No Password';
  PasswordValidationMinLen='Min. Length is {{minLen}}';
  PasswordValidationMinUpper='You need {{need}} more uppercase letter(s)';
  PasswordValidationMinLower='You need {{need}} more lowercase letter(s)';
  PasswordValidationMinNumberDigit='You need {{need}} more digit(s)';
  PasswordValidationMinSpecialChar='You need {{need}} more special character(s)';
  ReactivateAccount='Reactivate Account';
  PrintingSortOrder='Sorting (Printing)';
  RetrieveAllAccessibleEmployees = 'All Employees';
  ApproveScheduledTime='Approve Schedule as it is.';
  DoYouReallyWantToDeleteTheNamedWorkShift='Do you really want to delete this alias?';
  NoteOnAddOrModifyJobAndHourlyBonusesBatch='The employee position will have exactly the selected premium and will be activated if it was inactive.';
  GoToDivision='Go to the Division'
  PaidFamilyLeaveType='Calculation Method';
  ExplainMinutesToPayForFamily = '{{minutes}} min. should be paid.';
  EmployeeIsTerminated ='Employé has been terminated.';
  SearchEmployeePlaceHolderClient='By <Lastname, Firstname> or by <, Firstname> or #<Employee Number> or !<Badge Number>';
  TemporaryInternetConnectionError='Temporary Internet Connection Error.';
  ParamsProfileManager = 'Parameters Profile Manager';


  ParamsProfileDescription='Description';
  ParamsProfileCreatedBy='Created by';
  AddParamsProfile='New Profile';
  EmpoyeeParamsForPunchPortalAndMobile='Punch, Web Portal and Mobile App Parameters';
  ParamsProfileAggregation='Parameters Profile (If no selection is made, your profile\'s parameters will be used.)';
  ParamsProfileIsActive='Profile is active';
  UsersWithAccessToThisParamsProfile='Users with access to this profile';
  ParametersForPunch='Punch Parameters';
  InformationAvailableOnPortalAndMobile='Available Information on Web Portal and Mobile Application';
  EmployeeJobAndBonusAndEnterprise = 'Position, Premiums and Paying Enterprise';
  ShowPayStubsOnPortal='Display Pay Slips (if available)';
  AddParamsProfileAggregation='Add a New Profile';
  YourDefaultParameters='Your default parameters';
  ParamsProfileInformation='A parameters profile allows you to quickly <u><b>copy</b></u> a group of configurations to <b>accelerate</b> employees creation, <i>specially if you are hiring many new employees.</i>.'

  ChangeUsernameOrBadgeTitle='Modification for ';
  ChangeUsernameOrBadge='Modify Username or Badge Number';
  NewBadgeNumber='New Badge';
  ChangeBadgeNumber='Save';
  NewUsername='New Username';
  ChangeUserName='Save';

  SELECT_CUSTOM_CODE='Multi-choice';
  TIMEZONE='TimeZone';
  BOOLEAN='Boolean';
  INTEGER='Integer';
  HOUR='Hours:Minutes';
  CreateUDataExportFileForEmployee='Export a file for RPA360';
  SendUDataExportFileForEmployee='Send to RPA360';

  NbDistinctEmployeesWithApprovedTimesheets='Nb of employees with at least 1 approved TS.';

  UDataUserCredentials = 'User - Connection uData';
  UDataPwdCredentials = 'Password - Connection uData';
  UDataAdministrativeUnit = 'Administrative Unit';
  UDataUserInCharge = 'User in charge of the process';
  SendEmployeeToUData = 'Send Employees Data to RPA360';
  ChooseTheEmployeeToSendToUData = 'Choose Employees to send';
  SendToUData='Send';
  VerifyEmployeeInformation='Employee Verification';
  LaunchVerificationOfEmployeesInformation='Start Verification';
  DetectedIssue='Description of a potential issue.';
  ExplainVerifyEmployee = 'Verifications are done on active and visible employees file between {{start}} and {{end}}.';
  NoIssuesFound='No issue found';
  PaidBy='Paid by';
  ContactUs='Contact Us';

  'StartTime-EndTime' = 'Start - End (HH:MM AM - HH:MM PM)';
  LunchStartEndTime = 'Start - End of Lunch Break (HH:MM AM - HH:MM PM)';
  SupperStartEndTime = 'Start - End of Supper Break (HH:MM AM - HH:MM PM)';
  WorkshiftStartEndTime = 'Shift Start - End (HH:MM AM - HH:MM PM)';
  BreakStartEndTime = 'Break Start (HH:MM AM)';
  'wrong.format.HH:MM' = 'Format is HH:MM AM';
  'wrong.format.HH:MM-HH:MM'='Format is \'HH:MM AM - HH:MM PM\'';

  DesjardinsLoginSubTitleContent='Schedule Planning - Manager Entrance';
  DesjardinsContactUsButtonLabel='Contact Us';
  DesjardinsContactUsButtonContent='<p>Support Time Management: 1-800-361-1324 #1 #5 #2<br>Support Punch Clock: 1-800-361-1324 #1 #5 #6<p>';


  NethrisContactUsButtonLabel='Contact Us';
  NethrisLoginSubTitleContent='Schedule Planning - Manager Entrance';
  NethrisContactUsButtonContent='<p>Support Time Management: 514-356-5001 #1 #5 #2<br>Support Punch Clock: 514-356-5001 #1 #5 #6<p>';

  PREFS_HOUR_FORMAT='Hour Format';
  HOUR_FORMAT_HOUR_24 = '24h';
  HOUR_FORMAT_HOUR_AM_PM = 'AM/PM';


  PunchCanAutoUpdate='Punch can update itself';
  PunchAutoUpdateUrl='Punch auto-update Url';
  WorkShifts='Work shift';
  RetailNextPosStoreId='Retail Next POS Store Id';
  EmployeePOSId='POS Id';
  ExportToRetailNext='Generate Export File for RetailNext';
  UDataServiceMenuLabel = 'Send Employees Info to RPA360';
  RetailNextMenuLabel='Generate Export for RetailNext';
  GenerateExportFile='Generate';

  BudgetTimeAndAmount='Budget Parameters';
  ExplainUsagerBudget = 'Maximum hours per week: {{budgetInMinutes}}, Maximum amount per week: {{budgetAmount}}';
  ExplainUsagerBudgetNoAmount = 'Maximum hours per week: {{budgetInMinutes}}';
  UsagerBudgetNotUsedInDashboard='Not used.';
  UsagerBudget='Budget';
  UsagerBudgetExplanation='Create a weekly budget which will notify the user when it is exceeded. Warnings will appear in the main dashboard.<br>Please note: this tool summarizes, in hours, all the schedules (published or not) for all the departments this user has access to (see user\'s rights).<br>Also if you are modifying budget for the connected user, you will need to logout and login again to see the changes.';
  BudgetInMin='Maximum number of hours per week';
  BudgetAmount='Maximum amount per week ($)';
  BudgetValidation='Budget Verification';
  CRMPanel='CRM - Clients';
  OnBoarding = 'Create Client (Enterprise, Structure and Administrator)';
  SearchByCRM='Search by CRM Id';
  EnterCRMId='Enter the client\'s Id from the CRM';
  NoCRMBeanFound='No Data Found.';
  CRMId = 'CRM Id';

  ZohoConfiguration='Zoho configuration to allow information exchanges';
  EnterZohoAuthorizationToken='Application Authorization Code';
  RetrieveAuthorizationToken='Retrieve';
  AuthorizeAccessToZoho='Authorize Access';
  ZohoAccessAuthorizedFor1Hour='Zoho Access authorized for 1 hour.';


  EnterZohoAccountName='Enter Zoho Account Name';
  ExactZohoAccountNameOrStartsWith='Exact name or the BEGINNING of the name.';
  SearchZohoAccount='Search';
  ExplainVacationsLeft = 'Days Remaining = Allowed ( + Deferred from Previous Period  - Anticipated from Previous Period) + Anticipated - Deferred - Used';



  PreviousPeriodHasRemainingDays = 'Previous period has still {{nb}} days left.';
  PreviousPeriodHasAheadDays = 'Previous period has {{nb}} anticipated days, they will be automatically substracted from the available days for the current period.';
  PreviousPeriodHasDeferredDays = 'Previous period has {{nb}} deferred days, they will be automatically added to the available days for the current period.';
  PreviousPeriodHasRemainingAmount = 'Previous period has still an unused amount of {{nb}}.';

  PreviousPeriodHasAheadAmount='Previous period has an anticipated amount of {{nb}}, it will be automatically substracted from the available amount for the current period.';
  PreviousPeriodHasDeferredAmount='Previous period has a deferred amount of {{nb}}, it will be automatically added to the available amount for the current period.';


  AllPunches = 'All Punches';
  AutoUpdate='Auto. Update (V2 & V3)';
  AutoUpdateUrl='Automatic Update Url (V2 & V3)';
  LastSeen='Last Connection';
  SurveyManager='Survey Manager';
  SurveyManagerNbQuestions='Questions';
  AddSurveyAggregation='New Survey';
  SurveyAggregationTitle='Survey';
  SurveyTitle='Name';
  SurveyIsActive='Active';
  SurveyDescription='Description (will be displayed to the user)';
  SurveyQuestions='Questions';
  NoSurveyQuestionsFound='No Question';
  SurveyQuestionTitle='Question';
  SurveyQuestionDescription='Label';
  SurveyQuestionIsActive='Active';
  SurveyQuestionType='Type';
  SURVEY_QUESTION_TYPE_YES_NO='Yes/No';
  SURVEY_QUESTION_TYPE_CHECK_CHOICE='Multi-Choices';
  SURVEY_QUESTION_TYPE_RADIO_CHOICE='Multi-Choices (Exclusive)';
  SURVEY_QUESTION_TYPE_ONE_TO_FIVE='Scale 1 to 5';
  SurveyAnswerChoices='Available Answers';
  NoSurveyAnswerChoicesFound='No Choice';
  AnswerChoiceTitle='Available Answer';
  AnswerChoice='Answer';
  SurveyTargetUnits='Target/Completed Surveys';
  SurveyTargetPopulation='{{nb}} targeted employees ({{completed}}% completed.)';
  EmployeeTargetedByThisSurvey='Choose targeted employees for the survey.';
  UseUnitsOrEnterpriseToSelectEmployeesToTarget='Please choose units and/or enterprises to define the employees to target for this survey.';
  EmployeesTarget='Define Target';
  DoYouReallyWantToResetTheSurveyResults = 'Do you want to re-submit the survey \'{{name}}\' to all employees, including those having already answered?';
  DoYouReallyWantToDeleteTheSurveyAggregation = 'Do you want to delete the survey \'{{name}}\'?';
  ResetSurveyResults='Re-submit the survey.';
  ExportResultsInJson='Export Survey Results in Json';
  ExportResultsInXls ='Export Survey Results in Xls';
  ExportResultsInJsonIfShift='Export Survey Results in XLS, for Json use Shift+Click.';
  NoSurveyTargetUnitsFound='Target is undefined.';
  EmployeeCompletedSurvey='Employee completed the survey.';
  RetrieveEmployees='Retrieve Employees';

  API_ACCESS_TYPE_CIBLE_RECHERCHE='Cible Recherche';
  API_ACCESS_TYPE_ALLIE_RH='Folks';
  API_ACCESS_TYPE_EMPREZ='Emprez';

  AllApiAccess='API Access';
  ListReportToEmail='Report to Email';
  ApiAccesses='API Access Manager';
  ApiAccessesManager='Autorized Accesses for External Features';
  ApiAccessType='Type of Feature';
  ApiKey='Unique Id';
  AddApiAccess='Add Access';
  ApiAccessIsActive='Access is authorized and active';
  ApiAccessToUser='Access';
  delayBetweenConnectionsInMs='Delay between connections (ms)';
  delayBetweenQueriesInMs='Delay between queries (ms)';
  DelayInMs='Delay in ms';
  ApplyModification = 'Apply Modifications';
  CancelModification = 'Cancel Modifications';


  DoYouReallyWantToDeleteTheApiAccessToUser='Do you really want to delete this access?';

  PrintAsXLS='Excel Report';
  PrintAsPDF='PDF Report';
  PrintAsPDFPlanning='PDF Report, Shift + Click for a Report per Planning.';

  DeleteWorkshift='Delete all Schedules';
  CopyTemplates='Copy Templates';
  DeleteTemplates='Delete all Templates';
  ShowPayInformation='Display Informations for the PayRoll';
  ShowTimeBankInformation='Display Time Banks';
  Modify='Modify';
  ApproveUnApproveTS='Approve or Un-Approve the Timesheet';
  DoYouReallyWantToDeleteTheParamsProfile='Do you want to delete this parameters profile?';

  IncludeSpifInHolidayCalculation='Must be included to calculate Stat. Holidays';
  IncludeSpifInVacationCalculation='Must be included to calculate Vacations';
  WillBeIncludedInHolidayCalculation  = 'Will be included to calculate Stat. Holidays.';
  WontBeIncludedInHolidayCalculation  = 'WONT be included to calculate Stat. Holidays.';
  WillBeIncludedInVacationCalculation = 'Will be included to calculate Vacations.';
  WontBeIncludedInVacationCalculation = 'WONT be included to calculate Vacations.';
  SpifTypeManagement='Bonus Type Management';
  HolidayManagement='Statutory Holidays Management';
  ManageStatutoryHolidays='Statutory Holidays Management';
  DoYouReallyWantToDeleteThisLine = 'Do you really want to delete this line?';

  SelectedEmployeeWillBePaidByTheEnterprise='Employees are paid by the following enterprise:';
  SelectedEmployeeWillHaveTheFollowingJob='Employees have the following position:';

  AddOrModifyBonusBatch='Add or Modify Hourly Premiums';
  ChangeToOtherLanguage = 'Français';
  DoYouReallyWantToDeleteThisContact='Do you really want to delete this contact?';
  DoYouReallyWantToDeleteThisDocument='Do you really want to delete this document?';

  AddEmailToAccount='Add an email';
  ShouldAddAnEmailToYourAccount='You should add an email to your profile, it will allow you to retrieve easily your password.';
  AddOrUpdateEmailToAccount = 'Email associated with your account';
  ShouldAddOrUpdateAnEmailToYourAccount = 'Add or verify the email associated with your profile, it will allow you to retrieve easily your password.';

  JobIncludedInTimesheetConsideredInCalculationForCumulativeBonus='Only the timesheets associated with the following positions will be used.';
  JobExcludedInTimesheetConsideredInCalculationForCumulativeBonus='The timesheets NOT associated with the following positions will be used.';
  HasJobIncludedExcludingJobWontBeApplied='This condition WONT be used if the previous condition is used.';
  IncludingJobs='This Cumulative Premium will ONLY use the Timesheets associated with the positions ({{included}}).';
  ExcludingJobs='This Cumulative Premium will use all Timesheets EXCEPT those associated with the positions ({{excluded}}).';

  OverrideJobExportStructure = 'Export codes for division, service, department and sub-department associated with the position and the employee will be replaced by {{division}}, {{service}}, {{department}} and {{subDepartment}}';
  UnitAndJob='Unit / Job';
  PayExportCode='PayRoll Code';
  TimesheetCode='Timesheet Type';
  UnitJobCustomPayExportTitle='Custom association between a PayRoll Code and a Position';
  EditUnitJobCustomPayExport='Associate a PayRoll Code to a Position';
  OverrideJobExportStructureCodes='Replace the employees associated codes with the following information';
  JobSortingOrder='Sorting Order for the Position is {{tri2}}';
  SortingOrderJobHighNumberWillBeFirst='Sorting Order (ascending)';
  NoUnitJobCustomPayExportBeans='No Information';


  TotalMinutesOtherSchedules='Other schedules: {{min}}';
  TotalAmountOtherSchedules = 'Other amount: {{info}}';
  TotalAmountWithVacationOtherSchedules = 'Other amount incl. vac. : {{info}}';
  SchedulesToBeFilled='Shifts to Fill';
  EmployeHoraireToFillValidation='Shifts to Fill Validation';
  NoAnswerReceivedYet='No answer yet.';

  APPROVAL_STATE_WAITING_APPROVAL='Waiting for approval';
  APPROVAL_STATE_APPROVED='Approved';
  APPROVAL_STATE_REJECTED='Refused';

  ShowApprovableWorkShiftsForWorkShift='Shifts to Fill';
  ShowApprovableExchangeWorkshift='WorkShifts Exchange';
  ApprovableShiftHeader='{{job}} <span class="muted">{{unit}}</span> on {{event}}, from {{start}} to {{end}}.';
  ApprovableShiftScheduleFound ='Existing schedule found on {{event}}, from {{start}} to {{end}}.';
  ApprovableShiftScheduleFoundNoHours ='Existing schedule {{eventType}} found on {{event}}.';

  NoApprovableWorkShiftsYet = 'No Answer yet.';
  NoApprovedWorkShiftsYet = 'No Selection (Approval) done.';
  NoAnswersYet='No Answer yet.';
  NoApprovedWorkShiftsYetButAnswersReceived = 'No Selection (Approval) done, {{nbAnswers}} answer(s) received.';
  WorkShiftHasBeenAssignedTo= ' has been assigned to {{fn}}';


  EmployeeVacationHourIsNullOrNegative = 'There is no vacation left.';
  VacationsLeftInMinutes='Available Vacations';


  WarningEmployeeMinutesLeft = '<span class="emprez-orange-fiesta">Attention, when all the following holidays will be approved and ready for PayRoll then the balance will be {{nbMinutesLeft}}.</span>';
  EmployeeMinutesLeft = '<span class="emprez-vert-agrume">When all the following vacations will be approved and ready for PayRoll then the balance will be  {{nbMinutesLeft}}.</span>';
  VacationDurationIs = '{{duration}}'
  AverageWageForVacations='Average Wage for Vacation';
  UseCCQParametersWhenExportingInPay='Use the following parameters when exporting to PayRoll.';
  UseStructureWhenExportingInPay='Use the following parameters when exporting to PayRoll.';
  UseSegmentsWhenExportingInPay='Use the following parameters when exporting to PayRoll.';
  UseSageIntacctWhenExportingInPay='Use the following parameters when exporting to Sage-Intacct.';
  EnterpriseVacationsAreInHoursMinutes='Vacation are in Hours';
  VimInitialMinutes='Vacation in Hours:Minutes (initial)';
  VimBalanceMinutes='Vacation Balance in Hours:Minutes';
  VimDayOfVacationInMinutes='One day of vacation in Hours:Minutes';
  VimAverageRate='Average Hourly Wage for Vacations';
  BalanceVacationInMinutes='Vacation Balance in Hours:Minutes';
  DisplayBonusPartOnly='Use only the Premium part';
  UsePartialHiringToAddEmployeeToPayroll='Use \'Partial Hiring\'';

  ShowApprovableVacationRequest='Vacation Requests';
  ApprovableVacationRequestHeader='{{employeeFullName}} would like to have vacation from {{start}} to {{end}}. (request sent on {{createdDate}})';
  ApprovableVacationRequestHeaderHour='{{employeeFullName}} would like to have vacation on {{dayOfVacation}} from {{start}} to {{end}}. (request sent on {{createdDate}})';
  RequestApproved='Request Approved';
  RequestRejected='Request Refused';
  VacationsInMinutesLeftForEmployee='The employee has {{leftTime}} Hr:min left for vacation, 1 day of vacation equal to {{oneDayInMin}}.';
  VacationsInDaysLeftForEmployee='The employee has {{left}} days(s) of vacation.';
  ActiveScheduleHasBeenFoundOn='A Shift \'{{label}}\' has been scheduled on {{refDt}} from {{startHour}} to {{endHour}}.';
  ActiveScheduleHasBeenFoundOnNoHours = 'A Shift \'{{label}}\' of {{typeHoraire}} has been scheduled on {{refDt}}.';
  UnitJobCustomPayExport='The following informations are linked to the \'{{name}}\'.';
  ExportHourlyRate='Export Hourly Wage';
  WontExportHourlyRate='The Hourly Wage won\'t be exported.';
  NoVacationsInMinutesForEmployee='No information about vacation is available.';
  AllMemos='Messages';

  NoCurrentWorkshiftToApprove='No Shift.';
  NoCurrentWorkshiftToExchange='No Shift.';
  NoCurrentVacationRequest='No Vacation Request.';
  ImportDone='Import done without errors.';
  PayStubFileName= 'Pay Slip: \'{{fileName}}\'';


  SearchForEmployee='Search for Employee(s)';
  SearchByEnterprise='By Enterprise';
  SearchByServiceDepartement='By Service and Department';
  SearchByLastNameFirstNameMatricule='By Lastname, Firstname or #EmployeeId';
  SelectPositionAndBonuses='Select the Position and the Premiums';
  BonusDate='Date';
  ChooseADate='Select a Date';

  OtherBadges='Other Time Punch Codes';
  EmployeeOtherBadgesList='Other Time Punch Codes Linked to the Employee';
  EditEmployeeOtherBadge='Add or Modify a Time Punch Code';
  NoVacationsFound='No Vacation Bank.';
  DoneBy='Done by';
  Solde='Balance';
  ApplyParamsProfileAggregationToPayParams='Select a profile to replace the values below';
  AddNamedWorkshift='Add a Predetermined Shift';
  NamedWorkshifts='Predetermined Shift Management';
  EditNamedWorkShiftRightsForUser='Modify Access Rights for a User';
  EditPlanningRightsForUser='Modify Access Rights for a User';
  EditParamsProfileRightsForUser= 'Modify Access Rights for a User';
  EditSpifTypeRightsForUser='Modify Access Rights for a User';
  HasAccess='Access Granted';
  WarningTitle='Warning';

  ApprovableShiftMoreInfoWeekScheduled='Hours already scheduled this week: {{scheduled}} hh:mm, with this shift the total will be {{willBeScheduled}} hh:mm.';

  ApprovableShiftMoreInfoWeekScheduledOvertime='<div class="emprez-orange-fiesta">Warning, if this shift is approved, the employee will do {{overtimeWillBe}} hh:mm of overtime.</div>';

  ApprovableShiftMoreInfoWeekApprovedTimesheets='Timesheets already approved this week: {{approved}} HH:MM.';
  ApprovableShiftMoreInfoSeniority='Seniority since {{seniorityDate}}, {{seniorityInDays}} days.';
  ApprovableShiftMoreInfoPriority = 'Priority on the position: {{priority}}.'

  ShiftClickToAddAnImage='Shift+Click to add a Picture';
  ShiftClickToEditAnImageCtrlClickToDelete='Shift+Click to change a Picture and Ctrl+Click to delete.';
  DoYouReallyWantToDeleteThisProfilePicture='Do you want to delete the picture?';

  EditPicture='Add or Modify a Picture';
  SpifDescription='Bonus';
  JobUnitDescription='Position';
  AllieRHReports ='Folks';
  ReportTXT = 'Rapport Standard';

  StartOfTaskLocation='Task Start';
  EndOfTaskLocation='Task End';
  CantDecideIfStartOfEndOfTask='Task';

  NoBudgetScheduled='No Schedules yet.';
  ExplainBudgetScheduled='Schedules totalling {{budgetInMinutes}} ({{budgetAmount}}) exist from {{startWeek}} to {{endWeek}}.';
  ExplainBudgetScheduledNoAmount='Schedules totalling {{budgetInMinutes}} exist from {{startWeek}} to {{endWeek}}.';
  BudgetManagement='Budget Management';
  AccessDenied='You don\'t have access to this feature.';

  EventManagement='Events Management';
  NoEventFound = 'No Event for the Selected Period.';
  EditDayEventAggregation='Event';

  ExplainDayEvent='On {{eventDtStr}} for {{unitDescription}}.';
  ExplainDayEventWithHour='On {{eventDtStr}} at {{eventHourStr}} for {{unitDescription}}.';
  DayEvent='Details';
  EventDt='Date';
  EventHour='Hour (optional)'


  SalesCostManagement='Sales and Ratios Sales/Costs Management.';
  NoDaySalesFound='No Sales Information.';
  ExplainDaySalesCostObjective='Sales of {{expectedSales}} have been scheduled on {{eventDt}} for {{unitDescription}}. Targeted Ratio Sales/Costs is {{ratio}}.';
  ExplainDaySalesCostObjectiveNoRatio='Sales of {{expectedSales}} have been scheduled on {{eventDt}} for {{unitDescription}}.';
  ExpectedSales='Expected Sales';
  RealSales='Real Sales';
  WantedRatio='Targeted Ratio Sales/Costs';
  EditDaySalesCostObjectiveAggregation='Ratio Sales/Costs';
  DaySalesCostObjective='Costs Target';
  ExplainDaySalesCostObjectiveRealSalesSales='Target: {{ratio}} of {{expectedSales}} (real) for {{unitDescription}}';
  ExplainDaySalesCostObjectiveExpectedSalesSales='Target: {{ratio}} of {{expectedSales}} (expected) for {{unitDescription}}';
  ExplainDaySalesCostObjectiveNotShowingAmount='Target: {{ratio}} of sales for {{unitDescription}}';

  CanManageEvent='Events Management';
  CanManageOtherBudget='Budgets Management';
  CanManageSalesCostObjective='Ratio Sales/Costs Management';
  DataSaved='Data Saved.';

  EmprezMessages='Emprez Notices';
  NoEmprezMessage='No Notice';
  EditEmprezMessage='Notice';
  MessageToDisplay='Message';

  EmprezMessage='Notice';
  GoToReadAboutTheEmprezMessage='Find out more by clicking here.';
  DontShowMeThisMessageAgain='Stop showing me this notice.';
  ShowDayEvents='Display Events';
  DoYouWantToDeleteAllSchedulesNotTimesheets='This position {{position}} is not active. Do you want to delete all schedules and templates that are linked with it ? Already approved timesheets won\'t be affected.';

  ShowApprovableSpecialAvailability='Unavailability Request';
  NoCurrentSpecialAvailabilityToApprove='No Unavailability Requests.';
  ShowApprovablePeriodicAvailability='Availability Request';
  NoCurrentPeriodicAvailabilityToApprove='No Availability Requests.';
  CantAccessPayingEnterprise='No Access to the employee paying enterprise';

  AllMemosWhoseAuthorIs = '{{nb}} memos have been created by {{name}} ({{nbActive}} are active)';
  AllMemosReceived= '{{nb}} memos have been received by {{name}} ({{nbActive}} are active)';

  InactiveClickToActivate = 'Inactive (Click to activate)';
  ActiveClickToDeActivate = 'Active (Click to de-activate)';

  GroupManagement='Employee Group Manager';
  PlanManagement='Plan Manager';
  AddPlan='New';
  NoteToEmployee='Note to the Employee';
  OtherFilters='Other Filters';
  AdjustmentDetails='Adjustment Details';
  Details='Details';
  ModifyLevelJobInBatch='Modify Position Level';
  SelectPosition='Select a Position';

  ModifyEmployeeSortOrderInBatch='Modify Employee Sorting Order';
  PositionLevel='Level';
  CanChangePositionOnSchedule='The employee can change the position scheduled';
  'schedule.position.different.ts'='Scheduled position is different than the position used.';
  'schedule.position.different.ts.extra'='Scheduled position {{schedule}} is different than the position used {{ts}}.';
  CreateHolidays='Add or Delete Statutory Holidays';
  AddHoliday='Add dates for Statutory Holidays';
  AddingHolidaysInBatch='Statutory Holidays will be added for the following dates.';
  RemovingHolidaysInBatch='If Statutory Holidays exist for specified date it will be deleted.';
  ChooseDate='Choose Date';
  VacationDuration='Vacation Duration in Hours:Minutes';
  DurationForTheWholeDay='Whole Day';

  VacationPerDayOrPerMinute = 'Vacations by day or by hour';
  OneOrSeveralWholeDays = 'By Day';
  SomeTimeDuringTheDay = 'By Hour';


  DoYouReallyWantToReactivateAllTheMemos='Do you really want to reactivate all memos?';
  DoYouReallyWantToDeactivateAllTheMemos='Do you really want to deactivate all memos?';
  ReactivateAll='Reactivate All';
  DeactivateAll='Deactivate All';
  ClickToEditEmployee='Click to edit employee';


  CommitmentAggregationManager='Documents to Sign by Employees';
  CommitmentTitle='Title';
  CommitmentCreatedBy='Created by';
  CommitmentTargetUnits='Signatures';
  NoCommitmentTargetUnitsFound='No Defined Target';
  EmployeeSigned='Signed by the Employee';
  CommitmentAggregationEdit='Document to Sign';
  CommitmentDescription='Description';
  CommitmentIsActive='Active';
  dueDt='Document must be signed before';
  AddCommitmentAggregation ='New';
  CommitmentTargetPopulation='{{nb}}/{{total}} targeted employees already signed ({{completed}}%)';
  UsersWithAccessToCommitment='Users with access to this commitment';

  ShiftClickToIncludeInactive='Shift + click to include inactives.';
  ExportResultsInPDF='Export to PDF';
  CommitmentHasAlreadyReceivedSignatures='Some Employees already signed the document \'{{file}}\', therefore you can\'t modify it anymore.';
  startOfWeekExplain = 'Start of Week: {{day}}.';
  NotSameDayOfWeek='Configuration Error, a unit has a different Start of Week.';
  DoYouReallyWantToDeleteTheCommitmentAggregation='Do you really want to delete \'{{name}}\' ?'
  DoYouReallyWantToResetThisCommitment= 'Do you really want to reset \'{{name}}\' ? All previous employees signatures will be erased, they will have to sign the document again.';
  ResetEmployeeCommitments='Reset Signatures';

  UseUnitsOrEnterpriseToSelectEmployeesToTargetForSignature='Choose Units and/or Enterprises to define the Employees that must sign the document \'{{name}}\'.';
  EmployeeTargetedToSignDocument ='Choose Employees that must sign the document';
  EditOrConsult='Modify/View';
  UnitsTargetToSignDocument='Employees working in those departments';
  EnterprisesTargetToSignDocument='Employees paid by those enterprises';


  OverBudgetAmount='{{diff}} is over budget.';
  OverBudgetMin='{{diff}} is over budget.';
  PicturesTakenByPunch='Pictures taken by the Punch';
  TakeOwnershipAndSave='Take Ownership & Save';
  ImportingTaxInformation='Import Tax Statements (T4 et Relevé 1)';
  PayTaxInformationFileName= 'Tax Statements: \'{{fileName}}\'';
  PayTaxInformationFormatType='Tax Statement Format';
  DropPayTaxInformationHere = 'Drop file here.';
  PAY_TAX_INFORMATION_FORMAT_TYPE_NETHRIS_ = 'Nethris-Desjardins';
  PAY_TAX_INFORMATION_FORMAT_TYPE_NETHRIS = 'Standard';


  EditShiftBonus='WorkShifts Premium';
  AddJobBonus='Add Position Premium';
  ShiftBonus='Workshifts Premiums';

  ChooseShiftBonus='WorkShift Premium';
  WorkShiftBonusActive='Premium is active';
  WorkshiftBonusStartEndTime='Begin - End';

  WorkShiftBonus='WorkShifts Premium';
  AddWorkShiftBonus='Add a Premium';
  NoWorkShiftBonusesFound='No Premium Found.';
  EditWorkShiftBonus='WorkShift Premium';



  ListAllMemo='List all Memos';
  GoToAuthoredMemos='Go to Sent Memos';
  GoToReceivedMemos='Go to Received Memos';
  NoStatus='No Status.';
  AddMemoStatus='Add a Status';
  DeleteMemoStatus='Delete Status';
  StatusDate='Date';
  StatusType='Type';


  EnterBadge='Enter a badge number';
  BadgeActive='Is Badge Active?';
  AddOrModifyEmployeeBadge = 'Add or Modify a Badge for Employees';


  DoYouReallyWantToDeleteThePay='Do you want to delete the information about that pay ?';
  NoEntriesFound='No Entry Found.';

  GeoFenceManager='GPS Zones Manager';
  GeoFenceName='Name';
  GeoFenceNameActive='Active Zone';
  GeoFenceCreatedBy='Author';
  EditGeoFence='Modify a GPS Zone';
  EditGeoFenceRightsForUser='Modify Access for a User';
  AddGeoFence='Add GPS Zone';
  UsersWithAccessToGeoFence='Users that can use this GPS Zone.';
  GeoFenceLat='Latitude';
  GeoFenceLon='Longitude';
  GeoFenceRadiusInMeter='Radius in meters (50m - 1000m)';
  CanManageGeoFence='GPS Zones Manager';


  GeoFence='GPS Zones';
  GeoFenceExplain='You can restrict the locations where the employee can punch to the following physical locations. (Works ONLY when punching with the mobile App) ';
  CustomCumulativePremiumExplain='Add Custom Cumulative Premiums'
  ChooseGeoFence='Selection';

  EnterpriseUsesJobSegment='Export with Work No. (Segments)';
  Segments='Segments';
  SegmentsNumeros='Segments - Work No.';
  Segment1='Segment 1';
  Segment2='Segment 2';
  Segment3='Segment 3';
  Segment4='Segment 4';
  Segment5='Segment 5';
  Segment6='Segment 6';
  TimesheetTotalIsNegative='Total is negative.';
  BlockOutOfSequenceButtons='Block out of sequence buttons(V2 & V3)';
  IncludeInactiveEmployee='Include Inactive Employees';
  ChangeStatusEmbauche='Modify Status';
  HiringDetailModifyStatus='Hiring Status Modification';

  EmployeeNotificationDetails='Employee Configuration';
  NotificationPref='Notification Preference';
  UpdateConfiguration='Save Preferences';
  ClickToAddSchedule='Click to add a Schedule';
  ShiftClickToSeeTheInactive='Shift + Click to Load All (Inactive & Active)';
  RemindMeLater='Remind Me Later';

  NotMemberYet='Not a member yet';
  ChatManager='Conversations Manager';
  NoChatRoomSelected = 'Please select a conversation or create a new conversation with the button below.';
  Invite = 'Invite';
  nbMembers = '{{nb}} members.';
  EnterYourMessageHere='Enter your message here';
  ChannelIsPublic='Public';
  ChannelName='Name';
  EditChatChannel='Chat';
  Members='Members';
  IfChannelIsPrivateWeWillInviteTheFollowing='Please select the members to add to your private chat';
  ClickToUse='Click to use';
  NoMessages='No Message';
  ClickToDeleteChannel='Delete this ChatRoom';
  ClickToLeaveChannel = 'Leave this ChatRoom';
  DoYouReallyWantToDeleteThisChannel='Do you want to delete the ChatRoom \'{{name}}\' ? (All messages will also be deleted.)';
  NewChatFrom='{{from}}: \'{{body}}\' in \'{{channel}}\'';
  NewPrivateChatFrom='{{from}}: \'{{body}}\'';
  TwilioServices='Twilio Services';
  TwilioServiceId='Twilio Service Id';

  DoYouReallyWantToDeleteThisTwilioService='Do you want to delete service \'{{name}}\'? The twilio service and all associated messages will be deleted.'

  BankManager='Custom Time Banks Manager';
  BankName='Name';
  BankCreatedBy='Author';
  EditBankTypeRightsForUser='Modify Rights for a User';
  AddBankType='Add a Bank';
  EditBankType='Time Bank Type';
  BankTypeName='Name';
  BankTypeActive='Bank is active';
  UsersWithAccessToBankType='Users that can use this Time Bank';
  DoYouReallyWantToDeleteThis='Do you want to delete \'{{name}}\'?';

  AddToBankCode='PayRoll Code When Adding';
  RemoveFromBankCode='PayRoll Code When Using (Removing)';
  SetBankCode='PayRoll Code When Setting the Balance';
  None='None';
  BankDetail='Exportation';
  explainBankType='Adding: {{add}}, Using: {{remove}} et Setting: {{set}}.';
  OtherBanks='Custom Time Banks';
  CanManageBankTypes='Can Manage Custom Time Banks';
  YouHaveMinutesInYourBankForPeriod='{{left}} hours in the bank from {{start}} to {{end}}. (A day equal to {{oneDayInMinutes}} hours.) ';
  YouHaveMinutesInYourBank='{{left}} hours in the bank. (A day equal to {{oneDayInMinutes}} hours.) ';
  BankWillUseYourCurrentRate='PayRoll exportation will use the employee hourly wage.';
  BankWillUseTheFollowingRate='PayRoll exportation will use {{rate}} as hourly wage.';
  TotalAmountWillBeExportedInThePayrollTooltip = "Calculated Total Amount will be exported to the Payroll. Usually it is not exported when the hourly wage and the hours are exported.";
  TotalAmountWillBeExportedInThePayroll ="Export Total Amount";
  BalanceCanBeNegative="Balance can be negative";
  SynchronizeWithAPI='Synchronize with API';
  VisibleByEmployee='Visible by the Employee';

  BankType='Bank';
  TimeInBankInMinutes='Balance in hours';
  OneDayInMinutes='A day is equivalent to hours (hh:mm)';
  HourlyWage='Hourly Wage';
  UseNormalEmployeeRate='Use the Employee\'s Hourly Wage';
  NoBankFound='No Bank Found';
  TimeFromBank='Used Duration';

  IfApprovedBankWillBeOverTheBalance='Too much time has been taken from the bank.';
  BankWontBeExportedInPay='This timesheet WON\'T be exported by the PayRoll.';
  BankTypeIsNotAvailableForEmployee='This bank is not associated with the employee.';
  EditBankTypeEmployeHoraire='Custom Time Bank';

  NoBankTypeTransactionFor='No modification has been found in Custom Time Banks for {{emp}}.';
  UsedInSchedulesOrTs='Used in Schedules/Timesheets';
  addedMinuteToBank='{{min}} hours:minutes added';
  removedMinuteFromBank='{{min}} hours:minutes substracted';

  RemovedFromBank='{{value}} hours:minutes deleted from the bank.';
  AddedToBank='{{value}} hours:minutes added to the bank.';
  BankSetTo='The Bank has been set to {{value}} hours:minutes.';
  WillBeExportedInPayRoll='Export by PayRoll';
  BankBalanceHasBeenModified='The balance has been modified on {{on}}.';
  BankTypeTransactions='Custom Time Bank Transactions';
  EditBankTypeTransaction='Custom Time Bank Transaction';
  TRANSACTION_TYPE_ADD='Add';
  TRANSACTION_TYPE_SET='Set';
  TRANSACTION_TYPE_REMOVE='Use/Remove'
  ExportInPay='The transaction will be exported by the PayRoll';
  TransactionType='Transaction Type';
  ValueInMinStr='Value HH:MM';
  BankTypeEmployeeTransactionInactive='<span class="emprez-orange-fiesta">Inactive</span>';
  BankTypeEmployeeTransactions='Custom Time Bank Transactions';
  EmployeeMustHaveBankTypeAssociated='The employee must have been previously associated with a Custom Time Bank.';
  AddBankTypeEmployeeInBatch='Add Custom Time Banks';
  AddOrDeleteBankTypeEmployeeInBatch = 'Add or Delete Custom Time Banks';

  BankTypeEmployeeInactive='&nbsp;<span class="emprez-orange-fiesta">Inactive</span>';
  BankTypeReports='Reports - Custom Time Banks';

  BANK_TYPE='Time Bank';
  BankTypeTransactionCantBeModifiedOrDeleted='Modifications are blocked because the bank has already been modified on {{balanceModifedOn}}.';
  NoTwilioServices='No Twilio Service has been created yet.';
  UsingBankTypes='Using Custom Time Banks';
  NotYetApproved='Not Approved Yet';

  BankWillBeUsedToCalculateStatutoryHolidaysTooltip='Hours will be added to worked hours (till reaching the overtime limit)  to calculate the statutory holidays.';
  BankWillBeUsedToCalculateStatutoryHolidays='Included for Statutory Holidays';
  BankTypeConsideredInCalculationForCumulativeBonus='The timesheets associated with the following Custom Bank Types will be used.';
  ChooseBankType='Custom Time Banks';
  EmployeeCanRequestBankType='Employee can submit requests to use his Custom Time Banks (subject to approval).';
  SurveyQuestionOtherRef='Other Reference';
  ModifyExportPayCodesUseFromPosition='Replace PayRoll exportation codes by the default codes found in your structure';
  IncludeInactivePositions='Include employees whose position is inactive';
  CreatePrivateChatChannel='Create a Private Channel';
  BonusAvailableForTsStartingOrAfter='&nbsp;<span class="emprez-orange-fiesta">From {{dt}}.</span>';
  BonusAvailableForTsEndingOrBefore='&nbsp;<span class="emprez-orange-fiesta">Till {{dt}}.</span>';
  BonusAvailableForTsBetween='&nbsp;<span class="emprez-orange-fiesta">For Timesheets from {{start}} till {{end}}.</span>';
  MessageNotRead='{{nb}} unread';
  MessageNotReadPlural='{{nb}} unread';
  CreatePublicChannel='Public Channel';
  UserWillAccessToBankType='The user will be able to use the selected banks.';


  ApprovablePaidFamilyDayRequestHeader='{{employeeFullName}} would like to take off {{refDate}} as a paid family day.';
  ApprovableUnPaidFamilyDayRequestHeader='{{employeeFullName}} would like to take off {{refDate}} as an unpaid family day.';
  ApprovableBankTypeRequestHeaderCompleteDay='{{employeeFullName}} would like to take off {{refDate}} from the bank \'{{bankName}}\'.';
  ApprovableBankTypeRequestHeader='{{employeeFullName}} would like to take off {{nbMin}} hours:minutes, on {{refDate}} from the bank \'{{bankName}}\'.';
  NoTimeLeftInBank='No time left in this bank.';
  TimeLeftInBankForEmployee='{{leftTime}} hours:minutes in this bank. (1 day is equivalent to {{oneDayInMin}} hours:minutes)';
  NoTimeBankForThisEmployee='This Custom Time Bank is not linked to this employee or has an error.';
  ShowApprovableBankTypeRequest='Custom Time Bank';

  ShowApprovableFamilyDaysRequest='Family Days';
  NoCurrentBankTypeRequest='No request found.';
  NoCurrentFamilyDayRequest='No request found.';
  BonusActiveFrom='From';
  BonusActiveFromMore='The WorkShift must start on the same day or later than the following date.';
  BonusActiveTo='To';
  BonusActiveToMore='The WorkShift must end on the same day or before the following date.';
  New='New';
  EmployeesWithAtLeastOneSchedule='Employees with at least one schedule in the selected period.';
  EmployeesWithAtLeastOneApprovedTS='Employees with at least one approved TS in the selected period.';
  AdminReporting='Reports';

  ImportSurveys='Import Surveys';
  SurveyImported='Import success!';
  CantImportSurvey='An Error occured while importing, please verify the format of the file.';
  UploadJSONFile='Drop your file here';
  StartDt='Begin';
  EndDt='End';
  AddMultiple='Add Several';
  DatesInvalid='Dates are not valid. Please verify that the beginning is before the end for example.';
  SchedulesDeleted='{{nb}} schedules that were scheduled after the termination date, have been deleted.';
  DeleteSchedulesAfterTerminationDate='Delete schedules in the future';
  DeleteSchedulesAfterTerminationDateTip='Delete schedules that were scheduled after the termination date';
  EmployeeCanPunch='Employee can punch';
  InitialSeniorityInMin='Accum. Hours (Init.)';
  SurveySortOrder='Sorting Order';
  Completed='Completed';
  ImportOneOrSeveralSurveys='Import one or several surveys';
  ExportAllResults='Export all results for all surveys';
  ClickToSelectEmployeeThatCanPunch='Click to select only the employees that can punch';
  ClickToSelectInactiveEmployeeThatCanPunch='Click to select only the (inactive only) employees that can punch. (Shift+Click will deselect the inactive only employees)';


  DoYouReallyWantToDeleteThisEmployeeFromThisTask='Do you really want to remove {{fn}} {{ln}} from the task {{description}}?';
  DoYouReallyWantToChangeThisUsername='<span style="color:red">DANGER!</span><br>Do you really want to change this username?<br><br>It will <span style="color:red">be completly deleted</span> as weel as all its references. (Surveys (and Answers), Custom Time Banks, Plans,...)';
  YesIKnowWhatIamDoing='Yes, I know what I am doing.';

  UseDepartureDate='Import Departure Date';
  UseDepartureDateTip='Emprez will terminate the employee at the departure date. (Shift+Click to unselect all.)';
  UpdateVacationInformation='Update Vacation Banks';
  UpdateVacationInformationTip='Emprez will reset the vacation banks with the information in the Payroll. (Shift+Click to unselect all.)';

  UseReHiringDate='Import Rehiring Date';
  UseReHiringDateTip='Emprez will add a Hiring at the ReHiring date. (Shift+Click to unselect all.)';
  NbEmployeesTarget = '{{nb}} employees, {{nbPunch}} can punch, {{nbInactive}} are inactive, {{nbNoSurvey}} employees are not targeted. Current Selection: {{selection}}.';
  UpdateCustomTimeBanksTip = 'Emprez will update Custom Time Banks if necessary, value will be set to what is sent from the API (Shift+Click to unselect all.)'
  UpdateCustomTimeBanks='Update Custom Time Banks';


  AdministrativeRights='Administrative Rights';
  GrantablePreferences='Preferences';

  SURVEY_TYPE_GENERIC='Standard';
  SURVEY_TYPE_COVID_19='Covid-19';

  SurveyOtherRef='Other Ref.';
  SurveyIsReadonly='Read only';
  SurveyType='Type';
  ExportToXLS='Export to XLS';
  TimeBankHourlyWage='Specific hourly wage to be used';

  CustomCumulativePremiumConfiguration='Custom Cumulative Premiums';
  AvailableCustomCumulativePremiums='Available Premiums';

  EditCustomCumulativePremiumConfiguration = 'Configuration - Custom Cumulative Premiums';
  DailyCumulativePremiumConfiguration6000 = 'Daily Configuration';
  DailyCumulativePremiumConfiguration6004 = 'Daily Configuration';
  DailyExportCode = 'Payroll Code';
  DailyName = 'Name (Reporting)';
  DailyCondition = 'When the total hours';
  DailyConditionAmount = 'HH:mm';
  DailyCumulativeBonusPercent = 'Premium';
  DailyCumulativeBonusAmount = 'Premium';

  WeeklyCumulativePremiumConfiguration6000 = 'Weekly Configuration';
  BiWeeklyCumulativePremiumConfiguration6004 = 'Bi-Weekly Configuration (2 weeks)';
  WeeklyExportCode = 'Payroll Code';
  WeeklyName = 'Name (Reporting)';
  WeeklyCondition = 'When the total hours';
  WeeklyConditionAmount = 'HH:mm';
  WeeklyCumulativeBonusPercent = 'Premium';
  WeeklyCumulativeBonusAmount = 'Premium';
  


  TheEmployeeHadASalaryModification='The salary has been from modified on {{on}} from {{from}} to {{to}}. Do you want to add or update this modification to the employee\'s file?';
  SalaryUpdateReceivedIsTooLate='Refusing the salary update made on {{receivedUpdate}}, it is before the last modification on file {{lastUpdate}}.';

  REMOTE_ACCESS_TYPE_TEAMVIEWER='Teamviewer';
  REMOTE_ACCESS_TYPE_ZOHO_ASSIST="Zoho-Assist";
  RemoteAccessType='Remote Access Type';
  RemoteAccessName='Remote Access Name in Zoho-Assist or Teamviewer';
  IncludeInactivePosition='Include Inactive Positions';
  IncludeInactivePositionTip='Recipients with an inactive position will be included.';
  IncludeInactiveEmployeeTip='Not terminated and inactive employees (ex: Maternity Leave,...) will be included.';


  RUN_EVERY_TYPE_DAY='Daily';
  RUN_EVERY_TYPE_WEEK='Weekly';

  Frequency='Frequency';
  EmailTitle='Email Title';
  EmailBody='Email Body';
  EmailRecipients='Recipient';
  SendThisReportByEmailTip='You can send this report weekly or daily.';
  OUTPUT_TYPE_PDF='Pdf';
  OUTPUT_TYPE_XLS='Excel';
  OUTPUT_TYPE_XLSX='Excel';
  OUTPUT_TYPE_TXT='Text';
  HelloHereIsTheRequested = 'Hello {{name}},<br>Please find the report you were asking for.<br>Thank you.<br>Your team Emprez.';
  ReportToEmailTitle='Report by Email';
  ReportToEmailIsActive='Report is active';
  ReportToEmails='Reports by email';
  ReportToEmailName='Name';
  ReportToEmailRecipients='Recipients'
  ReportToEmailFrequency='Frequency';
  UserCanModifyCostDistribution='Can Modify the Cost Distribution';
  UserCanModifyCostDistributionTip='The employee can modify the export codes for the Pay (Division, Service,... ) or segments.';
  CanModifyOwnProfile='Can Modify his Personal Information';
  NbSegmentUsed='Number of segments used';
  Segment1Label='Segment1 Label (optional)';
  Segment2Label='Segment2 Label (optional)';
  Segment3Label='Segment3 Label (optional)';
  Segment4Label='Segment4 Label (optional)';
  Segment5Label='Segment5 Label (optional)';
  Segment6Label='Segment6 Label (optional)';
  EditEnterpriseCostDistributionConfig='Configuration';
  EnterpriseCostDistributionConfig='List of possible values per type (optional)';
  CostDistributionType='Type';
  COST_DISTRIBUTION_TYPE_SEGMENT1='Segment1';
  COST_DISTRIBUTION_TYPE_SEGMENT2='Segment2';
  COST_DISTRIBUTION_TYPE_SEGMENT3='Segment3';
  COST_DISTRIBUTION_TYPE_SEGMENT4='Segment4';
  COST_DISTRIBUTION_TYPE_SEGMENT5='Segment5';
  COST_DISTRIBUTION_TYPE_SEGMENT6='Segment6';

  COST_DISTRIBUTION_TYPE_DIVISION='Division';
  COST_DISTRIBUTION_TYPE_SERVICE='Service';
  COST_DISTRIBUTION_TYPE_DEPARTMENT='Department';
  COST_DISTRIBUTION_TYPE_SUBDEPARTMENT='Sub-Department';

  COST_DISTRIBUTION_TYPE_SI_ACCUMULATION_TYPE='Accumulation';
  COST_DISTRIBUTION_TYPE_SI_COST_TYPE='Cost Type';
  COST_DISTRIBUTION_TYPE_SI_TIME_TYPE ='Time Type';
  COST_DISTRIBUTION_TYPE_SI_LABOR_CLASS='Labor Class';
  COST_DISTRIBUTION_TYPE_SI_LABOR_SHIFT='Labor Shift';
  COST_DISTRIBUTION_TYPE_SI_LABOR_UNION = 'Labor Union';
  COST_DISTRIBUTION_TYPE_SI_DEPARTMENT='Department';
  COST_DISTRIBUTION_TYPE_SI_LOCATION='Location';

  EnterprisesPerEntity='Enterprises by entity';
  ShowDivisionsByEntity='Divisions by entity';
  ShowCRM='Display in the CRM part of Emprez';
  ShowInZoho='Display in the external CRM (Zoho)';
  CostsDistributionsTitle='Costs Distribution (If Empty distribution will be done according to the position)';
  SendCredentialsToEmployee='Send access information by email';
  PrintCredentialsForEmployee='Print access information';
  SegmentsConfiguration='Segments Configuration';
  DoYouReallyWantToDeleteThisValue='Do you really want to delete this value?';

  UpdateAllApiPassword='All API passwords';
  UpdateAllApiPasswordTip='Update all passwords for all enterprises sharing the same API username, API code and the same API Test WebService flag.';
  DoYouReallyWantToUpdateApiPassword='Do you want to update the password \'{{password}}\' for all the enterprises using the API code \'{{enterpriseCode}}\' AND the API username \'{{username}}\' AND having the Test WebService flag set to \'{{testMode}}\'?';
  _RetrieveSegmentsConfiguration='Retrieve configuration from {{payRoll}}';
  RetrieveSegmentsConfiguration='Retrieve Configuration';


  SyncAPIConfigTip='You can automatically synchronize the informations about your employees daily.';
  UpdateFromSyncAPITitle='Employees Synchronization for \'{{name}}\'';
  UpdateFromSyncAPIBody= 'Hello {{name}},<br> The informations about your employees have been updated.<br>Have a good day.<br>Your Team Emprez.';
  SyncAPIConfigTitle='Synchronization';
  SyncAPIConfigIsActive='Synchronization is active';
  ChangePeriod='Choose another period';
  OutputType='Output';
  EmployeesStatus='Employees Status';
  TypeOfAbsence='Absence Type';
  NbOfAbsences='Number of Absences';
  ShowAllAbsences='Show all absences';
  LateArrival='Late Arrival';
  LateArrivals='Late Arrivals';
  LateArrivalsAndHours='Late Arrivals (HH:MM)';
  NonAuthorizedAbsences='Non Authorized Absences';
  AuthorizedAbsences='Authorized Absences';

  EmployeeHrPerformances='Employee Performance'
  WorkedTS='Work';
  AbsencesTotal='Absences';
  EntrainementsAndFormations='Shadowings & Trainings';
  Entrainements='Shadowings';
  Formations='Trainings';

  ACCIDENT_TYPE_CAR_ACCIDENT='Car Accident';
  ACCIDENT_TYPE_AGGRESSION='Aggression';
  ACCIDENT_TYPE_ALLERGY='Allergy';
  ACCIDENT_TYPE_AMPUTATION='Amputation';
  ACCIDENT_TYPE_BURN='Burn';
  ACCIDENT_TYPE_FALL='Fall';
  ACCIDENT_TYPE_CONCUSSION='Concussion';
  ACCIDENT_TYPE_FOREIGN_BODY='Foreign Body';
  ACCIDENT_TYPE_HEATSTROKE='Heatstroke';
  ACCIDENT_TYPE_CUT='Cut' ;
  ACCIDENT_TYPE_COVID_19='Covid-19' ;
  ACCIDENT_TYPE_DEPRESSION='Depression' ;
  ACCIDENT_TYPE_PAIN='Pain';
  ACCIDENT_TYPE_DAZZLE='Dazzle' ;
  ACCIDENT_TYPE_BRUISE='Bruise';
  ACCIDENT_TYPE_CONTUSION='Contusion' ;
  ACCIDENT_TYPE_EXCESSIVE_EFFORT='Excessive Effort';
  ACCIDENT_TYPE_ELECTROCUTION='Electrocution';
  ACCIDENT_TYPE_SWELLING='Swelling';
  ACCIDENT_TYPE_SPRAIN_STRAIN_DISLOCATION='Sprain/Strain/Dislocation';
  ACCIDENT_TYPE_FRACTURE='Fracture';
  ACCIDENT_TYPE_SLIP_STUMBLE='Slip or Stumble';
  ACCIDENT_TYPE_HIT_STRANDED='Hit or Stranded';
  ACCIDENT_TYPE_FIRE_EXPLOSION='Fire or Explosion';
  ACCIDENT_TYPE_POISONING='Poisoning';
  ACCIDENT_TYPE_SUPERFICIAL_LESION='Superficial Lesion';
  ACCIDENT_TYPE_DISCOMFORT='Discomfort';
  ACCIDENT_TYPE_REPETITIVE_MOVEMENT='Repetitive Movement';
  ACCIDENT_TYPE_SURGERY='Surgery';
  ACCIDENT_TYPE_BITE='Bite';
  ACCIDENT_TYPE_OPEN_DEEP_WOUND='Open or Deep Wound';
  ACCIDENT_TYPE_HARMFUL_SUBSTANCE='Harmful Substance';
  ACCIDENT_TYPE_OTHER='Other';


  WORK_ACCIDENT_FILE_STATUS_TYPE_OPEN='Open';
  WORK_ACCIDENT_FILE_STATUS_TYPE_CONSOLIDATED='Consolidated';

  BODY_REGION_TYPE_HEAD = 'Head';
  BODY_REGION_TYPE_FACE = 'Face';
  BODY_REGION_TYPE_EYE = 'Eye';
  BODY_REGION_TYPE_EAR = 'Ear';
  BODY_REGION_TYPE_TEETH = 'Teeth';
  BODY_REGION_TYPE_NECK = 'Neck';
  BODY_REGION_TYPE_CHEST = 'Chest';
  BODY_REGION_TYPE_LEFT_SHOULDER = 'Left Shoulder';
  BODY_REGION_TYPE_RIGHT_SHOULDER = 'Right Shoulder';
  BODY_REGION_TYPE_LEFT_ARM = 'Left Arm';
  BODY_REGION_TYPE_RIGHT_ARM = 'Right Arm';
  BODY_REGION_TYPE_LEFT_ELBOW = 'Left Elbow';
  BODY_REGION_TYPE_RIGHT_ELBOW = 'Right Elbow';
  BODY_REGION_TYPE_LEFT_FOREARM = 'Left Forearm';
  BODY_REGION_TYPE_RIGHT_FOREARM = 'Right Forearm';
  BODY_REGION_TYPE_LEFT_WRIST = 'Left Wrist';
  BODY_REGION_TYPE_RIGHT_WRIST = 'Right Wrist';
  BODY_REGION_TYPE_LEFT_HAND = 'Left Hand';
  BODY_REGION_TYPE_RIGHT_HAND = 'Right Hand';
  BODY_REGION_TYPE_LEFT_FINGERS = 'Left Fingers';
  BODY_REGION_TYPE_RIGHT_FINGERS = 'Right Fingers';
  BODY_REGION_TYPE_LEFT_HIP = 'Left Hip';
  BODY_REGION_TYPE_RIGHT_HIP = 'Right Hip';
  BODY_REGION_TYPE_LEFT_THIGH = 'Left Thigh';
  BODY_REGION_TYPE_RIGHT_THIGH = 'Right Thigh';
  BODY_REGION_TYPE_LEFT_KNEE = 'Left Knee';
  BODY_REGION_TYPE_RIGHT_KNEE = 'Right Knee';
  BODY_REGION_TYPE_LEFT_LOWER_LEG = 'Left Lower Leg';
  BODY_REGION_TYPE_RIGHT_LOWER_LEG = 'Right Lower Leg';
  BODY_REGION_TYPE_LEFT_ANKLE = 'Left Ankle';
  BODY_REGION_TYPE_RIGHT_ANKLE = 'Right Ankle';
  BODY_REGION_TYPE_LEFT_FOOT = 'Left Foot';
  BODY_REGION_TYPE_RIGHT_FOOT = 'Right Foot';
  BODY_REGION_TYPE_LEFT_TOE = 'Left Toe';
  BODY_REGION_TYPE_RIGHT_TOE = 'Right Toe';

  LESION_TYPE_AGGRAVATION = 'Aggravation';
  LESION_TYPE_GRADUAL_ONSET = 'Gradual Onset';
  LESION_TYPE_NEARLY_ACCIDENT = 'Nearly Accident';
  LESION_TYPE_RELAPSE = 'Relapse';
  LESION_TYPE_DECEASED = 'Deceased';
  LESION_TYPE_PRECISE_AND_SUDDEN_EVENT = 'Precise and Sudden Event';
  LESION_TYPE_PROFESSIONAL_SICKNESS = 'Professional Sickness';


  EmployeeWorkAccidents='Work Accidents';
  AccidentDate='Accident Date';
  LesionTypes = 'Lesions Type';
  AccidentTypes = 'Accidents Type';
  BodyRegionTypes = 'Body Regions';

  HealthFile = 'Health-Security File';
  HowOccursTheAccident='Explain how the accident or disease occured';
  NbDaysOfAbsence = 'Nb of days of absence';

  TemporaryAssignment='Temporary Position';
  TemporaryAssignementNote='Notes about the Temporary Position';
  CorrectiveAction='Corrective Measures';
  CorrectiveActionNote='Note about the corrective measures';
  FileStatus='File Status';
  ConsolidationDate='Consolidation Date';
  DoYouReallyWantToDeleteThisCommand = 'Do you want to delete the command \'{{ cmd }}\'? ';
  ZK_PUNCH_COMMAND_STATUS_READY='Ready to be sent';
  ZK_PUNCH_COMMAND_STATUS_NEW='New';
  ZK_PUNCH_COMMAND_STATUS_SENT='Sent';
  ZK_PUNCH_COMMAND_STATUS_DONE='Response Received';
  ZK_PUNCH_MODEL_S900='S900';
  ZK_PUNCH_MODEL_S905='S905';

  CommandRequested='Query';
  CommandStatus='Status';
  ReturnCode='Return Code';
  CommandReturned='Received Response';

  SerialNumber='Serial Number';
  ServerVersion='Server Version';
  ErrorDelayInSeconds='Delay between connections errors (sec.)';
  DelayBetweenServerAccessInSeconds ='Delay between connections (sec.)'
  DelayClockSyncTimeWithServerInSeconds ='Delay sync Time (sec.)'
  IntervalInMinutesBetweenCheckingAndSendingNewData='Delay Verif. & Send (min.)';
  RealTime='Real Time';
  TransmissionTimes='Transmission Times (; max 10)';
  TransFlags='Transfert Flags'
  MappedValueForCheckIn='Mapping Punch \'Arrival\'';
  MappedValueForCheckOut='Mapping Punch \'Departure\'';
  MappedValueForMealStart='Mapping Punch \'Meal Start\'';
  MappedValueForMealEnd='Mapping Punch \'Meal End\'';
  MappedValueForBreakStart='Mapping Punch \'Break Start\'';
  MappedValueForBreakEnd='Mapping Punch \'Break End\'';
  MappedValueForWorkCode='Mapping Punch \'Work Code\' - Must be 254 if required';
  MappedValueForOther='Mapping Punch \'Other\'';

  BadgeType='Type';
  EMPLOYEE_BADGE_TYPE_CARD='Card';
  EMPLOYEE_BADGE_TYPE_CODE_ZK='ZK Code';


  LastAttendanceOK='<span class="emprez-vert-agrume">Punches Last Transmission {{dt}}.</span>';
  LastAttendanceWarning='<span class="emprez-orange-fiesta">Punches Last Transmission {{dt}}.</span>';
  LastAttendanceError='<span class="emprez-rouge-matador">Punches Last Transmission {{dt}}.</span>';
  LastClockSyncOK='<span class="emprez-vert-agrume">Last Clock Dernière synchronization de l\'horloge {{dt}}.</span>';
  LastClockSyncWarning='<span class="emprez-orange-fiesta">Dernière synchronization de l\'horloge {{dt}}.</span>';
  LastClockSyncError='<span class="emprez-rouge-matador">Dernière synchronization de l\'horloge {{dt}}.</span>';

  LastHeartBeatOK='<span class="emprez-vert-agrume">Last heartbeat {{dt}}.</span>';
  LastHeartBeatWarning='<span class="emprez-orange-fiesta">Last heartbeat {{dt}}.</span>';
  LastHeartBeatError='<span class="emprez-rouge-matador">Last heartbeat {{dt}}.</span>';

  ZkWorkCode='WorkCode';
  DoYouReallyWantToDeleteThisWorkCode='Do you want to delete code \'{{code}}\' for \'{{jobLabel}}\' ?';
  SessionLostPleaseReconnect='You session expired, you will need to reconnect to continue.';
  EditZkPositionWorkCode='WorkCode';

  GenerateCommandsForEmployees='Generate requests for \'Employee\'';
  GenerateCommandsForPositions='Generate requests \'WorkCode\'';
  NoCommandsFound='No Requests';
  ToBeRemovedFromZkPunch='To be removed from punch';
  RemoveFromZkPunch='Remove from punch';


  Performances='Emprez BI';
  Actives='Actives'
  Inactives='Inactives';
  NewPlural='New';
  TerminatedPlural='Terminated';

  IndustryClassification='Classification';
  MANUFACTURING_31= 'Manufacturing';
  CAR_AND_PART_DEALER_441='Cars and parts dealer';
  GROCERIES_445='Grocerie';
  PHARMACIES_446='Pharmacy';
  SPORTING_HOBBY_STORE_451='Sporting, Hobby Store'
  GENERAL_STORE_452='General Store'
  TRANSPORT_48='Transport';
  TRANSPORT_AIR_481 = 'Transport Air';
  TRANSPORT_WATER_483 = 'Transport Water';
  TRANSPORT_TRUCK_484 = 'Transport Truck';
  WAREHOUSE_493 = 'Warehouse';
  DESIGN_SERVICE_5414 = 'Design Service';
  VETERINARY_SERVICE_54194 = 'Veterinary';
  NURSING_RESIDENTIAL_FACILITIES_623 = 'Nursing, Residential Facility';
  PHYSICIANS_OFFICES_6211='Offices of Physicians';
  FOOD_SERVICES_AND_DRINKING_PLACES_722='Food Services and Drinking Places';
  PERSONAL_CARE_SERVICES_8121='Personal Care Services';

  UNKNOWN = 'Unknown';
  EditStructureAndDivision='Click to display and modify the structure. Shift+Click to modify only the division.';
  EmployeePerformancePerMonth='Monthly Performances - ';
  AbsencesRatio='Absenteeism';
  LateArrivalRatio='Lateness Ratio';

  PerformanceModuleReports='Reports - Emprez BI';
  PerformanceModuleDashboard='Emprez BI';
  NoInformationFound='No information';
  RetrieveCommitmentFile='Download the document';
  DoYouReallyWantToDeleteAllTheTemplates='Do you really want to delete all the templates?';
  ExtendedMeals='Meals';
  ExtendedMealsAndHours='Meals (HH:MM)';
  ExtendedMealsTip='Meals duration is too long';
  ExtendedBreaks='Breaks';
  ExtendedBreaksAndHours='Breaks (HH:MM)';
  ExtendedBreaksTip='Breaks duration is too long';
  LateDepartures='Late End of WorkShifts';
  LateDeparturesTip='Late End of WorkShifts';


  TotalMoreTSThanScheduledInMin='Worked hours that exceed the scheduled hours.';
  TotalMoreTSThanScheduled = 'Timesheets with worked hours that exceed the scheduled hours.';

  NumberOfMoreTSThanScheduled='Nb of TS with an excess';
  NumberOfMoreTSThanScheduledInMin='Total Duration (hh:mm)';
  MoreTSThanScheduled='Excess';
  MoreTSThanScheduledTip='Worked hours that exceed the scheduled hours.';
  NewPluralTip='Employees arriving this month.'
  TerminatedPluralTip='Employees leaving this month.';
  TotalAbsenteeism='Absenteeism (%)';
  EmployeeIsIncludedInPerformanceRH='Included in Emprez BI';

  JobNumbersNoSegment = 'Job Number';
  PasswordsAreHiddenForThisEnterprise='Passwords are hidden for this enterprise';
  PasswordsAreHidden='Passwords are hidden';
  UsernamesAreHidden = 'Usernames are hidden';
  PunchBadgesAreHidden = 'Badges for punching are hidden';
  EmployeeDOBHidden = 'DOB are hidden';
  EmployeeAddressHidden = 'Addresses are hidden';
  EmployeeCityHidden = 'Cities are hidden';
  EmployeePostalCodeHidden = 'Postal Codes are hidden';
  EmployeeProvinceOrStateHidden = 'Provinces are hidden';
  EmployeeCountryHidden  = 'Countries are hidden';
  EmployeeEmailHidden = 'Emails are hidden';
  EmployeeTelephoneHidden = 'Telephone are hidden';


  SetAnExpiryDateOnSelection = 'Expiry date on Selection';
  DeactivateSelection = 'Deactivate Selection';
  ActivateSelection = 'Activate Selection';
  NeedsToSelectSomeModules='You need to select at least one module.';

  CanLockTimesheet = 'Lock Timesheets';
  CanUnlockAllTimesheet = 'Unlock All Timesheets';
  LockAllTip='Lock all approved timesheets';
  UnLockAllTip='Unlock all locked timesheets depending on your rights.';
  LockAllExpenseTip='Lock all approved expenses';
  UnLockAllExpenseTip='Unlock all locked expenses depending on your rights.';


  LockAllTimesheets='Lock all timesheets';
  LockAllExpenses = 'Lock all expenses';
  ExportOnlyExpenses = 'Export only expenses';

  ExplainLateArrival = 'Explain Late Arrival (V3)';
  ExplainEarlyDeparture = 'Explain Early Departure (V3)';
  ExplainLateDeparture= 'Explain Late Departure (V3)';
  AlwaysExplainArrival = 'Always Explain Arrival (V3)';
  AlwaysExplainDeparture = 'Always Explain Departure (V3)';
  ExplicationsDeparturePipedSeparated ='Explications Departure (V3)'
  ExplicationsArrivalPipedSeparated ='Explications Arrival (V3)'
  AlwaysExplainTaskBeginning='Always Ask for Note for Task Beginning (V3)';
  AlwaysExplainTaskEnding='Always Ask for Note for Task Ending (V3)';


  MsgNotRead='Not Read';
  SeeTheWholeMemoThread='Display the whole thread';
  ShiftClickToActivateDeactivateSelection='Activate a selection, Shift+Click to deactivate a selection';
  ActivateSurveyAggregations='Activate a selection';
  DeactivateSurveyAggregations='Deactivate a selection';
  TheSelectedUserHasAccessToTheFollowing='The selected user has access to the following';
  ModuleExpiredOn='Module will expire on {{expiryDt}}.';
  AccessToModule='Access to Module';


  DetailsButtonExplanation='\'Details\' will show employees responsibles for these situations.';
  NbOfTimesheets='Nb of Timesheets';
  NbOfAbsencesInPercentage='Absenteism Ratio';
  NbOfAbsencesInPercentageEmprezIndice='Emprez Index';
  HowToImproveTheSituation="How to improve the situation";
  HowToImproveTheSituationForTooLongMeals="Your employees are not punching meals?";
  HowToImproveTheSituationForTooLongBreaks="Your employees are not punching breaks?";
  ThisIsWhyTheyShould="This is a reason why they should.";
  ClickHere='Click here.';

  ExplainWhyTSHaveToBeApproved='In order to get the right calculation, it is mandatory that the timesheets are approved.';
  HowToDoItWell='How to do it well.';
  AbsenteismForThePeriod='Absenteism ratio for the period';
  AbsenteismForThePeriodEmprezIndice='Emprez Index';
  TotalHoursScheduled='Scheduled Hours';
  TotalHoursApproved='Approved Hours';
  ExtraTS='Exceeding Hours';
  ExtraTSRatio='Exceeding Hours (%)';
  ExtraTSRatioEmprezIndice='Emprez Index (%)';

  WhyBreaksShouldBePunched='Why \'Employees Breaks\' should be punched?';
  EmprezIndice='Emprez Index';
  NbOfLateArrivals='Late arrivals in the period';
  NbOfLateArrivalsInPercentage='Late arrivals in %';
  AverageLateArrivalInMin='Average Duration';

  NbOfLateDepartures='Late end of shifts during the period';
  NbOfLateDeparturesInPercentage='Late end of shifts (%)';
  AverageLateDepartureInMin='Average Duration'

  NbOfExtendedMeals='Meals too long during the period';
  NbOfExtendedMealsInPercentage='Meals too long (%)';
  AverageExtendedMealInMin='Average duration';
  NbOfExtendedBreaks='Breaks too long during the period';
  NbOfExtendedBreaksInPercentage='Breaks too long (%)';
  AverageExtendedBreakInMin='Average Duration';

  CreateAZkPunch='Create a ZK Punch';
  EditPunchNow='Paramétrez l\'horodateur';
  EmployeesResponsibleOfThisSituation='Employees responsible for this situation';
  ReportAbsenteismPerMonthPerUnit='Report: Absenteism ratio per month, per department.';
  ReportLateArrivalPerMonthPerUnit='Report: Late arrivals per month, per department.';
  ReportLateDeparturePerMonthPerUnit='Report: Late departures per month, per department.';
  EditZkPunchCommand='ZK Commands';
  ModuleIsExpiredTheFeaturesAreLimited='The module being expired, some of the features are limited.';
  YourCommentsHere='Your Comments Here!';

  VerifySchedulesErrorsTip='Verify if you have some errors in the schedules';
  Verify='Verify';
  Leading0AreRemovedFromZkCard='Leading \'0\' in Zk Cards are automatically removed.';

  IncludeRoleAdmin='Display \'Administrators\'';
  IncludeRoleLimitedAdmin='Display \'Admin. (Limited)\'';
  IncludeRoleResponsable='Display \'Managers\'';
  IncludeRoleLimitedResponsable='Display \'Managers (Limited)\'';
  IncludeRoleEmployee='Display \'Employees\'';
  NotifyEmployeeTip='Notify by email or in the mobile application.';
  EmailIsNotValid='Email is not valid, only the notification by the mobile application will be used.';
  WhatMightHelp='Click here to see some help to resolve this issue.';
  ExpectingAnswer='No answer received yet.';
  PriorityOnThePosition='Priority on the position: ';
  FirstDayCSST = '1st day CSST';
  CUMULATIVE_PREMIUM_CCP6000 = 'Premium 6000';
  CUMULATIVE_PREMIUM_CCP6001 = 'Premium 6001';
  CUMULATIVE_PREMIUM_CCP6002 = 'Premium 6002';
  CUMULATIVE_PREMIUM_CCP6003 = 'Premium 6003';
  CUMULATIVE_PREMIUM_CCP6004 = 'Premium 6004';
  CUMULATIVE_PREMIUM_CCP6005 = 'Premium 6005';
  CUMULATIVE_PREMIUM_CCP6006 = 'Premium 6006';
  CUMULATIVE_PREMIUM_CCP6007 = 'Premium 6007';
  CUMULATIVE_PREMIUM_CCP6008 = 'Premium 6008';
  CUMULATIVE_PREMIUM_CCP6009 = 'Premium 6009';

  CumulativePremiumConfiguration6001='Premium Configuration';
  CumulativePremiumConfiguration6002='Premium Configuration';
  CumulativePremiumConfiguration6003='Premium Configuration';
  CumulativePremiumConfiguration6004='Premium Configuration';
  CumulativePremiumConfiguration6005='Premium Configuration';
  CumulativePremiumConfiguration6006='Premium Configuration';
  CumulativePremiumConfiguration6007='Premium Configuration';
  CumulativePremiumConfiguration6008='Premium Configuration';
  CumulativePremiumConfiguration6009='Premium Configuration';

  Range1='First Part';
  Range1Name='Name (Report)';
  Range1Active= 'Active';
  Range1ExportCode='Pay Code';
  Range1StartInMin='Start (ex: 10)';
  Range1EndInMin='End (ex: 120)';
  ConditionAmount='HH:mm';
  Range2='Second Part';
  Range2Name='Name (Report)';
  Range2Active= 'Active';
  Range2ExportCode='Pay Code';
  Range2StartInMin='Start (ex: 10)';
  Range2EndInMin='End (ex: 120)';


  RemoveMinutePartCumulativePremiumConfiguration6008='Minute Removal Configuration';
  CumulativePartOfCumulativePremiumConfiguration6008='Cumulative Premium Configuration';

  CCP6000_MainExplanation='This premium will calculate daily and weekly overtime.<br><i>Daily overtime won\'t be reported again in the weekly overtime.</i><br>';
  CCP6000_DailyWithCondition='<b>Daily premium</b> of {{bonus}}, for schedules of type {{schedules}}, when the total of the hours is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';
  CCP6000_WeeklyWithCondition='<b>Weekly premium</b> of {{bonus}}, for schedules of type {{schedules}}, when the total of the hours is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';

  CCP6001_MainExplanation ='This premium will be triggered for schedules of type {{schedules}}, when the {{period}} total of hours is {{condition}}.<br>';
  CCP6001_Range='Premium of {{bonus}} when the {{period}} total is between {{startMin}} min. and {{endMin}} minutes. (Pay Code: {{codeForPay}}, Label Pay: {{labelForPay}}).' ;
  CCP6001_Range_Unlimited='Premium of {{bonus}} when the {{period}} total is more than {{startMin}} minutes. (Pay Code: {{codeForPay}}, Label Pay: {{labelForPay}}).' ;


  CCP6002_MainExplanation='This premium will calculate daily and weekly overtime for schedules of type {{schedules}}, when the total of daily hours is {{dailyCondition}} and/or when the total of weekly hours is {{weeklyCondition}}.<br><i>Daily overtime won\'t be reported again in the weekly overtime.</i><br>';
  CCP6002_Range_Daily='Premium of {{bonus}} when the daily total is between {{startMin}} min. and {{endMin}} minutes. (Pay Code: {{codeForPay}}, Label Pay: {{labelForPay}}).' ;
  CCP6002_Range_Daily_Unlimited='Premium of {{bonus}} when the daily total is more than {{startMin}} minutes. (Pay Code: {{codeForPay}}, Label Pay: {{labelForPay}}).' ;
  CCP6002_Range_Weekly='Premium of {{bonus}} when the weekly total is between {{startMin}} min. and {{endMin}} minutes. (Pay Code: {{codeForPay}}, Label Pay: {{labelForPay}}).' ;
  CCP6002_Range_Weekly_Unlimited='Premium of {{bonus}} when the weekly total is more than {{startMin}} minutes. (Pay Code: {{codeForPay}}, Label Pay: {{labelForPay}}).' ;

  CCP6004_MainExplanation='This premium will calculate daily and biweekly overtime.<br><i>Daily overtime won\'t be reported again in the biweekly overtime.</i><br>';
  CCP6004_DailyWithCondition='<b>Daily premium</b> of {{bonus}}, for schedules of type {{schedules}}, when the total of the hours is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';
  CCP6004_WeeklyWithCondition='<b>Bi-Weekly premium</b> of {{bonus}}, for schedules of type {{schedules}}, when the total of the hours is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';

  CCP6005_MainExplanation='This premium will calculate overtime per shift.<br><i>Shifts are NOT added before comparing to the condition.</i><br>';
  CCP6005_Condition='<b>Premium</b> of {{bonus}}, for schedules of type {{schedules}}, when the approved time is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';

  CCP6006_MainExplanation='This premium will be triggered if the condition is met AND a shift has been approved on {{specialBonusDay}}.<br>';
  CCP6006_Condition='<b>Premium</b> of {{bonus}}, for schedules of type {{schedules}}, when the weekly hours before {{specialBonusDay}} is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';

  CCP6007_MainExplanation='This premium will remove some minutes if the condition is met.<br>';
  // CCP6007_Condition='<b>Premium</b> will remove {{minToRemove}} min for schedules of type {{schedules}}, when the daily hours is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';
  CCP6007_Condition='<b>Premium</b> will remove {{minToRemove}} min for schedules of type {{schedules}}, when the daily hours is {{condition}}.';

  CCP6008_MainExplanation='This premium will remove some minutes per timesheet and then will calculate the cumulative bonus.<br>';
  CCP6008_RemoveCondition='<b>Premium</b> will remove {{minToRemove}} min for schedules of type {{schedules}}, when the daily hours is {{condition}}.';
  CCP6008_CumulativeCondition='<b>Premium {{period}}</b> of {{bonus}}, for schedules of type {{schedules}}, when the total of the hours is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';

  CCP6009_MainExplanation='This premium will remove some minutes per timesheet and then will calculate daily and weekly overtime.<br><i>Daily overtime won\'t be reported again in the weekly overtime.</i><br>';
  CCP6009_RemoveCondition='<b>Premium</b> will remove {{minToRemove}} min for schedules of type {{schedules}}, when the daily hours is {{condition}}.';
  CCP6009_DailyWithCondition='<b>Daily premium</b> of {{bonus}}, for schedules of type {{schedules}}, when the total of the hours is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';
  CCP6009_WeeklyWithCondition='<b>Weekly premium</b> of {{bonus}}, for schedules of type {{schedules}}, when the total of the hours is {{condition}}. (Pay Code: {{codeForPay}}, Pay Label: {{labelForPay}}).';


  SpecialBonusDay='Special Bonus Day';


  ExportCode='Payroll Code';

  NoEmployeeToCreate='No employee to create.';
  FakeLastName='Hidden';
  ChangePasswordNextLogin='The employee will have to change his password for next login';
  ManageRightsOnCustomReports='Manage Access to Custom Reports';
  EditCustomReportRightsForUser='Modify Access Rights for a User';
  EmployeeLastName='Lastname';
  EmployeeFirstName='Firstname';
  ReportCode='Report Code';
  IncludeApprovedTS='Include already approved TS';
  IncludeApprovedExpenses='Include already approved Expenses';
  ExportToPDF='Export in PDF';
  Week1='Week 1';
  Week2='Week 2';

  UseDivisionProvinceAndCountryForSubDivisions='Replace Country & Province in all sub-units of this division';
  LeftInBank='<b>{{bankName}}</b>: <span class="muted">{{leftInMinutes}}</span>';
  SendCredentialsByEmailBatch='Send Credentials by Email or Generate a PDF';
  ForceNewPasswordAfterNextLogin='Password expires';
  ForceNewPasswordAfterNextLoginTip='The User will have to change his password after the next login.';
  DoYouReallyWantToDeleteTheGroupOfEnterprise='Do you really want to delete this group \'{{name}}\' ?';
  ListOfGroupOfEnterprise='Enterprises Groups - {{nb}} group(s)';
  GroupId='Id';
  SynchroAutomatiquePerEnterprise='Automatic Synchronization per Enterprise';
  UseAddressFromAPI='Use Employee Address from API';
  UseDOBFromAPI='Use Employee DOB from API';
  ZkPunchModel='Model';
  SelectAllWeeks='Select all Weeks';
  ActivateCopiedSchedules='Publish all Copied Schedules';
  MaxInactivityInDaysForManagers='Inactivity Max for Managers (days)';
  PunchesPerEntity='Punches per Entity';
  NbDistinctEmployeesWithApprovedTS='Nb Employees with at least 1 approved TS';

  DeleteTask='Delete Project';
  ModifyTask='Modify Project';
  EmployeesOnTheTask='Add or Remove Employees from the Project';
  DetailsOfTheTask='Completion Status of the Project';

  AddingToBankTypes='Add to Custom Time Banks';
  WeAreRemovingFromTSToAddToBank='We remove {{hoursToRemove}} from {{fromTSType}}, we add {{addToBank}} to the bank {{bankName}}';
  ValueToSubstractInMinStr='Value HH:MM to substract';

  NewServiceForSagesFromPJC='New Communication Protocol for Sages by Centre RX - (Starting Apr. 16th 2022)';
  MemoExpiresOn='Exp. on ';

  EmployeeWhoseScheduleOrTimesheetHasDeleted='Employee whose schedule/ts has been deleted';
  EmployeeThatDeletedScheduleOrTimesheet='Employee who deleted the schedule/ts';
  searchScheduleFromDate='Schedule date from ';
  searchScheduleToDate='Schedule date to (max 30 days)';
  DeletedBy='Deleted by';
  DeletedWhen='Deleted on';
  ScheduleTime='Schedule';
  TotalAmount='Total ($)';
  DeletedScheduleAndTimesheet='Del. Schedule/TS';
  ListHolidayBanks='List of Holiday Banks';
  HolidayBanks='Holiday Banks';

  HolidayBankId='Id';
  HolidayBankPeriodStart='Begin';
  HolidayBankPeriodEnd='End';
  AccumulatedAmount='Acc. Amnt';
  VacationInDays='Nb days';
  VacationsBalanceInMinutes='Bal. in min';
  VacationsInMinuteAverageRate='Avg Rate';
  DoYouReallyWantToDeleteThisVacationBank='Do you delete this bank (id: {{id}}) ?';
  DeleteHolidayBank='Delete';
  ListSyncAPIConfig='Synchro API';
  NoSyncAPIConfigFound='No Configuration Found';
  LastRunDate='Last Run';
  NextRunDate='Next Run';
  DisplayLastRunDetails='Display Last Run Details';
  NoSyncAPIDetailFound='No Detail Found';
  EmployeeFullName='Fullname';

  CollapseDivisionsTip='Collapse Divisions';
  CollapseDivisions='Collapse';
  AccessTokenIsNotAuthorizedYet='Access Token not Available';

  PotentialEnterprises='Enterprises that could probably be linked... (To be manually verified)';
  PotentialDivisions='Divisions that could probably be linked... (To be manually verified)';

  ExpenseDate='Date';
  ExpenseType='Type';
  EditExpenseType='Expense Type';
  EditExpense='Expense to refund';
  NbUnitWithUnitName='Value of the Expense in ';
  NoExpensesFound = 'No Expenses';
  AddExpenseFiles = 'Add Files (Optional)';
  DoYouReallyWantToDeleteThisExpense='Do you really want to delete this expense?';
  ExpenseHasFiles= 'Download the Attachments';
  DoYouReallyWantToDeleteThisExpenseFile='Do you really want to delete this file? This can\'t be rollbacked.';
  AllUpdateZoho = 'Update Zoho for all Active Enterprises with a Zoho Link';
  ZohoSynchroResults = 'Zoho Synchro Results';
  ExpenseTypes='Expense Types Management';
  CanAddExpenses='Can Add Expenses';
  CanManageExpenseType='Can Manage Expense Types';
  valuePerUnit='Value per Unit';
  unitName='Unit';
  UpdateAllActiveEnterpriseWithZohoAccess='Update active enterprises in Zoho';
  UpdatingZoho='Updating Zoho';
  UpdatingBilling='Updating Recurrent Bill';

  ToBeDeleted='To Delete';
  ScheduledToBeDeletedAfterDate='Scheduled to be deleted on or after';
  WillBeDeactivatedOnDate='Will deactivate after first login at 00:00 on:'
  EnterpriseToBeDeleted='Enterprises to Delete';
  PageMissing='Page not found.';
  PreviousSearch='Previous Search';
  ParamsProfileIsMandatoryWhenCreatingEmployee = 'Parameter Profile is mandatory when creating employees.';
  DoYouReallyWantToDeleteThisBankTypeEmployee='Do you really want to delete this bank for this period?';
  DoYouReallyWantToDeleteThoseSickDays='Do you really want to delete this period?';
  DoYouReallyWantToDeleteThoseFamilyDays='Do you really want to delete this period?';
  DoYouReallyWantToDeleteThoseVacations='Do you really want to delete this period?';
  ClientName='Client Name';
//  EditDivision='Edit division';
  EditEnterprise = 'Edit Enterprise';
  GenerateAutomaticSchedules = 'Create schedules according to the preferences';
  PositionDescription='Positions';
  RestartCamera='Restart Camera (V8)';
  DisplayTimerForMealsAndBreaks='Display Timer for Meals & Breaks (Virtual)';
  EmployeeWithNoLogin='Employees - Applications Access';
  CanAccessApplications='Access Applications';
  LastLogin = 'Last Login';
  DeactivateSelectedEmployees='Deactivate Selection';
  ActivateSelectedEmployees='Activate Selection';
  noLoginSince='No Login Since';
  CantConnectApplications='Can\'t connect to applications (portal, client, mobile,...)';
  OnlyEmployeeWithNoLogin='Only employees who never logged in.';
  ChangePasswordAtFirstLogin='User will change password after first login';
  SendConnectionInformationByEmail='Send connection information by email';
  EncryptPasswordForSelectedEmployees='Encrypt Pwd Selection';
  IncludeEmployeeWithAnEncryptedPassword = 'Include Employees with an encrypted password';
  TotalDestructionOfEnterpriseAndEmployees='Total destruction of the enterprise and all its employees';
  DeleteEnterpriseTitle='Delete Enterprise';
  DeleteForReal='Delete all the information associated with the enterprise';

  AddEnterpriseStatutoryHoliday='Add Statutory Holiday';
  CopyHolidaysBetweenEnterprises='Copy Statutory Holidays between Enterprises';
  EnterpriseStatutoryHoliday = 'Statutory Holiday';
  StatutoryHolidayDate = 'Date';
  ShiftClickToLoadPastDates='Shift+Click to load past dates';
  DoYouReallyWantToDeleteThisHoliday='Do you really want to delete this Statutory Holiday?';
  CopyStatutoryHolidays='Copy Statutory Holidays';
  FromEnterprise='From Enterprise';
  ToEnterprise='To Enterprise';
  DoYouReallyWantToDeleteTheSpifType='Do you really want to delete \'{{name}}\'?';
  SpifOwner='Owner';
  UsersWithAccessToSpifType= 'Users with access to this type';
  AddSpifType='Add';
  SearchUnsubscribedEmails='Search Unsubscribed Emails';
  EnterUnsubscribedEmail='Enter the email to find';
  SearchEvents='Search Events';
  EnterEmail='Enter the email linked to the events';
  NoEmailsFound='No Emails Found';
  DashboardPreferences='Dashboard';
  OtherPreferences='Others';

  Speed='Speed Test';
  SpeedTestIn='Speed test done in {{ms}} ms.';
  DeleteSchedules='Delete Schedules';

  AddEvaluationAggregation='New Evaluation Template';
  EvaluationsManager='Evaluations Manager';
  DoYouReallyWantToDeleteTheEvaluationAggregation='Do you want to delete this template?';
  EVALUATION_QUESTION_TYPE_YES_NO='Yes/No';
  EVALUATION_QUESTION_TYPE_CHECK_CHOICE='Multi-Choices';
  EVALUATION_QUESTION_TYPE_RADIO_CHOICE='Multi-Choices (Exclusive)';
  EVALUATION_QUESTION_TYPE_ONE_TO_FIVE='Scale 1 to 5';
  EvaluationTitle='Title';
  EvaluationCreatedBy='Created by';
  EvaluationNbQuestions='Nb Questions';
  EvaluationAggregationTitle='Evaluation Template';
  CanManageEvaluation='Manage Evaluation Templates';
  CanSendMemoToSameLevelUser='Memo To Same Level Users';
  EmployeeEvaluations='Employee\'s Evaluations';
  DueDate='Due date';
  EvaluationEmployee='Evaluation Template Parameters';
  EvaluateEvaluationEmployee = 'Employee\'s Evaluation';

  EditEvaluationTemplate='Modify Evaluation Template Parameters';
  EvaluateTheEmployee='Evaluate the Employee';
  StartEvaluation='Start Evaluation';
  NoteFromEmployee='Note (Employee)';
  NoteFromManager='Note (HR Assessor)';
  EvaluationIsComplete='Evaluation has been completed';
  NoteFromAssessor='Evaluation\'s Global Note';
  AddEvaluationFiles = 'Add Files (Optional)';
  EvaluationHasFiles= 'Download the Attachments';
  DoYouReallyWantToDeleteThisEvaluationFile='Do you really want to delete this file? This can\'t be rollbacked.';

  YES='Yes';
  NO='No';
  TemplateType='Template';
  CreateStandard='Standard Template';
  CreateStandardTip='Create a template from an already defined standard';
  ResetEvaluationEmployee='Reset Evaluation. Will delete the current answers.';
  DoYouReallyWantToResetTheEmployeeEvaluation='Do you want to delete the answers to this evaluation \'{{name}}\'?';
  NotCompleted = 'Not Completed';
  StronglyDisagree='Strongly Disagree';
  Disagree='Disagree';
  NotAgreeNorDisagree='Neutral'
  Agree='Agree';
  StronglyAgree='Strongly Agree';
  NoAnswerForThisQuestion='No answer for this question';
  QuestionIsInactive='Inactive';
  DoYouReallyWantToDeleteTheEmployeeEvaluation='Do you want to delete this evaluation?';
  DoYouReallyWantToDeleteAllTheEmployeeEvaluations ='Do you want to delete ALL these evaluations?';
  NoTimesheetSummaryFound='No timesheet summary found. You probably don\'t have any timesheet yet.';
  HumanResourceReports='Reports - Human Resources';
  ClickToSort='Click to Sort';
  '5IsABetterGradeThan1'='note: 5 is better than 1';
  FnamePreferred='Preferred First Name';

  CloneEmployeePositions='Copy Employee\'s Positions';
  SelectPositionsYouWantToCopy='Select Positions to Copy';
  CopyJobsFromAnotherEmployee='Copy Positions from Another Employee';
  ShowHideEmployeeNoSchedules='Show/Hide Employees Without Schedules';
  SearchAhead='Search by name...';
  CalculateDailyBeforeWeekly='Calculate daily premiums before weekly premiums';
  MinuteScheduledAndPublished = '{{scheduled}} scheduled: {{published}} published + <span class="emp-parme">{{notPublished}} not published</span>.';
  MinuteScheduled = '<span class="emprez-vert-agrume">{{scheduled}} scheduled and published.</span>';
  MinuteScheduledAndPublishedWithAmount='{{scheduled}} ({{scheduledAmount}}) scheduled: {{published}} ({{publishedAmount}}) published + <span class="emp-parme">{{notPublished}} ({{notPublishedAmount}}) not published</span>.';
  MinuteScheduledWithAmount='<span class="emprez-vert-agrume">{{scheduled}} ({{scheduledAmount}}) scheduled and published.</span>';
  EmployeeNotifications='Notifications received';
  SentDate = 'Sent';
  NoNotificationsFound='No Notifications';
  EmployeeMemberOfGroups='Member of Groups';
  ViewGroup='View Group';
  RemoveFromGroup = 'Remove From Group';
  DoYouReallyWantToRemoveTheEmployeFromGroup='Do you really want to remove the employee from the group \'{{groupName}}\'?';
  ChooseGroup='Choose Group';
  YouAreNotTheOwnerOfThisGroup='You are not the owner of the group.';
  CreateANewGroup='Create a new group';
  RequestList='Requests received';


  PresencesMightBeDelayed='Presences depend on the information sent by the punches and might be delayed by 15 min depending on their configuration.'
  ScheduledStart='Scheduled Arrival';
  PunchedStart='Punched Arrival';
  PunchedStartWithAdjustment = 'Punched Arrival (Rounded)';
  WhoIsPresentNow='Who is present now?';
  NoPresencesFound='Nobody is present';
  YouCantSelectThisGroupYouDontHaveTheOwnership='You can\'t use this group. You should ask its owner \'{{owner}}\'';
  DoYouReallyWantToDeleteCurrentScheduleFor='Do you really want to delete current schedules for {{employee}}?';
  NoNotesFound='No Notes Found';


  SchedulesPlanningNG = 'Plans';
  SchedulesPerEmployeesNG = 'Employees';
  SchedulesPerJobsNG = 'Structure';
  SchedulesForOneJobNG = 'Position';
  Tools = 'Outils';
  AliasManagerNG = 'Predetermined Shifts';
  CostManagement = 'Cost Management';
  EventManagementNG = 'Events';
  BudgetManagementNG='Budgets';
  SalesCostManagementNG = 'Sales';

  AddOrRemoveInBatch='Add & Delete in Batch';
  AddJobInBatchNG ='Positions';
  AddHourlyBonusInBatchNG='Hourly Premiums';
  AddOrModifyEmployeeBadgeNG='Badges';
  AddCumulativeBonusInBatchNG='Cumulative Premiums';
  CreateOrDeleteVacationRecordNG='Vacations';
  CreateOrDeleteSickDaysNG='Sick Days';
  CreateOrDeleteFamilyDaysNG='Family Days';
  CreateHolidaysNG='Statutory Holidays';
  AddOrDeleteBankTypeEmployeeInBatchNG='Custom Time Banks';
  AddSpifInBatchNG='Bonuses';
  ModifyInBatch='Update in Batch';
  UpdateSalaryInBatchNG='Wage';
  UpdateVisibleEmployeeNG='Visibility';
  ModifyLevelJobInBatchNG='Position Level';
  ModifyEmployeeSortOrderInBatchNG='Sorting Order';
  VerificationExportAndUpdate='Bi-Weekly Usage';

  ManagementOf='Managers';
  BonusManagementShort = 'Premiums';
  SpifTypeManagementShort='Spifs';
  ParamsProfileManagerShort='Parameters Profiles';

  NamedWorkshiftsShort='Named Workshifts';
  SurveyManagerShort='Surveys';
  GeoFenceManagerShort='GPS Zones';
  BankManagerShort='Custom Time Banks'
  BankManagerShort2='Custom Time Banks'
  BankTypeTransactionsShort='Transactions (Custom Time Banks)'
  BankTypeTransactionsShort2='Transactions (Time Banks).'
  ApiAccessesShort='API Accesses';
  ReportToEmailsShort='Reports per Email';
  ManageRightsOnCustomReportsShort='Custom Reports Accesses';
  ManageRightsOnCustomReportsShort2='Custom Reports Accesses';
  PerformanceModuleDashboardShort='Emprez BI';
  ExpenseTypesShort='Expenses Types';
  HolidayManagementShort='Statutory Holidays';
  EvaluationsManagerShort='Evaluations Templates (HR)';


  DeleteUnapprovedSchedulesAndGabarits ='Delete Unapproved Schedules and Templates';
  HideShowAmounts='Hide/Show Amounts';
  EmployeeTools='Tools - Batch';
  CreateChatUserTip='Create a chat User in Twilio';
  SessionWithIntuitIsValid='Session is valid';
  SessionWithIntuitIsNotValid='Session is not valid, you need to reconnect.';
  Automatic='Automatic';
  UseCgiAPIV2='Use CGI API V2 (With Consent)';
  UseCgiAPIV2WithoutConsent ='Use CGI API V2 (Without Consent)';
  CgiAPIV2ClientId='Client Id'
  CgiAPIV2ClientSecret='Client Secret';

  CgiBusinessId='CGI Business Id';
  CgiAPIV2TestMode='Test mode for API V2';
  DoYouReallyWantToDeleteThisToken='Do you really want to delete this token?';
  NoTokenFound='No Token Found.';

  SessionWithAPIIsValid = 'The Session is Active';
  VerifyConnection='Verify the Session';
  SessionWithAPIIsNotValid = 'The Session has Expired'
  ConnectToAPI='Connect';
  ConnectToAPITitle = 'Connect to {{service}}';
  YouNeedToSelectABank='You need to select a Bank';
  SelectedBankHasNoSetCodeToRetrieveFromAPI='Selected Bank has no code to fetch it from the API';
  LastBalanceUpdate='Last Balance updated on {{last}}';

  ItemsSelected = '{{nb}} Selected Items';
  RecipientsSelected = '{{nb}} Selected Recipients'
  SelectAnItem = 'Select an Item';
  SelectRecipients = 'Select Recipients';
  NoSelectionAvailable = 'No Selection Available';
  NoRecipientToSelect = 'No Recipients to Select';
  FindRecipientToInvite='Find Recipients to Invite';

  FavoritePanel='Your Favorite Menu';
  ConfigureFavoriteMenu='Configure';
  ConfigureYourMenu='Configure your Favorite Menu';
  FavoriteMenu='Your Favorite Menu';
  AvailableMenu = 'Available Menus';
  NoDivisionsAssociatedWithThisTwilioAccount='No division associated with this Twilio Account, could be deleted';
  NoEnterprisesAreConnectedToFolks='No enterprise is connected with Folks.';

  UseAllieRHFolks='API Folks';
  AllieRHFolksClientId='Folks Client Id';
  AllieRHFolksSecret='Folks Secret';
  AllieRHFolksKey='Folks Enterprise\'s Id'
  VerifyAllieRHCompanyNumber='Verify Company Number (Importing)';
  ExternalID='External Id';
  ExternalID2='External Id (2)';
  selectAll='Select All';
  unSelectAll = 'Unselect All';
  OnAddCalendar='Add Calendar';
  FEDERAL ='Federal';
  BanksAndHolidays = 'Banks & Holidays';
  EmprezBI = 'Emprez BI';
  NoInformation = 'No Information';

  WithSchedulesOnly = 'With Schedules Only';
  WithoutSchedulesOnly = 'Without Schedules Only';
  HideAmountTemporary='Hide Amounts (Temp.)';
  SavePreferences = 'Save Preferences';

  EMPREZ_UI_V1 ='Version 1 - Obsolete';
  EMPREZ_UI_V2 ='Version 2';
  EMPREZ_UI_V3 ='Version 3';
  MobileAndWebAccess='Mobile & Web Access';
  CCQConfiguration = 'CCQ';
  CopyCalendarUrlToClipboard='Copy the link to add to a Calendar (Google, Apple,...)';
  SendCalendarUrlByEmail='Email the link to add to a Calendar (Google, Apple,...)';
  TimesheetParams='Timesheets Params';
  DoYouReallyWantToApplyTimesheetParamsToEmployeePaidBy = 'Do you really want to apply the parameters to employees paid by {{name}}?';
  EmployeeScheduleParams='Schedule Params';
  EmployeeTimesheetParams='Timesheet Params';
  PayParams = 'Payroll';
  EmployeePayParams = 'Payroll Parameters';
  RPA360Tools='RPA360 - Tools';
  ConfigurationAndParameters='Configuration & Parameters';

  CGICustomerConfiguration='Customer Configuration for API V2';
  SageIntacctConfiguration='Sage Intacct Configuration';
  BusinessId='Business Id';
  BusinessCode='Business Code';
  DescriptionEn='Description (En)';
  DescriptionFr='Description (Fr)';
  RetrieveBusinessId='Retrieve Business Information';
  CompanyItemNumber='Company Number';
  CompanyItemName='Company Name';
  CompanyItemStatus='Company Status';
  EnterpriseCodeCompanyNumber='Enterprise Code / Company Number';
  InformationAboutBusinesses='Information - Businesses'
  InformationAboutCompanies='Information - Companies'

  SelectDivisions = 'Select Divisions';
  DivisionsSelected = '{{nb}} Selected Divisions'
  NoDivisionToSelect = 'No Divisions to Select';
  FilterByPositions='Filter by Position';
  NoPositionToSelectYetLoadSomeSchedules='Load some schedules';
  SelectedPosition='{{nb}} Positions';

  Costs = 'Costs';
  Projects= 'Projects';
  PerformanceModule = 'Emprez BI';
  HumanResource='Human Resources';

  ChooseEmployeeToken='Choose Employee\'s Token';
  EmployeeToken='Employee\'s Token';
  PleaseSelectAnEnterpriseOrAGroupOfEnterprise='Please Select an Enterprise or a Group of Enterprises';
  UpdateFromWebServiceShort = 'Update from {{payRoll}}';
  UpdateFromFolksShort='Update from Folks';
  ReportingGroup='Groups';
  ShowOrHideToolbar='Hide or Show the Toolbar';

  ReadJobIdFromCustomFields='Read JobId From Custom Fields';
  JobIdCustomFieldName='JobId Custom Field Name';

  SynchroFromFolks='Retrieve Information from Folks to update the Employees';
  SynchroFromOdoo='Retrieve Information from Odoo to update the Employees';
  UseEndDateTip='Emprez will terminate the employee at the end date.';
  UseEndDate='Use EndDate';
  UpdateSalary='Update Salary';
  UpdateEmployee='Update Employee';
  UpdateEmployeeTip='Update most of the Employee Information';
  CreateEmployeeFromFolks='Create Employee';
  CreateEmployeeFromFolksTip='Import Employees from Folks. Some configuration is necessary to link Emprez positions with those found in Folks.';
  UpdateContacts='Update Emergency Contacts'
  SyncAPIConfigsCGIAPI='Synchronization for CGI API';
  SyncAPIConfigsFolks='Synchronization for Folks API';
  SyncAPIConfigsOdoo='Synchronization for Odoo API';

  NOTIFICATION_TYPE_EMAIL = 'Email';
  NOTIFICATION_TYPE_APPLICATION = 'Mobile Application';
  NOTIFICATION_TYPE_APPLICATION_AND_EMAIL = 'Email + Mobile Application';
  NOTIFICATION_TYPE_NONE = 'No Notification';

  onReceivingVacationRequest ='Vacation Requests';
  onReceivingBankUsageRequest='Bank Usage Requests';
  onReceivingApplyOnOpenShift='Candidate on Workshift';
  onReceivingExchangeShiftRequest='Exchange Workshifts';
  onReceivingAvailabilitiesRequest='Submitted Availabilities';
  onReceivingUnAvailabilityRequest='Submitted Unavailabilities';

  EmployeeNotificationConfiguration='Notifications from Employees\' Requests';

  ConversationWithOnePerson='Conversation with one person';
  ConversationWithMultiplePerson='Conversation with a group';
  UsersCanLeaveChannel='Leaving';
  UsersCanLeaveChannelFull='Users can leave Channels';
  DoYouReallyWantToRemoveThisParticipant='Do you want to remove {{name}} from this conversation?';
  EnterNewNameForTheConversation='Update the name';
  ClickToModify='Click to modify';
  ClickToRemoveMember='Click to Remove Member';
  ModifyConversationName = 'Modify Conversation Name';
  DeleteMessages='Select Messages to Delete';
  SelectedMessages = '{{nb}} messages selected.';
  DoYouReallyWantToDeleteTheSelectedMessages='Do you really want to delete the selected messages?';
  NewConversation='New Conversation';

  StartRecording = 'Start Recording';
  StopRecording = 'Stop Recording';
  Recording='Recording...';
  FileAttachedToConversationTooLarge = 'The size of the file is too large. (max {{limit}} MB)';

  UsersCanSendAudio = 'Users can send Audio (max 3 min)';
  UsersCanSendFile='Users can send File (jpg, png and pdf) (max 2MB)';
  UsersCanSendPicture='Users can send Picture (max 2MB)';
  NoEmployeesWorkingInDivision='No Employees';
  DeleteUnitAndJobs='Delete Unit and Jobs';
  EntityEdit='Modify Entity';
  WeekNbrCalculator ='Week Nbr Calculator';
  UpdatedDate='Updated';
  ModifiedBy='Modified';
  NewEntity='New Entity';

  BirthdaysValidation='Birthdays';
  NoBirthdays='No Birthdays soon.';
  EmployeeBirthday='Today {{birthday}}, is {{fn}}\'s birthday!';
  EmployeeBirthdaySoon='{{fn}}\'s birthday will be on {{birthday}}.';
  EmployeeBirthdayPassed='{{fn}}\'s birthday was on {{birthday}}.';

  ExpiredSkillsValidation='Skills - Expirations';
  EmployeeSkillIsExpiring='{{fn}}\'s skill \'{{skill}}\' will expire on {{refDate}}.';
  EmployeeSkillIsExpired='{{fn}}\'s skill \'{{skill}}\' expired on {{refDate}}.';
  FilterByFullname='Filter';
  SelectEntity='Select an Entity';
  ExpensesToApprove='Expenses to Approve';
  ExpensesByWeekAndEmployee='Expenses per Week and per Employee';
  NoItemsFound='No Items Found';
  ThoseParametersWillInfluenceThePayNumber='These parameters will modify the payroll numbers. Usually the payroll number (ex: 2024-23 23rd pay of 2024) depends on the payment date and not the period.'
  DaysToDeposit='Payment after nb days (default: 5)';
  PayBacktime='Payment after nb weeks (default: 0)';

  PunchWithVoiceEnabledWarning='Experimental! It will work ONLY with /virtual-punch with the Chrome browser!';
  VoiceEnabledInFrench='French Voice Recognition';
  VoiceEnabledInEnglish='English Voice Recognition';

  FoldAllShiftsToFill = 'Fold All';
  UnFoldAllShiftsToFill = 'Unfold All'

  NoExpensesToApprove='No Expenses to Approve.';
  FamilyDaysTitle ='Personal Days - Floating Days - Emergency Leaves';
  EmployeeFamilyDays='Family Days';
  NoFamilyDays = 'No Family Days';
  NbPaidDaysAllowed='Nb Paid Days Allowed';
  NbPaidDaysUsed='Nb Paid Days Used';
  NbUnPaidDaysAllowed='Nb Unpaid Days Allowed';
  NbUnPaidDaysUsed='Nb Unpaid Days Used';
  DoYouReallyWantToDeleteThisFamilyDays='Do you really want to delete those \'Family Days\'?';
  CreateOrDeleteFamilyDays='Add or Delete Family Days';

  NotEnoughUnPaidFamilyDaysLeft='Not enough Unpaid Family Days Left';
  NotEnoughPaidFamilyDaysLeft='Not enough Paid Family Days Left';

  AutoAttendanceDisclaimer = 'Employees will have their timesheets automatically approved. Only the timesheets of type Work, Training and Shadowing are used.';
  AutoAttendance='Automatic Attendance';
  DlgAutoAttendanceMessages = 'Automatic Attendance Details';

  AutoAttendanceMessage = 'Automatic Attendance Details';
  NoAttendanceMessage = 'No Messages';
  DoYouReallyWantToDeleteThisMessage='Do you really want to delete this message?';
  UpdateAutoAttendanceBatch='Update Automatic Attendance';
  IsPunching='Is Punching?';
  UpdateAutoAttendanceBatchLabel='Automatic Attendance';
  DoYouReallyWantToDeleteSelectedMessage='Do you really want to delete the selected messages?';
  DeleteSelection='Delete Selection'

  DoYouWantToSelectThisApplicantForThisShift = 'Do you want to schedule {{applicant}} for this shift?';
  ImportProject='Import Project';
  IMPORT_PROJECT_TYPE_MS_PROJECT_MPX = 'MS Project MPX';
  UploadFile='Choose a file to import';
  TestOdoo='Odoo (Test)';
  TestFolks='Folks (Test)';
  UsesOdoo='API Odoo' ;
  OdooHost='Host (URL)';
  OdooDatabase='Database';
  OdooUsername='Username';
  OdooPasswordOrAPIKey='Password or API Key';
  MatchEmployeeWithOdoo='Odoo: Linking Employees found in Odoo (Firstname+Lastname)'
  ImportEmployeeFromOdoo='Odoo: Import Employees into Emprez';
  NoEnterprisesAreConnectedToOdoo='No Enterprises are configured to use Odoo';

  VerifyOdooCompanyNumber='Verify Odoo Company Number';
  OdooCompanyNumber='Odoo Company Number';
  OdooCodeForTsType='Odoo Type for TS (ALL=1,ABSAUTH=44,ABSAUTHPAYE=...)';
  LinkedWithExternalHRService='Linked with external HR Service';
  PasswordSentToEmailOnFile='Password sent to the email on file';
  ROICalculation='ROI Calculation (XLS)';
  DisplayDistinctSchedules='Display Distinct Schedules';
  AddGPSFenceOnPosition='Add GPS Zones on Positions';
  AddGPSFenceOnPositionNG = 'GPS Zones';
  ReplaceGPSFences='Replace GPS Zones';
  GPSFences='GPS Zones';
  AbsenceSubType ='Absence Reason';

  ABSENCE_SUB_TYPE_FAMILY_OBLIGATION='Family Obligation';
  ABSENCE_SUB_TYPE_MEDICAL_APPOINTMENT  = 'Medical Appointment';
  ABSENCE_SUB_TYPE_ACCIDENT_ON_DUTY  = 'Accident On Duty';
  ABSENCE_SUB_TYPE_FLOATER  = 'Floater';
  ABSENCE_SUB_TYPE_ACCIDENT_OFF_DUTY  = 'Accident Off Duty';
  ABSENCE_SUB_TYPE_LAY_OFF  = 'Lay Off';
  ABSENCE_SUB_TYPE_SHORTAGE_OF_WORK  = 'Shortage of Work';
  ABSENCE_SUB_TYPE_DISCIPLINARY  = 'Disciplinary';
  ABSENCE_SUB_TYPE_DENTIST  = 'Dentist';
  ABSENCE_SUB_TYPE_WEATHER  = 'Weather';
  ABSENCE_SUB_TYPE_SICK  = 'Sickness';
  ABSENCE_SUB_TYPE_OTHER  = 'Other';
  ABSENCE_SUB_TYPE_LATE  = 'Late';
  ABSENCE_SUB_TYPE_UNION_LEAVE  = 'Union Leave';
  ABSENCE_SUB_TYPE_EARLY_DEPARTURE  = 'Early Departure';
  ABSENCE_SUB_TYPE_INVALIDITY  = 'Invalidity';
  ABSENCE_SUB_TYPE_EMERGENCY_LEAVE  = 'Emergency Leave';
  ABSENCE_SUB_TYPE_UNAVAILABLE  = 'Unavailable';
  ABSENCE_SUB_TYPE_QUARANTINE  = 'Quarantine';

  BlockTextMemoBetweenEmployee='Employees can NOT send text memo between them';
  OvernightTSAccountedOnEndDate='Overnight Shifts will be accounted on the End of Shift Date';
  OvernightTSAccountedOnEndDateDescription='A Shift from Monday 11:00 PM to Tuesday 04:30 AM will be considered to be on Tuesday (Normally it would be considered on Monday) '

  SummaryAreUsingTheTSDateAndNotTheStartOfTheWeek='Weekly Summaries use TS Date as reference'
  SummaryAreUsingTheTSDateAndNotTheStartOfTheWeekDescription='Default reference is the start of the pay period and it shifts the payment for statutory holidays to the next pay period IF the start of the pay period is not \'standard\' (aka Sunday or Monday) AND the statutory holiday falls on the last day of the second week. '

  CalculateStatutoryHolidayWithoutSummary='Statutory Holiday Calculation';
  CalculateStatutoryHolidayWithoutSummaryDescription='Select this option to NOT use the weekly summaries and to use ONLY the associated TS';

  UsesSageIntacct='Sage Intacct';
  SageIntacctCompanyId='Company Id';
  SageIntacctEntityId='Entity Id (Optional)';
  MatchEmployeeWithSageIntacct='Sage-Intacct: Linking Employees found in Odoo (Firstname+Lastname)'
  MatchEmployeeFromEnterpriseWithSageIntacct = 'Match with {{name}}';

  ImportEmployeeFromSageIntacct='Sage-Intacct: Import Employees into Emprez';
  ImportEmployeeWithSageIntacct='Import with {{name}}';
  NotesFromConversionFromAPI = 'Internal Information about the Conversion from the API';

  ExternalEntityCode='External Entity Code';
  ImportSageIntacctProject='Import from Sage-Intacct';
  AssociatedWithTheTask='Associated with the task';
  TimedTaskIsAssociatedWithTheEmployee='The employee is associated with the task.';
  ReportTaskToSageIntacct= 'Select Tasks to Send to Sage-Intacct as Timesheets';
  ReportTasksToSageIntacct ='Send to Sage-Intacct';
  SendToSageIntacct='Send';
  AlreadySent='Already Sent';
  MyPreferences='My Preferences';
  MyProfile='My Profile';
  BatchGroup='Groups';
  CanAddEmployeeToGroup='Can Add Employee';
  CanRemoveEmployeeToGroup = 'Can Remove Employee';
  CanAdd='Can Add';
  CanRemove='Can Remove';

  WizStep='Step';
  WizSelectEmployeesDescription='Select the Employees';
  WizModifyParametersDescription='Modify the Parameters';
  WizApplyModificationDescription='Apply Modifications';
  WizInformationResults='Results';
  SelectTerminatedAndVisible='Select All Visible & Terminated Employees '
  UsersRights='Users Rights';
  EmployeeGenderHidden='Genders are hidden';
  NoErrorsFound='No Errors Found';
  NoDeletedScheduleOrTimesheet='No Deleted Schedules or Timesheets';

  TimesheetTime='Timesheeet Time';
  PunchTime = 'Punched Time';
  ToggleAmountTemporary='Toggle Amount Display';
  ToggleAMPMTemporary='Toggle AM/PM Display';
  PublishThisLine='Publish this line';
  UnPublishThisLine='Unpublish this line';
  DeleteSchedulesOnThisLine='Delete schedules on this line';

  EditEmployeeSchedule = 'Modify the Schedule';
  DeleteEmployeeSchedule='Delete the Schedule';
  EditEmployee='Modify the Employee';
  HideUnit='Hide Unit';
  ShowUnit='Show Unit';
  HideChildren='Hide Sub-Units';
  ShowChildren='Show Sub-Units';
  Contacts='Emergency Contacts';
  DisplayCharts='Display Charts';
  ReloadWithInactive = 'Reload (with inactive)';

  YouHaveANewDocumentToSign='You have a new document to sign';
  YouHaveANewDocumentToSignBody='Hello,<br> You need to login in your Emprez employee\'s portal or mobile application to read and sign the following document \'{{name}}\'.<br> Thank you.';
  NotifyEmployees='Notify Employees';
  NoEmployeesLeftToNotify='No employees left to notify. They all signed the documents!';
  DoYouWantToNotifyTheEmployees='Do you want to notify the employees who didn\'t sign the document ?';
  ExternalId='External Id';
  GotoChatChannel='Answer in ChatRoom';

  PlanningErrors='Planning Errors'
  BudgetErrors='Budget Errors';
  EmployeeScheduleErrors='Schedule Errors';
  EmployeHoraireToFillErrors='Shift to Fill Errors';
  ExpiredSkillsErrors='Skills/Qualifications expired';
  BirthdaysAlert='Birthdays';
  EmployeePerformanceToReviewAlert='Performances to review';
  ToApprove = 'To Approve';
  SelectTimesheetsToApprove='Select Timesheets To Approve';
  NoProjectFound='No Project Found';
  FilterByEmployee='Employee';
  ApprovedTimesheets='Total';
  FilterByApprover='Approvers';
  AllApprovers='All';
  GeneralInformation = 'General Information';
  PersonalInformation='Personal Information';
  EmergencyContacts='Emergency Contacts';
  Positions ='Positions';
  Skills = 'Skills';
  DailyManagement = 'Daily Management';
  AddASchedule='Add a Schedule';
  AddATimesheet = 'Add a Timesheet';
  AddATask='Add a Task';
  TimeManagement = 'Time Management';
  MoneyManagement='Money';
  CommunicationManagement='Communication';
  MiscManagement='Misc';
  VacationManagement='Vacations';
  DoYouReallyWantToDeleteThisCustomReport='Do you really want to remove the custom report?';
  VacationsList='Vacations List';
  CostDistribution='Cost Distribution (optional)';
  CostDistributionFromEnterprise='Read parameters from the following enterprise';

  AddEmployeeTimedTask='Time on Task';
  startHour='Start Hour (hh:mm)';
  endHour='End Hour (hh:mm)';
  TimedTaskToChoose='Task'
  ErrorStartOfTaskIsAfterEndOfTask = 'Error: The start of the task is after the end of the task.';
  ErrorEndOfTaskIsAfterEndOfShift = 'Error: The end of the task ({{endOfTask}}) is after the end of the shift ({{endOfShift}}).';
  ErrorStartOfTaskIsBeforeStartOfShift = 'Error: The start of the task ({{startOfTask}}) is before the start of the shift ({{startOfShift}}).';
  ChooseCommitment='Choose';
  Commitment='Commitment';
  DefaultPosition='Default Position : \'{{position}}\'';
  ApplyConfigurationForHolidays='Apply the configuration for the Statutory Holidays';
  TasksInTimesheets='Tasks during Timesheet';

  AddEmployeeToAllTasks='Add Employees to All Tasks';
  AddEmployeesToTask ='Add Employees to Task';

  DeleteTimedTask ='Delete Task';
  ModifyTimedTask = 'Modify Task';
  DuplicateTimedTask = 'Duplicate Task';
  DoYouReallyWantToDeleteAllUnapprovedTheWorkshift='Do you really want to delete ALL the unapproved timesheet?';
  DoYouWantToDeleteThisReport = 'Do you want to delete this report?';
  GPSInformation = 'GPS Information';
  ChatRooms = 'Conversations';
  ChannelIsReadOnly ='This conversation is read only.';
  CantLeaveChannel ='You can\'t leave this conversation.';
  DeactivateEnterprise='Deactivate Enterprise';
  DoYouReallyWantToDeactivateThisEnterprise='Do you really want to deactivate this enterprise?';
  DoYouReallyWantToRemoveAllUnitWithNoEmployeesAndNoUsersAndNoChildren='Do you really want to remove all Units with no Employees no Users and no Sub-Units ?';


  UseBulletinBoardChannel='Use Bulletin Board (Read Only Public - Admins can write)'
  BulletinBoardChannelName ='Bulletin Board Name';

  UseDiscussionBoardChannel='Use Discussion Board (Read/Write Public )';
  DiscussionBoardChannelName ='Discussion Board Name';
  ApplyTimesheetParamsToEmployeeOfEnterprise='Apply Parameters';
  RetrieveConfigurationFromSage='Retrieve Configuration from Sage-Intacct';
  ThisProjectHasAlreadyBeanImportedFromSage='This project \'{{name}}\' has already been imported. Emprez will update the information it has and will try to add the missing tasks and resources. It will not remove tasks or ressources already imported. Do you want to continue?';
  DoYouWantToRefuseTheOtherRequests='Do you want to refuse the other requests?';
  ChooseAPremium= 'Choose a Premium';
  Premiums='Premiums';
  YouCantHaveMoreThan20Premiums='You can\'t have more than 20 premiums.';
  PreviousPeriods='Previous Periods';
  NextPeriods='Next Periods';

  FamilyDays='<b>Family Days</b>: <span class="muted">{{paidUsedDays}}/{{paidDays}} paid, {{unpaidUsedDays}}/{{unpaidDays}} unpaid</span>';
  FamilyDaysWithDates='<b>Family Days (from {{start}} to {{end}})</b>: <span class="muted">{{paidUsedDays}}/{{paidDays}} paid, {{unpaidUsedDays}}/{{unpaidDays}} unpaid</span>';
  SickDaysDisplayFormat='<b>Sick Days (HH:MM)</b>: <span class="muted">{{usedSickDays}}/{{sickDaysLeft}} used / left</span>';


  SickDaysBalance='<b>Sick Days</b>: <span class="muted">{{sickDaysLeft}}</span>';

  FamilyDaysBalanceNoDates='<b>Family Days</b>: <span class="muted">{{paidDaysLeft}} paid left, {{unpaidDaysLeft}} unpaid left</span>';
  FamilyDaysBalanceWithDates='<b>Family Days</b><span style="font-size: x-small">(from {{start}} to {{end}})</span>: <span class="muted">{{paidDaysLeft}} paid left, {{unpaidDaysLeft}} unpaid left</span>';
  NoFamilyDaysAvailable='No Family Days';


  BalanceIs='<span class="muted">&nbsp;Balance: {{balance}} </span>';
  DurationInHoursMinutes='Duration (HH:MM)';
  SelectEmployees='Select Employees';
  UseUnitsOrEnterpriseToSelectEmployeesToModify='Please choose units and/or enterprises to select the employees to modify.';

  ModifyEmployeePunchParamsInBatch='Modify Employee Punch Parameters';
  ModifyEmployeePortalParamsInBatch='Modify Employee Portal Parameters';
  ModifyEmployeeScheduleParamsInBatch='Modify Employee Request Parameters';
  ModifyEmployeeTimesheetParamsInBatch='Modify Employee Timesheet Parameters';

  ApplyStatutoryHolidays='Apply the configuration for the Statutory Holidays';
  EmployeePosition='Position';

  DefaultSorting='Default Sort';
  EmployeeTaskDescriptionStartDate_Sorting='By Employee,Task and Start Date';
  StartDateEmployeeTaskDescription_Sorting='By Start Date, Employee and Task';
  StartDateTaskDescriptionEmployee_Sorting='By Start Date, Task and Employee';
  SelectedTasks='{{nb}} task(s)';
  SelectTask = 'Filter per Task';
  SelectedEmployees='{{nb}} employee(s)';
  FilterEmployee='Filter per Employee';
  NewHRConfiguration='New HR Configuration';
  NoHRConfigurationFound='No HR Configuration';
  HRConfigurations = 'HR Configurations';
  NoUserAccess='No User has Access';
  NoParameters = 'No Parameters';
  DeleteHRConfiguration='Delete HR Configuration';
  DoYouReallyWantToRemoveThisConfiguration ='Do you really want to delete the configuration \'{{name}}\'? It can\'t be undone.';
  HRConfiguration ='HR Configuration';
  EditAccessRights='Modify Access Rights';
  EditRightsForMoreInformation = 'Custom Rights';
  FullAccess = 'Full Access';
  DisplayOrder='Display Order';

  DocumentCenter = 'HR Center';


  SelectedExpenseTypes='{{nb}} Type(s)';
  SelectExpenseType='Filter per Type';
  NoExpenseTypeFound='No Type Found';
  SORT_BY_EMPLOYEE_BY_DATE='By Employee and Date';
  SORT_BY_DATE_BY_EMPLOYEE='By Date and Employee';
  DlgChooseCustomCodesTitle='Selection';
  SelectedTypes='Filter per Type';
  SelectType='{{nb}} Type(s)';
  NoTypesFound='No Type Found';
  SelectedApprover = 'Filter per Approver';
  SelectApprover='{{nb}} Approver(s)';
  NoApprouverFound = 'No Approver Found';

  SelectedConsequences='Filter per Consequence';
  SelectConsequence='{{nb}} Consequence(s)';
  NoConsequencesFound='No Consequence Found';


  HR_PARAM_TYPE_CATEGORY = 'Category';
  HR_PARAM_TYPE_CONSEQUENCE = 'Consequence';
  HR_PARAM_TYPE_GRIEVANCE_TYPE = 'Grievance Type';
  HR_PARAM_TYPE_CERTIFICATE_CATEGORY = 'Certificate Category';
  HR_PARAM_TYPE_TRAINING_ORGANISATION='Training Organisation';
  HR_PARAM_TYPE_SECURITY = 'Security';
  HR_PARAM_TYPE_SECTION = 'Section';

  CurrentListOfParameters='Current List';
  CreateNewConsequence='Add New';
  AddDisciplineFiles = 'Add Files';
  DownloadFiles='Download Attachments';
  DoYouReallyWantToDeleteThisFile='Do you really want to delete this file?';
  GRIEVANCE_STATUS_TYPE_ACCEPTED='Accepted';
  GRIEVANCE_STATUS_TYPE_REFUSED = 'Refused';

  SelectedTypeOfEvents='{{nb}} Event Type(s)';
  SelectTypeOfEvent='Filter per Event Type';
  NoTypeOfEventFound='No Event Type Found';
  GrievanceName='Name (Ref,...)';
  ParentGrievance= 'Parent Grievance';
  ChooseGrievance='Choose Grievance';
  DateRef='Ref. Date';
  TypeOfEvent='Event Type';
  CreateNewType='Create a new Event Type';
  Actors='Actors';
  GoingToCourtOfJustice='Court of Justice'
  LegalCosts='Legal Costs';
  OtherCosts='Other Costs';
  ResolutionDt='Resolution Date';
  GrievanceStatusType='Status'
  AddGrievanceFiles='Add Files';
  AddFiles='Add Files';
  DropPunchToImport='Drop the file to import';
  ImportGroupCarburPunchXLS='Import arrivals & departures - Groupe-Carbur'


  VALIDITY_UNIT_TYPE_DAYS='Days';
  VALIDITY_UNIT_TYPE_MONTHS='Months';
  VALIDITY_UNIT_TYPE_YEARS='Years';

  Certificat='Certificate';
  EmployeeCertificates='Employee\'s Certifications';
  EmployeeCertificate='Employee\'s Certification';
  ValidityValue='Validity';
  ValidityUnit='Validity Unit';
  NbOfHoursToCompleteCertificate='How many hours to complete';
  RequiredCertificates='Required Certificates';

  ChooseCertificat='Select a Certificate';
  CreateNewCategory='Create a new Category';

  SelectedCategories='{{nb}} Categories';
  SelectCategory='Filter per Category';
  NoCategoryFound='No Category Found';
  CategoryName='Category Name';
  NoCertificatesToChooseFromYouNeedToCreateSome = 'You don\'t have any certificates yet.';

  NbOfHoursToComplete='Duration to complete';
  SelectedCertificates='{{nb}} Certificates';
  SelectCertificate='Filter per Certificate';
  NoCertificateFound='No Certificate Found';
  AddEmployeeCertificateFiles='Add Files';
  ReceivedOnDt='Received on';
  AlwaysValid='Always Valid';
  ValidTillDt='Valid till';

  DoYouReallyWantToRemoveThisEmployeeFromTheTrainingProgram='Do you really want to remove this employee from the Education Program?';

  FromDt='From';
  ToDt='To';
  TrainingProgram = 'Education Program';
  TrainingPrograms = 'Education Programs';
  NbOfHours='Education Duration in Hours';
  TrainingProgramDurationInDays = 'The Education Program will take {{duration}} day(s)';
  TrainingProgramType='Education Type';
  TRAINING_PROGRAM_TYPE_INTERNAL='Internal';
  TRAINING_PROGRAM_TYPE_EXTERNAL='External';
  Trainer = 'Trainer';
  TrainingCost='Costs ($)';
  PerDiemTrainerCost='Costs ($ Per Diem)';
  PerDiemEmployeeCost ='Costs ($ Per Diem)';
  TrainingOrganisationCost = 'Costs ($)';
  TrainingOrganisation='Training Organisation';
  CreateNewTrainingOrganisation='Create new Organisation'
  EligibleToGovernmentProgram='Eligible - Law 90';

  SORT_BY_DATE_BY_CERTIFICAT='Sort by Date and Certificate';
  SORT_BY_CERTIFICAT_BY_DATE='Sort by Certificate and Date';

  SelectedTrainers='{{nb}} Trainers';
  SelectTrainer = 'Filter by Trainer';
  NoTrainerFound = 'No Trainer Found';

  EmployeeTrainingProgram='Education Program - Employee'

  EmployeeCost='Cost';
  OtherEmployeeCost='Other Costs';
  EmployeeTrainingProgramResultType='Employee\'s Status';

  EMPLOYEE_TRAINING_PROGRAM_RESULT_TYPE_NOT_COMPLETED = 'Not Completed';
  EMPLOYEE_TRAINING_PROGRAM_RESULT_TYPE_COMPLETED_WITH_SUCCESS = 'Success';
  EMPLOYEE_TRAINING_PROGRAM_RESULT_TYPE_COMPLETED_WITH_FAILURE = 'Fail';
  EmployeeThatWillFollowThisTrainingProgram = 'Employees enrolled in this Education Program';
  TsType='Type';
  ApprovedBy='Approved by';
  ApprovedOn='Approved on';
  RemoveAll='Remove ALL';

  SelectedEvaluations='{{nb}} Evaluation(s)';
  SelectEvaluation='Filter by Evaluation';
  NoEvaluationFound='No Evaluation Found';
  SelectTheDueDateForTheEvaluation='Select the due date of the evaluation';
  ApplyToEmployee='Associate Employees';

  LearningCenter='Learning Center'
  PerformanceCenter ='Performance Center';


  HRPerformanceTemplates='Performances (Templates)';
  EmployeePerformances='Employee\'s Performances';

  EmployeeAbilities = 'Employee\'s Abilities';
  Abilities='Abilities'

  SelectedAbilities='{{nb}} Abilit(ies)';
  SelectAbility='Filter by Ability';
  NoAbilityFound='No Ability Found';
  NoAbilityToChooseFromYouNeedToCreateSome='Please, start by creating new abilities.';
  EmployeeAbility='Employee\'s Ability'
  Ability='Ability'
  WeightForReview='Weight for Review'
  AbilityLevel='Ability Level'
  CreateNewAbility='Create new Ability';
  CurrentListOfAbilities='Abilities Library';
  LabelForEmployeeAbilityWithWeightAndLevel='{{title}} - lvl: {{level}}, wght: {{weight}}';
  AutoReviewByEmployee='Auto Review by Employee';
  AddManagerAsReviewer='Add Managers as Reviewers';

  IncludeKRAInReview='Include KRA in Review';
  WeightForKRAInReview = 'Weight for KRA in Review';
  IncludeCompetencyInReview='Include Competencies in Review';
  WeightForCompetencyInReview = 'Weight for Competencies in Review';
  IncludeAbilityInReview='Include Abilities in Review';
  WeightForAbilityInReview = 'Weight for Abilities in Review';
  IncludeGoalInReview='Include Goals in Review';
  WeightForGoalInReview='Weight for Goals in Review';
  IncludeReview360InReview='Include Review 360s';
  WeightForReview360InReview='Weight for Review 360s';

  HRPerformanceTemplate='Performance Review (Template)';

  DueDt='Due Date'
  PeriodStartDt='Start Review Period';
  PeriodEndDt = 'End Review Period';
  EmployeePerformance = 'Employee\'s Performance';
  EMPLOYEE_PERFORMANCE_STATUS_TO_BE_COMPLETED='To be completed';
  EMPLOYEE_PERFORMANCE_STATUS_COMPLETED='Completed';

  SelectedPerformanceTitles='{{nb}} Performance(s)';
  SelectPerformanceTitle='Filter by Performance';
  NoPerformanceTitleFound='No Performance Found';
  EmployeeAbilityReviews='Employee Abilities Reviews';
  EmployeeAbilityReviewsTab='Abilities';
  PleaseReviewThisAbility='Rate the following ability: <b>{{name}}</b>';
  NoAbilityToRateForEmployee='No Abilities to rate have been found for this employee';
  EmployeeAbilityReview='Employee Ability Review';

  RatingAndNote='Rating & Note';
  SORT_BY_DATE_BY_TITLE_BY_EMPLOYEE='By Date, Title & Employee';
  SORT_BY_TITLE_BY_DATE_BY_EMPLOYEE='By Title, Date & Employee';

  LabelForEmployeeCompetencyWithWeightAndLevel='{{title}} - wght: {{weight}}';
  CreateNewCompetency = 'Create new Competency';
  SelectedCompetencies='{{nb}} Competencies';
  SelectCompetency = 'Filter by Competency';
  NoCompetencyFound = 'No Competency Found';
  EmployeeCompetencies = 'Employee\'s Competencies';
  EmployeeCompetency = 'Employee\'s Competency';
  CurrentListOfCompetencies='Competencies Library';
  PleaseReviewThisCompetency ='Rate the following competency: <b>{{name}}</b>';
  NoCompetencyToRateForEmployee='No Competencies to rate have been found for this employee';
  EmployeeCompetencyReviews='Employee Competencies Reviews';
  EmployeeCompetencyReviewsTab='Competencies';

  LabelForEmployeeKRAWithWeightAndLevel='{{title}} - wght: {{weight}}';
  CreateNewKRA = "Create new KRA";
  SelectedKRAs='{{nb}} KRA(s)';
  SelectKRA = 'Filter by KRA';
  NoKRAFound = 'No KRA Found';


  EmployeeKRAs = 'Employee\'s KRAs';
  EmployeeKRA = 'Employee\'s KRA';
  CurrentListOfKRAs='KRAs Library';
  PleaseReviewThisKRA   ='Rate the following KRA: <b>{{name}}</b>';
  NoKRAToRateForEmployee='No KRAs to rate have been found for this employee';
  EmployeeKRAReviews='Employee KRAs Reviews';
  EmployeeKRAReviewsTab='KRAs';

  PRIORITY_TYPE_LOW='Low Priority';
  PRIORITY_TYPE_MEDIUM='Medium Priority';
  PRIORITY_TYPE_HIGH='High Priority';

  SelectedGoals='{{nb}} Goal(s)';
  SelectGoal='Filter by Goal';
  NoGoalFound = 'No Goal Found';
  LabelForEmployeeGoalWithWeightAndLevel = '{{title}} - wght: {{weight}}, {{priority}} ';
  EmployeeGoals='Employee\'s Goals';
  EmployeeGoal = 'Employee\'s Goal';
  Goals='Goals';

  NoGoalToRateForEmployee='No Goals to rate have been found for this employee';
  EmployeeGoalReviews='Employee\'s Goals Reviews';
  EmployeeGoalReviewsTab='Goals Reviews';
  EmployeeReview360s='Employee\'s 360 Review';
  EmployeeReview360sTab='Review 360';
  ActiveInactiveTerminatedEmployees = '{{nbActive}} actives, <span class=\"emprez-orange-fiesta\">{{nbInactive}} inactives</span>,  <span class=\"emprez-rouge-matador\">{{nbTerminated}} terminated</span>';
  ReminderDt = 'Reminder Date';
  TooManyHoursPerDay='Too many hours per day (>8h)';
  RenewalDt = 'Renewal Date';
  TrainingCostReport='Training Cost Report';

  SelectedJobs='{{nb}} Job(s)';
  FilterByJob = 'Filter by Job';
  NoJobFound = 'No Job Found';
  SearchEmployee = 'Search Employee';
  SearchEmployeePlaceholder = 'By Lastname, Firstname or #EmployeeId';
  LoadEmployees='Load Employees';
  CompletedDate='Completed on';
  DateRange='Range';
  ChooseDateRange='Choose Range';

  SelectedGoalKPIs='{{nb}} Goal KPI(s)';
  SelectGoalKPI='Filter by Goal KPI';
  NoGoalKPIFound='No Goal KPI Found';

  GoalKPI = 'Goal KPI';

  GoalKPIs = 'Goal KPI';
  KRAs = 'KRA';
  AssociatedKRAs = 'Linked KRAs (Optional)';
  AssociatedGoals='Linked Goals (Optional)';
  AddNew='Add New';
  ChooseKRAs='Choose';
  ChooseKRADescription='Choose one or several KRAs';
  KRA='KRA'
  CreateNewGoal='Create New Goal';
  UnitKRAs='Employees working in these units will be automatically associated with this KRA (Optional)';
  ChooseGoals='Choose'
  ChooseGoalDescription='Choose one or more Goals';

  SelectedManagers='{{nb}} Manager(s)';
  SelectManager='Filter by Manager';
  NoManagerFound='No Manager Found';
  EmployeeManagers='Employee\'s Managers';
  FinalAssessmentForTheReview='Final Assessment';

  SORT_BY_TITLE = 'Sort by Title';
  SORT_BY_DESCRIPION = 'Sort by Description';
  HRCareerAggregation = 'Career Path';
  HRCareerAggregations = 'Career Paths';
  EmployeeCareer='Employee\'s Career Path';
  EmployeeCareers='Employee\'s Career Paths';
  HRCareer = 'Career Path';
  HRCareerDetail = 'Career Step';
  HRCareerDetails = 'Career Steps';

  SelectedCareers='{{nb}} Career Paths';
  SelectCareer='Sort by Career Path';
  NoCareerFound='No Career Path Found';
  CreateNewCareer='Create a new Career Path';

  CAREER_DETAIL_TYPE_TRAINING = 'Training';
  CAREER_DETAIL_TYPE_COACHING = 'Coaching';
  CAREER_DETAIL_TYPE_SPECIAL_PROJECT = 'Special Project';
  CAREER_DETAIL_TYPE_OTHER = 'Other';

  CAREER_STATUS_TYPE_OPEN='Open';
  CAREER_STATUS_TYPE_IN_PROGRESS='In progress';
  CAREER_STATUS_TYPE_CANCELLED='Cancelled';
  CAREER_STATUS_TYPE_COMPLETED='Completed';

  NoRecognitionFound='No Recognition Found';
  EmployeeRecognitions='Employee\'s Recognitions';
  EmployeeRecognition='Employee\'s Recognition';

  RECOGNITION_TYPE_INFORMAL_THANK_YOU='Informal Thank You';
  RECOGNITION_TYPE_FORMAL_RECOGNITION='Formal Recognition';
  RECOGNITION_TYPE_SPECIAL_BONUS='Special Bonus';
  RECOGNITION_TYPE_WAGE_INCREASE='Wage Increase';

  RECOGNITION_SOURCE_TYPE_MANAGER='Manager';
  RECOGNITION_SOURCE_TYPE_COLLEAGUE='Colleague';
  RECOGNITION_SOURCE_TYPE_UPPER_MANAGEMENT='Upper Management';
  EmployeePerformanceReviewers='Reviewers';
  NotCompletedByReviewerYet='Not Completed';
  CompletedByReviewer='Completed';
  AddEmployeeToAutoEvaluate='Add Employee to Auto-Review';
  AutoEvaluationByTheEmployee='Auto-Review';
  StartEvaluationPerformance='Evaluate';

  PerformancesConfiguration='Configuration';
  PerformancesEmployeeConfiguration='Employee\'s Configuration'
  PerformancesEvaluations='Evaluations';
  HRSurveys='HR Surveys';
  EmployeeHRSurveys='Employee\'s HR Surveys';

  CertificatesAndCareerPaths='Certificates & Career Paths';
  EmployeesCertificatesAndCareerPaths='Employee\'s Education';
  EmployeeTrainingPrograms='Employee\'s Education Programs';

  EmployeeDocumentsAndNotes='Employee\'s Documents & Notes';
  EmployeeFinancials='Employee\'s Financials';
  EmployeeExceptions='Employee\'s Exceptions';

  EmployeePerformancesToComplete='Performances to complete';
  EmployeePerformancesToReview='Performances to review';
  AverageGrade='Average Grade';

  AccessByUsers = 'Users Access';
  AccessRights = 'Access Rights';

  ChooseUnits='Choose Units';
  ChooseUnitDescription='Description';
  RecognitionType='Type'
  RecognitionSource='Source';

  ListReportsByEmail='Reports by Emails';
  DlgWebPayRequest='Pay Parameters';
  DisplayAmount='Display amounts';

  NoEmployeeToSelect='No Employee to Select';
  DuplicateTimedTaskGroup='Duplicate Project';

  DoYouWantToDuplicateTheEmployeesOnTheTask='The project and its tasks will be duplicated, do you want to associate the employees with the copied tasks?';
  Duplicate='Copy';


  EnterpriseVacationsAreInHoursMinutesDescription='WARNING: Any vacations bank already created for the employees paid by this enterprise WILL need to be verified and probably modified. Changing this option will be logged and under the responsibility of the user.'
  PayParametersModificationWarning='WARNING: Changing the pay period has consequences for past and future payroll. Approved TS might be unpaid or paid twice. Changing this option will be logged and under the responsibility of the user.'
  EnterpriseLogs='Enteprise Logs';
  ShowLogs='Show Logs';
  NoLogs='No Logs';
  VACATIONS_IN_MINUTES='Vacations in Minutes';
  PAY_PERIOD_REF='Pay Period'
  ImportSchedulesFromOnTrack='Import Schedules from OnTrack';
  ImportSchedulesOnTrack='Import Schedules from OnTrack';
  ActivityDateForPlanning='Optional - Planning is active between';
  CopyOf='Copy of ';
  DisplayActiveTheseHours='Filter by Hour';
  DoYouReallyWantToDeleteThisTimedTask='Do you really want to delete this task \'{{description}}\'?';
  MINUTE_REMOVAL_TYPE_AT_THE_END='At the End';
  MINUTE_REMOVAL_TYPE_AT_THE_BEGINNING='At the Beginning';
  HowToRemoveMinutes='How to remove minutes?';
  MinutesToRemove='Minutes to remove';

  CumulativeExportCode=   'Payroll Code';
  CumulativeName=  'Name (Reporting)';
  CumulativeCondition='When the total hours';
  CumulativeConditionAmount='HH:mm';
  MemoStatistics = '{{nbReadPercent}}% of messages are read.';
  MemoStatisticsTitle='Message Statistics';
  DoYouWantToDeleteThisMemo='Do you really want to delete this message \'{{title}}\'?';
  MemoNotReadYet='Not read yet by {{recipients}}.';
  MemoNotAcknowledgedYet ='Not acknowledged yet by {{recipients}}.';

  SendReminder='Send a Reminder';
  ReminderToReadTitle = 'Reminder for the message \'{{title}}\' from {{from}}';
  ReminderToReadBody='Hello,<br>This is a friendly reminder to let you know that on {{created}} you have received a memo titled \'{{title}}\' from {{from}} requiring your attention.<br>Thank you.';


}

